webpackJsonp([14],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	// AUTO GENERATED BY: build/XT5-webpack/entry-loader.js
	__webpack_require__.p = window.__webpack_public_path__;
	__webpack_require__(66)(function () { __webpack_require__(492); });


/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 处理组件的模板渲染
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	    var $ = __webpack_require__(1);
	    var Handlebars = __webpack_require__(14);
	
	    var compiledTemplates = {};
	
	    // 提供 Template 模板支持，默认引擎是 Handlebars
	    var exports = {
	
	        // Handlebars 的 helpers
	        templateHelpers: null,
	
	        // Handlebars 的 partials
	        templatePartials: null,
	
	        // template 对应的 DOM-like object
	        templateObject: null,
	
	        // 根据配置的模板和传入的数据，构建 this.element 和 templateElement
	        parseElementFromTemplate: function () {
	            // template 支持 id 选择器
	            var t, template = this.get('template');
	            if (/^#/.test(template) && (t = document.getElementById(template.substring(1)))) {
	                template = t.innerHTML;
	                this.set('template', template);
	            }
	            this.templateObject = convertTemplateToObject(template);
	            this.element = $(this.compile());
	        },
	
	        // 编译模板，混入数据，返回 html 结果
	        compile: function (template, model) {
	            template || (template = this.get('template'));
	
	            model || (model = this.get('model')) || (model = {});
	            if (model.toJSON) {
	                model = model.toJSON();
	            }
	
	            // handlebars runtime，注意 partials 也需要预编译
	            if (isFunction(template)) {
	                return template(model, {
	                    helpers: this.templateHelpers,
	                    partials: precompile(this.templatePartials)
	                });
	            } else {
	                var helpers = this.templateHelpers;
	                var partials = this.templatePartials;
	                var helper, partial;
	
	                // 注册 helpers
	                if (helpers) {
	                    for (helper in helpers) {
	                        if (helpers.hasOwnProperty(helper)) {
	                            Handlebars.registerHelper(helper, helpers[helper]);
	                        }
	                    }
	                }
	                // 注册 partials
	                if (partials) {
	                    for (partial in partials) {
	                        if (partials.hasOwnProperty(partial)) {
	                            Handlebars.registerPartial(partial, partials[partial]);
	                        }
	                    }
	                }
	
	                var compiledTemplate = compiledTemplates[template];
	                if (!compiledTemplate) {
	                    compiledTemplate = compiledTemplates[template] = Handlebars.compile(template);
	                }
	
	                // 生成 html
	                var html = compiledTemplate(model);
	
	                // 卸载 helpers
	                if (helpers) {
	                    for (helper in helpers) {
	                        if (helpers.hasOwnProperty(helper)) {
	                            delete Handlebars.helpers[helper];
	                        }
	                    }
	                }
	                // 卸载 partials
	                if (partials) {
	                    for (partial in partials) {
	                        if (partials.hasOwnProperty(partial)) {
	                            delete Handlebars.partials[partial];
	                        }
	                    }
	                }
	                return html;
	            }
	        },
	
	        // 刷新 selector 指定的局部区域
	        renderPartial: function (selector) {
	            if (this.templateObject) {
	                var template = convertObjectToTemplate(this.templateObject, selector);
	
	                if (template) {
	                    if (selector) {
	                        this.$(selector).html(this.compile(template));
	                    } else {
	                        this.element.html(this.compile(template));
	                    }
	                } else {
	                    this.element.html(this.compile());
	                }
	            } else { // 如果 template 已经编译过了，templateObject 不存在
	                var all = $(this.compile());
	                var selected = all.find(selector);
	                if (selected.length) {
	                    this.$(selector).html(selected.html());
	                } else {
	                    this.element.html(all.html());
	                }
	            }
	
	            return this;
	        },
	
	        // 公开Handlerbars 的escape 方法
	        escapeExpression: function (string) {
	            return Handlebars.escapeExpression(string);
	        }
	    };
	
	
	    // Helpers
	    // -------
	    var _compile = Handlebars.compile;
	
	    Handlebars.compile = function (template) {
	        return isFunction(template) ? template : _compile.call(Handlebars, template);
	    };
	
	    // 将 template 字符串转换成对应的 DOM-like object
	    function convertTemplateToObject(template) {
	        return isFunction(template) ? null : $(encode(template));
	    }
	
	    // 根据 selector 得到 DOM-like template object，并转换为 template 字符串
	    function convertObjectToTemplate(templateObject, selector) {
	        if (!templateObject) return;
	
	        var element;
	        if (selector) {
	            element = templateObject.find(selector);
	            if (element.length === 0) {
	                throw new Error('Invalid template selector: ' + selector);
	            }
	        } else {
	            element = templateObject;
	        }
	        return decode(element.html());
	    }
	
	    function encode(template) {
	        return template
	            // 替换 {{xxx}} 为 <!-- {{xxx}} -->
	            .replace(/({{[^}]+}})/g, '<!--$1-->')
	            // 替换 src="{{xxx}}" 为 data-TEMPLATABLE-src="{{xxx}}"
	            .replace(/\s(src|href)\s*=\s*(['"])(.*?\{.+?)\2/g, ' data-templatable-$1=$2$3$2');
	    }
	
	    function decode(template) {
	        return template.replace(/(?:<|&lt;)!--({{[^}]+}})--(?:>|&gt;)/g, '$1').replace(/data-templatable-/ig, '');
	    }
	
	    function isFunction(obj) {
	        return typeof obj === "function";
	    }
	
	    function precompile(partials) {
	        if (!partials) return {};
	
	        var result = {};
	        for (var name in partials) {
	            var partial = partials[name];
	            result[name] = isFunction(partial) ? partial : Handlebars.compile(partial);
	        }
	        return result;
	    }
	
	    return exports;
	
	    // 调用 renderPartial 时，Templatable 对模板有一个约束：
	    // ** template 自身必须是有效的 html 代码片段**，比如
	    //   1. 代码闭合
	    //   2. 嵌套符合规范
	    //
	    // 总之，要保证在 template 里，将 `{{...}}` 转换成注释后，直接 innerHTML 插入到
	    // DOM 中，浏览器不会自动增加一些东西。比如：
	    //
	    // tbody 里没有 tr：
	    //  `<table><tbody>{{#each items}}<td>{{this}}</td>{{/each}}</tbody></table>`
	    //
	    // 标签不闭合：
	    //  `<div><span>{{name}}</div>`
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	


/***/ },

/***/ 12:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	    var $ = __webpack_require__(1);
	    var Dialog = __webpack_require__(80);
	    var Dnd = __webpack_require__(83);
	
	    var template = '{{#if title}}'
	                    + '<div class="{{classPrefix}}-title" data-role="title">{{{title}}}</div>'
	                    + '{{/if}}'
	                    + '<div class="{{classPrefix}}-content" data-role="content">'
	                        + '<div class="{{classPrefix}}-message" data-role="message">{{{message}}}</div>'
	                    + '</div>'
	                    + '{{#if hasFoot}}'
	                    + '<div class="{{classPrefix}}-operation" data-role="foot">'
	                        + '<div class="{{classPrefix}}-btns">'
	                            + '{{#if confirmTpl}}'
	                            + '<button type="button" class="u-btn u-btn-primary" data-role="confirm">'
	                                +'{{{confirmTpl}}}'
	                            + '</button>'
	                            + '{{/if}}'
	                            + '{{#if uncertainTpl}}'
	                            + '<button type="button" class="u-btn u-btn-primary" data-role="uncertain">'
	                                + '{{{uncertainTpl}}}'
	                            + '</button>'
	                            + '{{/if}}'
	                            + '{{#if cancelTpl}}'
	                            + '<button type="button" class="u-btn u-btn-default" data-role="cancel">'
	                                + '{{{cancelTpl}}}'
	                            + '</button>'
	                            + '{{/if}}'
	                        + '</div>'
	                    + '</div>'
	                    + '{{/if}}';
	
	    var ConfirmBox = Dialog.extend({
	
	        attrs: {
	            title: '默认标题',
	
	            confirmTpl: '确定',
	
	            uncertainTpl: '',       // '不确定'，默认不呈现
	
	            cancelTpl: '取消',
	
	            message: '默认内容',
	
	            // 是否允许拖放
	            // 该项只能应用于弹窗的title区域
	            dnd: true,
	
	            effect: 'fade'
	        },
	
	        setup: function () {
	            ConfirmBox.superclass.setup.call(this);
	
	            var model = {
	                classPrefix: this.get('classPrefix'),
	                message: this.get('message'),
	                title: this.get('title'),
	                confirmTpl: this.get('confirmTpl'),
	                uncertainTpl: this.get('uncertainTpl'),
	                cancelTpl: this.get('cancelTpl'),
	                hasFoot: this.get('confirmTpl') || this.get('cancelTpl')
	            };
	
	            this.set('content', this.compile(template, model));
	
	            this.after('render', function() {
	                if (this.get('dnd') && this.get('title')) {
	                    this.dnd = new Dnd({
	                        element: this.element,
	                        handle: this.$('[data-role=title]')
	                    });
	                }
	            })
	        },
	
	        destroy: function() {
	            this.dnd && this.dnd.destroy();
	            ConfirmBox.superclass.destroy.call(this);
	        },
	
	        _setPosition: function () {
	            // 高度超过窗口的 42/50, 采用纵向轴滚动
	            var $content = this.contentElement;
	            if (this.element.height() > $(window).height() * 0.84) {
	                $content.find('[data-role=content]').css({
	                    maxHeight: $(window).height() - $content.find('[data-role=title]').outerHeight() - $content.find('[data-role=foot]').outerHeight(),
	                    overflowY: 'scroll'
	                });
	            } else {
	                $content.find('[data-role=content]').css({
	                    maxHeight: 9999,
	                    overflowY: 'visible'
	                });
	            }
	
	            Dialog.superclass._setPosition.call(this);
	        },
	
	        events: {
	            'click [data-role=confirm]': function (e) {
	                e.preventDefault();
	                this.trigger('confirm');
	            },
	            'click [data-role=uncertain]': function (e) {
	                e.preventDefault();
	                this.trigger('uncertain');
	            },
	            'click [data-role=cancel]': function (e) {
	                e.preventDefault();
	                this.trigger('cancel');
	                this.hide();
	            },
	            'click [data-role=close]': function (e) {
	                e.preventDefault();
	                this.trigger('cancel');
	                this.hide();
	                ConfirmBox.superclass.hide.call(this);
	            }
	        },
	
	        _onChangeMessage: function (val) {
	            this.$('[data-role=message]').html(val);
	        },
	
	        _onChangeTitle: function (val) {
	            this.$('[data-role=title]').html(val);
	        },
	
	        _onChangeConfirmTpl: function (val) {
	            this.$('[data-role=confirm]').html(val);
	        },
	
	        _onChangeUncerainTpl: function(val) {
	            this.$('[data-role=uncertain]').html(val);
	        },
	
	        _onChangeCancelTpl: function (val) {
	            var $cancel = this.$('[data-role=cancel]');
	
	            if (!val) {
	                $cancel.html('').hide();
	            } else {
	                $cancel.html(val).show();
	            }
	        }
	
	    });
	
	    ConfirmBox.alert = function (message, callback, options) {
	        var defaults = {
	            message: message,
	            title: '',
	            cancelTpl: '',
	            closeTpl: '',
	            onConfirm: function () {
	                callback && callback();
	                this.hide();
	            }
	        };
	        addShowingConfirms('alert');
	        new ConfirmBox($.extend(null, defaults, options)).show().after('hide', function () {
	            this.destroy();
	            deleteShowingConfirms('alert');
	        });
	    };
	
	    ConfirmBox.confirm = function (message, title, onConfirm, onCancel, options) {
	        // support confirm(message, title, onConfirm, options)
	        if (typeof onCancel === 'object' && !options) {
	            options = onCancel;
	            onCancel = undefined;
	        }
	
	        var defaults = {
	            message: message,
	            title: title || '确认框',
	            closeTpl: '',
	            onConfirm: function () {
	                onConfirm && onConfirm();
	                this.hide();
	            },
	            onCancel: function () {
	                onCancel && onCancel();
	                this.hide();
	            }
	        };
	        addShowingConfirms('confirm');
	        new ConfirmBox($.extend(null, defaults, options)).show().after('hide', function () {
	            this.destroy();
	            deleteShowingConfirms('confirm');
	        });
	    };
	
	    ConfirmBox.show = function (message, callback, options) {
	        var defaults = {
	            message: message,
	            title: '',
	            confirmTpl: false,
	            cancelTpl: false
	        };
	        addShowingConfirms('show');
	        new ConfirmBox($.extend(null, defaults, options)).show().before('hide', function () {
	            callback && callback();
	        }).after('hide', function () {
	            this.destroy();
	            deleteShowingConfirms('show');
	        });
	    };
	
	    ConfirmBox.hasConfirmBox = function(type) {
	        return ConfirmBox[type] && ConfirmBox[type].count > 0;
	    };
	
	
	    // Helpers
	    function addShowingConfirms(type) {
	        var count = ConfirmBox[type].count || 0;
	        ConfirmBox[type].count = ++count;
	    }
	
	    function deleteShowingConfirms(type) {
	        var count = ConfirmBox[type].count || 0;
	        if (count) {
	            ConfirmBox[type].count = --count;
	        }
	    }
	
	    return ConfirmBox;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },

/***/ 20:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 基础浮层组件，提供浮层显示隐藏、窗口resize时重新定位、点击页面空白处浮层消失等功能，是所有浮层类组件的基类。
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	    var $ = __webpack_require__(1);
	    var Widget = __webpack_require__(30);
	    var Position = __webpack_require__(84);
	
	
	    // Helpers
	    // -------
	
	    function isInDocument(element) {
	        return $.contains(document.documentElement, element);
	    }
	
	    function hideBlurOverlays(e) {
	        $(Overlay.blurOverlays).each(function (index, item) {
	            // 当实例为空或隐藏时，不处理
	            if (!item || !item.get('visible')) {
	                return;
	            }
	
	            // 遍历 _relativeElements ，当点击的元素落在这些元素上时，不处理
	            for (var i = 0; i < item._relativeElements.length; i++) {
	                var el = $(item._relativeElements[i])[0];
	                if (el === e.target || $.contains(el, e.target)) {
	                    return;
	                }
	            }
	
	            // 到这里，判断触发了元素的 blur 事件，隐藏元素
	            item.hide();
	        });
	    }
	
	    // 从数组中删除对应元素
	    function erase(target, array) {
	        for (var i = 0; i < array.length; i++) {
	            if (target === array[i]) {
	                array.splice(i, 1);
	                return array;
	            }
	        }
	    }
	
	
	    // Overlay definition
	    // ------------------
	
	    var Overlay = Widget.extend({
	
	        attrs: {
	            // 基本属性
	            width: null,
	            height: null,
	            zIndex: 99,
	            visible: false,
	
	            // 定位配置
	            align: {
	                // element 的定位点，默认为左上角
	                selfXY: [0, 0],
	                // 基准定位元素，默认为当前可视区域
	                baseElement: Position.VIEWPORT,
	                // 基准定位元素的定位点，默认为左上角
	                baseXY: [0, 0]
	            },
	
	            // 父元素
	            parentNode: document.body
	        },
	
	        show: function () {
	            // 若从未渲染，则调用 render
	            if (!this.rendered) {
	                this.render();
	            }
	            this.set('visible', true);
	            return this;
	        },
	
	        hide: function () {
	            this.set('visible', false);
	            return this;
	        },
	
	        setup: function () {
	            var that = this;
	            // 窗口resize时，重新定位浮层
	            this._setupResize();
	
	            this.after('render', function () {
	                var _pos = this.element.css('position');
	                if (_pos === 'static' || _pos === 'relative') {
	                    this.element.css({
	                        position: 'absolute',
	                        left: '-9999px',
	                        top: '-9999px'
	                    });
	                }
	            });
	            // 统一在显示之后重新设定位置
	            this.after('show', function () {
	                setTimeout(function () {
	                    that._setPosition();
	                }, 50);
	            });
	        },
	
	        destroy: function () {
	            // 销毁两个静态数组中的实例
	            erase(this, Overlay.allOverlays);
	            erase(this, Overlay.blurOverlays);
	            return Overlay.superclass.destroy.call(this);
	        },
	
	        // 进行定位
	        _setPosition: function (align) {
	            // 不在文档流中，定位无效
	            if (!isInDocument(this.element[0])) return;
	
	            align || (align = this.get('align'));
	
	            // 如果align为空，表示不需要使用js对齐
	            if (!align) return;
	
	            var isHidden = this.element.css('display') === 'none';
	
	            // 在定位时，为避免元素高度不定，先显示出来
	            if (isHidden) {
	                this.element.css({
	                    visibility: 'hidden',
	                    display: 'block'
	                });
	            }
	
	            Position.pin({
	                element: this.element,
	                x: align.selfXY[0],
	                y: align.selfXY[1]
	            }, {
	                element: align.baseElement,
	                x: align.baseXY[0],
	                y: align.baseXY[1]
	            });
	            // 定位完成后，还原
	            if (isHidden) {
	                this.element.css({
	                    visibility: '',
	                    display: 'none'
	                });
	            }
	
	            return this;
	        },
	
	        // resize窗口时重新定位浮层，用这个方法收集所有浮层实例
	        _setupResize: function () {
	            Overlay.allOverlays.push(this);
	        },
	
	        // 除了 element 和 relativeElements，点击 body 后都会隐藏 element
	        _blurHide: function (arr) {
	            arr = $.makeArray(arr);
	            arr.push(this.element);
	            this._relativeElements = arr;
	            Overlay.blurOverlays.push(this);
	        },
	
	        // 用于 set 属性后的界面更新
	        _onRenderWidth: function (val) {
	            this.element.css('width', val);
	        },
	
	        _onRenderHeight: function (val) {
	            this.element.css('height', val);
	        },
	
	        _onRenderZIndex: function (val) {
	            this.element.css('zIndex', val);
	        },
	
	        _onRenderAlign: function (val) {
	            this._setPosition(val);
	        },
	
	        _onRenderVisible: function (val) {
	            this.element[val ? 'show' : 'hide']();
	        }
	
	    });
	
	    // 绑定 blur 隐藏事件
	    Overlay.blurOverlays = [];
	    $(document).on('click', function (e) {
	        hideBlurOverlays(e);
	    });
	
	    // 绑定 resize 重新定位事件
	    var timeout;
	    var winWidth = $(window).width();
	    var winHeight = $(window).height();
	    Overlay.allOverlays = [];
	
	    $(window).resize(function () {
	        timeout && clearTimeout(timeout);
	        timeout = setTimeout(function () {
	            var winNewWidth = $(window).width();
	            var winNewHeight = $(window).height();
	
	            // IE678 莫名其妙触发 resize
	            // http://stackoverflow.com/questions/1852751/window-resize-event-firing-in-internet-explorer
	            if (winWidth !== winNewWidth || winHeight !== winNewHeight) {
	                $(Overlay.allOverlays).each(function (i, item) {
	                    // 当实例为空或隐藏时，不处理
	                    if (!item || !item.get('visible')) {
	                        return;
	                    }
	                    item._setPosition();
	                });
	            }
	
	            winWidth = winNewWidth;
	            winHeight = winNewHeight;
	        }, 80);
	    });
	
	    return Overlay;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 27:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 基础类，提供Class、Events、Attribute和Aspect支持
	 *
	 * @example
	 *
	 *      1、创建子类
	 *          var Pig = Base.extend({
	 *              attrs: {
	 *                  name: ''
	 *              },
	 *              talk: function() {
	 *                  alert(this.get('name'));
	 *              }
	 *          });
	 *
	 *     2、定义组件基类
	 *          var Widget = Base.extend({
	 *              initialize: function(config) {
	 *                  Widget.superclass.initialize.call(this, config);
	 *                  this.parseElement();
	 *                  this.initProps();
	 *                  this.delegateEvents();
	 *                  this.setup();
	 *              }
	 *          })
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var Class = __webpack_require__(28);
	    var Events = __webpack_require__(29);
	    var Aspect = __webpack_require__(78);
	    var Attribute = __webpack_require__(79);
	
	
	    module.exports = Class.create({
	        Implements: [Events, Aspect, Attribute],
	
	        initialize: function(config) {
	            this.initAttrs(config);
	
	            // Automatically register `this._onChangeAttr` method as
	            // a `change:attr` event handler.
	            parseEventsFromInstance(this, this.attrs);
	        },
	
	        destroy: function() {
	            this.off();
	
	            for (var p in this) {
	                if (this.hasOwnProperty(p)) {
	                    delete this[p];
	                }
	            }
	
	            // Destroy should be called only once, generate a fake destroy after called
	            // https://github.com/aralejs/widget/issues/50
	            this.destroy = function() {};
	        }
	    });
	
	    function parseEventsFromInstance(host, attrs) {
	        for (var attr in attrs) {
	            if (attrs.hasOwnProperty(attr)) {
	                var m = '_onChange' + ucfirst(attr);
	                if (host[m]) {
	                    host.on('change:' + attr, host[m]);
	                }
	            }
	        }
	    }
	
	    function ucfirst(str) {
	        return str.charAt(0).toUpperCase() + str.substring(1);
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 28:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 基础类，提供类的创建和继承
	 *
	 * @example
	 *
	 *      var Pig = Class.create({
	 *          // initialize方法在构造实例时调用
	 *          initialize: function(name) {
	 *              this.name = name;
	 *          },
	 *
	 *          talk: function() {
	 *              console.log('I am' + this.name);
	 *          }
	 *      });
	 *
	 *      var RedPig = Pig.extend({
	 *          initialize: function(name) {
	 *              // 调用父类的同名方法
	 *              RedPig.superclass.initialize.call(this, name);
	 *          },
	 *
	 *          color: 'red'
	 *      });
	 *
	 *      var props = {
	 *          fly: function() {
	 *              console.log('fly');
	 *          }
	 *      }
	 *
	 *      var FlyableRedPig = RedPig.extend({
	 *          // 将props的属性或者原型混入新的类中
	 *          Implements: props,
	 *
	 *          initialize: function(name) {
	 *              FlyableRedPig.superclass.initialize.call(this, name);
	 *          }
	 *      });
	 *
	 *
	 *      // 类已经存在，动态修改
	 *      FlyableRedPig.implements({
	 *          swim: function() {
	 *              console.log('swim');
	 *          }
	 *      })
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	    function Class(o) {
	        // 转换存在的函数为Class
	        if (!(this instanceof Class) && isFunction(o)) {
	            return classify(o);
	        }
	    }
	
	    // 创建类
	    //  var Pig = Class.create({
	    //      Extends: Animal,
	    //      Implements: Flyable,
	    //      initialize: function() {
	    //          Pig.superclass.initialize.apply(this, arguments);
	    //      },
	    //      Statics: {
	    //          COLOR: "red"
	    //      }
	    //  })
	    Class.create = function(parent, properties) {
	        if (!isFunction(parent)) {
	            properties = parent;
	            parent = null;
	        }
	
	        properties || (properties = {});
	        parent || (parent = properties.Extends || Class);
	        properties.Extends = parent;
	
	        // 创建类的构造函数
	        function SubClass() {
	            // 组合继承
	            // 继承parent的属性，但是这里SubClass仍然不能调用parent在原型定义的方法
	            // 需要在后面调用SubClass.prototype = new parent();
	            parent.apply(this, arguments);
	
	            // 调用自己的initialize函数
	            if (this.constructor === SubClass && this.initialize) {
	                this.initialize.apply(this, arguments);
	            }
	        }
	
	        // 添加父类属性
	        // 如果指定了数组StaticsWhiteList，则只添加StaticsWhiteList指定的属性
	        if (parent !== Class) {
	            mix(SubClass, parent, parent.StaticsWhiteList);
	        }
	
	        // 添加实例属性
	        implement.call(SubClass, properties);
	
	        // 让类为可继承的
	        return classify(SubClass);
	    };
	
	    function implement(properties) {
	        var key, value;
	
	        for (key in properties) {
	            value = properties[key];
	
	            if (Class.Mutators.hasOwnProperty(key)) {
	                Class.Mutators[key].call(this, value);
	            } else {
	                this.prototype[key] = value;
	            }
	        }
	    }
	
	    // 作用同Class.create
	    Class.extend = function(properties) {
	        properties || (properties = {});
	        properties.Extends = this;
	
	        return Class.create(properties);
	    };
	
	
	    function classify(cls) {
	        cls.extend = Class.extend;
	        cls.implement = implement;
	        return cls;
	    }
	
	
	    Class.Mutators = {
	        // 单个继承
	        'Extends': function(parent) {
	            var existed = this.prototype;
	            var proto = createProto(parent.prototype);
	
	            // 保存现有的属性
	            mix(proto, existed);
	
	            // 保持constructor指向
	            proto.constructor = this;
	
	            // 重要：原型继承
	            this.prototype = proto;
	
	            // 设置该属性用于访问父类原型方法
	            this.superclass = parent.prototype;
	        },
	
	        // 支持多个
	        // 将 items 各项的原型或者属性混合到类的原型中
	        'Implements': function(items) {
	            isArray(items) || (items = [items]);
	            var proto = this.prototype, item;
	
	            while (item = items.shift()) {
	                mix(proto, item.prototype || item);
	            }
	        },
	
	        'Statics': function(staticProperties) {
	            mix(this, staticProperties);
	        }
	    };
	
	
	    // Shared empty constructor function to aid in prototype-chain creation.
	    function Ctor() {
	    }
	
	    // See: http://jsperf.com/object-create-vs-new-ctor
	    var createProto = Object.__proto__ /* eslint no-proto: 0 */
	        ? function(proto) {
	            return { __proto__: proto };
	        }
	        : function(proto) {
	            Ctor.prototype = proto;
	            return new Ctor();
	        };
	
	
	    // Helpers
	    // ------------
	
	    function mix(r, s, wl) {
	        // Copy "all" properties including inherited ones.
	        for (var p in s) {
	            if (s.hasOwnProperty(p)) {
	                if (wl && indexOf(wl, p) === -1) continue;
	
	                // 在 iPhone 1 代等设备的 Safari 中，prototype 也会被枚举出来，需排除
	                if (p !== 'prototype') {
	                    r[p] = s[p];
	                }
	            }
	        }
	    }
	
	
	    var toString = Object.prototype.toString;
	
	    var isArray = Array.isArray || function(val) {
	        return toString.call(val) === '[object Array]';
	    };
	
	    var isFunction = function(val) {
	        return toString.call(val) === '[object Function]';
	    };
	
	    var indexOf = Array.prototype.indexOf ?
	        function(arr, item) {
	            return arr.indexOf(item);
	        } :
	        function(arr, item) {
	            for (var i = 0, len = arr.length; i < len; i++) {
	                if (arr[i] === item) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	
	
	    return Class;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 29:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 提供基本的事件绑定、解绑和触发
	 *
	 * @example
	 *
	 *      方式一：直接实例化
	 *          var object = new Events();
	 *          object.on('expand', function() {
	 *          });
	 *
	 *          object.trigger('expand');
	 *
	 *      方式二：混入到其他类中
	 *          function Dog() {}
	 *          Events.mixTo(Dog);
	 *
	 *          Dog.prototype.sleep = function() {
	 *              this.trigger('sleep');
	 *          }
	 *
	 *          var dog = new Dog();
	 *          dog.on("sleep", function() {
	 *          });
	 *          dog.sleep();
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    var eventSplitter = /\s+/;
	
	    var keys = Object.keys;
	    if (!keys) {
	        keys = function(o) {
	            var result = [];
	
	            for (var name in o) {
	                if (o.hasOwnProperty(name)) {
	                    result.push(name);
	                }
	            }
	            return result;
	        };
	    }
	
	    function isFunction(func) {
	        return Object.prototype.toString.call(func) === '[object Function]';
	    }
	
	    // 事件添加、删除和触发
	    function Events() {
	    }
	
	    /**
	     * 监听事件
	     *
	     * @param {String|Null} events 空格分离的事件名称，缺省为message
	     * @param {Function} callback 事件触发的回调函数
	     * @param {Object|Null} context 执行回调函数的上下文
	     */
	    Events.prototype.on = function(events, callback, context) {
	        var event, cache, list;
	        if (!callback) return this;
	
	        cache = this.__events || (this.__events = {});
	        events = events.split(eventSplitter);
	
	        while (event = events.shift()) {
	            list = cache[event] || (cache[event] = []);
	            list.push(callback, context);
	        }
	
	        return this;
	    };
	
	    /**
	     * 只触发一次事件
	     *
	     * @param {String|Null} events 空格分离的事件名称，缺省为message
	     * @param {Function} callback 回调函数
	     * @param {Object|Null} context 回调函数的执行上下文
	     */
	    Events.prototype.once = function(events, callback, context) {
	        var that = this;
	        var cb = function() {
	            that.off(events, cb);
	            callback.apply(context || that, arguments);
	        };
	        return this.on(events, cb, context);
	    };
	
	    /**
	     * 解绑事件
	     *
	     * @param {String|Null} events 空格分离的事件名称
	     * @param {Function|Null} callback 回调函数
	     * @param {Object|Null} context 执行回调函数的上下文
	     * @example
	     *
	     *      // 移除change事件的onChange回调
	     *      object.off("change", onChange);
	     *
	     *      // 移除change事件的所有回调
	     *      object.off("change");
	     *
	     *      // 移除所有事件的onChange回调
	     *      object.off(null, onChange);
	     *
	     *      // 移除上下文为context的所有事件的所有回调
	     *      object.off(null, null, context);
	     *
	     *      // 移除object对象上的所有事件
	     *      object.off();
	     */
	    Events.prototype.off = function(events, callback, context) {
	        var cache, event, list, i;
	
	        if (!(cache = this.__events)) return this;
	        if (!(events || callback || context)) {
	            delete this.__events;
	            return this;
	        }
	
	        events = events ? events.split(eventSplitter) : keys(cache);
	
	        while (event = events.shift()) {
	            list = cache[event];
	            if (!list) continue;
	
	            if (!(callback || context)) {
	                delete cache[event];
	                continue;
	            }
	
	            for (i = list.length - 2; i >= 0; i -= 2) {
	                if (!(callback && list[i] !== callback ||
	                    context && list[i + 1] !== context)) {
	                    list.splice(i, 2);
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * 触发事件
	     *
	     * @param {String} events 空格分离的事件名称
	     */
	    Events.prototype.trigger = function(events) {
	        var cache, event, list, i, len, rest = [], returned = true;
	        if (!(cache = this.__events)) return this;
	
	        events = events.split(eventSplitter);
	
	        // 遍历获取参数
	        for (i = 1, len = arguments.length; i < len; i++) {
	            rest[i - 1] = arguments[i];
	        }
	
	        while (event = events.shift()) {
	            // Copy callback lists to prevent modification.
	            if (list = cache[event]) list = list.slice();
	
	            returned = triggerEvents(list, rest, this) && returned;
	        }
	
	        return returned;
	    };
	
	    Events.prototype.emit = Events.prototype.trigger;
	
	    /**
	     * 将事件功能混入到其他类中
	     *
	     * @param {Function|Object} receiver
	     */
	    Events.mixTo = function(receiver) {
	        var proto = Events.prototype,
	            key;
	
	        if (isFunction(receiver)) {
	            for (key in proto) {
	                if (proto.hasOwnProperty(key)) {
	                    receiver.prototype[key] = proto[key];
	                }
	            }
	        } else {
	            var event = new Events();
	            for (key in proto) {
	                if (proto.hasOwnProperty(key)) {
	                    copyProto(key);
	                }
	            }
	        }
	
	        function copyProto(key) {
	            receiver[key] = function() {
	                proto[key].apply(event, Array.prototype.slice.call(arguments));
	                return this;
	            };
	        }
	    };
	
	    // Execute callbacks
	    function triggerEvents(list, args, context) {
	        var pass = true;
	
	        if (list) {
	            var i = 0, l = list.length, a1 = args[0], a2 = args[1], a3 = args[2];
	            // call is faster than apply, optimize less than 3 argu
	            // http://blog.csdn.net/zhengyinhui100/article/details/7837127
	            switch (args.length) {
	                case 0: for (; i < l; i += 2) { pass = list[i].call(list[i + 1] || context) !== false && pass; } break;
	                case 1: for (; i < l; i += 2) { pass = list[i].call(list[i + 1] || context, a1) !== false && pass; } break;
	                case 2: for (; i < l; i += 2) { pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass; } break;
	                case 3: for (; i < l; i += 2) { pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass; } break;
	                default: for (; i < l; i += 2) { pass = list[i].apply(list[i + 1] || context, args) !== false && pass; } break;
	            }
	        }
	        // trigger will return false if one of the callbacks return false
	        return pass;
	    }
	
	    return Events;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },

/***/ 30:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 组件基类，主要负责View层的管理。
	 * Widget组件具有四个要素：描述状态的attributes和properties，描述行为的events和methods。
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	    var $ = __webpack_require__(1);
	    var Base = __webpack_require__(27);
	
	    var DELEGATE_EVENT_NS = '.delegate-events-';
	    var ON_RENDER = '_onRender';        // Base 基类默认已经取了 _onChange，故这里不能也修改为 _onChange，否则会造成属性事件绑定两次
	    var DATA_WIDGET_CID = 'data-widget-cid';
	
	    // 所有初始化过的 Widget 实例
	    var cachedInstances = {};
	
	    var Widget = Base.extend({
	
	        propsInAttrs: ['element', 'events', 'config'],
	
	        // 与 widget 关联的 DOM 元素
	        element: null,
	
	        // 事件代理，格式为：
	        //   {
	        //     'mousedown .title': 'edit',
	        //     'click {{attrs.saveButton}}': 'save'
	        //     'click .open': function(ev) { ... }
	        //   }
	        events: null,
	
	        // 外部配置信息，组件实例化时传入
	        // 适用于外部配置来改变组件功能
	        config: null,
	
	        // 属性列表
	        attrs: {
	            // 基本属性
	            id: null,
	            className: null,
	            style: null,
	
	            // 默认模板
	            template: '<div></div>',
	
	            // 默认数据模型
	            model: null,
	
	            // 组件的默认父节点
	            parentNode: document.body
	        },
	
	        // 初始化方法，确定组件创建时的基本流程：
	        // 初始化 attrs --》 初始化 props --》 初始化 events --》 子类的初始化
	        initialize: function(config) {
	            this.cid = uniqueCid();
	
	            // 初始化 attrs，不支持从 data-api 初始化配置
	            Widget.superclass.initialize.call(this, config || {});
	
	            // 初始化 props
	            this.parseElement();
	            this.initProps();
	
	            // 初始化 events
	            this.delegateEvents();
	
	            // 子类自定义的初始化
	            this.setup();
	
	            // 保存实例信息
	            this._stamp();
	
	            // 是否由 template 初始化
	            this._isTemplate = !(config && config.element);
	        },
	
	        // 构建 this.element
	        parseElement: function() {
	            var element = this.element;
	
	            if (element) {
	                this.element = $(element);
	            } else if (this.get('template')) {  // 未传入 element 时，从 template 构建
	                this.parseElementFromTemplate();
	            }
	
	            // 如果对应的 DOM 元素不存在，则报错
	            if (!this.element || !this.element[0]) {
	                throw new Error('element is invalid');
	            }
	        },
	
	        // 从模板中构建 this.element
	        parseElementFromTemplate: function() {
	            this.element = $(this.get('template'));
	        },
	
	        // 负责 properties 的初始化，提供给子类覆盖
	        initProps: function() {
	        },
	
	        // 注册事件代理
	        delegateEvents: function(element, events, handler) {
	            var argus = trimRightUndefine(Array.prototype.slice.call(arguments));
	            // widget.delegateEvents()
	            if (argus.length === 0) {
	                events = getEvents(this);
	                element = this.element;
	
	            // widget.delegateEvents({
	            //   'click p': 'fn1',
	            //   'click li': 'fn2'
	            // })
	            } else if (argus.length === 1) {
	                events = element;
	                element = this.element;
	
	            // widget.delegateEvents('click p', function(ev) { ... })
	            } else if (argus.length === 2) {
	                handler = events;
	                events = element;
	                element = this.element;
	
	            // widget.delegateEvents(element, 'click p', function(ev) { ... })
	            } else {
	                element || (element = this.element);
	                this._delegateElements || (this._delegateElements = []);
	                this._delegateElements.push($(element));
	            }
	
	            // 'click p' => {'click p': handler}
	            if (isString(events) && isFunction(handler)) {
	                var o = {};
	                o[events] = handler;
	                events = o;
	            }
	
	            // key 为 'event selector'
	            for (var key in events) {
	                if (!events.hasOwnProperty(key)) continue;
	
	                var args = parseEventKey(key, this);
	                var eventType = args.type;
	                var selector = args.selector;
	
	                (function(handler, widget) {
	
	                    var callback = function(ev) {
	                        if (isFunction(handler)) {
	                            handler.call(widget, ev, this);
	                        } else {
	                            widget[handler](ev, this);
	                        }
	                    };
	
	                    // delegate
	                    if (selector) {
	                        $(element).on(eventType, selector, callback);
	
	                    // normal bind
	                    // 分开写是为了兼容 zepto，zepto 的判断不如 jquery 强劲有力
	                    } else {
	                        $(element).on(eventType, callback);
	                    }
	
	                })(events[key], this);
	            }
	
	            return this;
	        },
	
	        // 卸载事件代理
	        undelegateEvents: function(element, eventKey) {
	            var argus = trimRightUndefine(Array.prototype.slice.call(arguments));
	
	            if (!eventKey) {
	                eventKey = element;
	                element = null;
	            }
	
	            // 卸载所有
	            // .undelegateEvents()
	            if (argus.length === 0) {
	                var type = DELEGATE_EVENT_NS + this.cid;
	
	                this.element && this.element.off(type);
	
	                // 卸载所有外部传入的 element
	                if (this._delegateElements) {
	                    for (var de in this._delegateElements) {
	                        if (!this._delegateElements.hasOwnProperty(de)) continue;
	                        this._delegateElements[de].off(type);
	                    }
	                }
	
	            } else {
	                var args = parseEventKey(eventKey, this);
	
	                // 卸载 this.element
	                // .undelegateEvents(events)
	                if (!element) {
	                    this.element && this.element.off(args.type, args.selector);
	
	                // 卸载外部 element
	                // .undelegateEvents(element, events)
	                } else {
	                    $(element).off(args.type, args.selector);
	                }
	            }
	            return this;
	        },
	
	        // 提供给子类覆盖的初始化方法
	        setup: function() {
	        },
	
	        // 将 widget 渲染到页面上
	        // 渲染不仅仅包括插入到 DOM 树中，还包括样式渲染等
	        // 约定：子类覆盖时，需保持 `return this`
	        render: function() {
	
	            // 让渲染相关属性的初始值生效，并绑定到 change 事件
	            // 初始调用 render 方法时触发一次事件调用
	            if (!this.rendered) {
	                this._renderAndBindAttrs();
	                this.rendered = true;
	            }
	
	            // 插入到文档流中
	            var parentNode = this.get('parentNode');
	            if (parentNode && !isInDocument(this.element[0])) {
	                // 隔离样式，添加统一的命名空间
	                // https://github.com/aliceui/aliceui.org/issues/9
	                var outerBoxClass = this.constructor.outerBoxClass;
	                if (outerBoxClass) {
	                    var outerBox = this._outerBox = $('<div></div>').addClass(outerBoxClass);
	                    outerBox.append(this.element).appendTo(parentNode);
	                } else {
	                    this.element.appendTo(parentNode);
	                }
	            }
	
	            return this;
	        },
	
	        // 让属性的初始值生效，并绑定到 change:attr 事件上
	        _renderAndBindAttrs: function() {
	            var widget = this;
	            var attrs = widget.attrs;
	
	            for (var attr in attrs) {
	                if (!attrs.hasOwnProperty(attr)) continue;
	                var m = ON_RENDER + ucfirst(attr);
	
	                if (this[m]) {
	                    var val = this.get(attr);
	
	                    // 让属性的初始值生效。注：默认空值不触发
	                    // 初始化时调用一次事件函数 _onRenderAttr
	                    if (!isEmptyAttrValue(val)) {
	                        this[m](val, undefined, attr);
	                    }
	
	                    // 将 _onRenderXx 自动绑定到 change:xx 事件上
	                    (function(m) {
	                        widget.on('change:' + attr, function(val, prev, key) {
	                            widget[m](val, prev, key);
	                        });
	                    })(m);
	                }
	            }
	        },
	
	        _onRenderId: function(val) {
	            this.element.attr('id', val);
	        },
	
	        _onRenderClassName: function(val) {
	            this.element.addClass(val);
	        },
	
	        _onRenderStyle: function(val) {
	            this.element.css(val);
	        },
	
	        // 让 element 与 Widget 实例建立关联
	        _stamp: function() {
	            var cid = this.cid;
	
	            this.element.attr(DATA_WIDGET_CID, cid);
	            cachedInstances[cid] = this;
	        },
	
	        // 在 this.element 内寻找匹配节点
	        $: function(selector) {
	            return this.element.find(selector);
	        },
	
	        destroy: function() {
	            this.undelegateEvents();
	            delete cachedInstances[this.cid];
	
	            // For memory leak
	            if (this.element && this._isTemplate) {
	                this.element.off();
	                // 如果是 widget 生成的 element 则去除
	                if (this._outerBox) {
	                    this._outerBox.remove();
	                } else {
	                    this.element.remove();
	                }
	            }
	            this.element = null;
	
	            Widget.superclass.destroy.call(this);
	        }
	    });
	
	    // For memory leak
	    $(window).unload(function() {
	        for(var cid in cachedInstances) {
	            cachedInstances[cid].destroy();
	        }
	    });
	
	    // 查询与 selector 匹配的第一个 DOM 节点，得到与该 DOM 节点相关联的 Widget 实例
	    Widget.query = function(selector) {
	        var element = $(selector).eq(0);
	        var cid;
	
	        element && (cid = element.attr(DATA_WIDGET_CID));
	        return cachedInstances[cid];
	    };
	
	
	    // Helpers
	    // ------
	
	    var toString = Object.prototype.toString;
	    var cidCounter = 0;
	
	    function uniqueCid() {
	        return 'widget-' + cidCounter++;
	    }
	
	    function isString(val) {
	        return toString.call(val) === '[object String]';
	    }
	
	    function isFunction(val) {
	        return toString.call(val) === '[object Function]';
	    }
	
	    // Zepto 上没有 contains 方法
	    var contains = $.contains || function(a, b) {
	        var include = false;
	
	        if (a.compareDocumentPosition) {
	            include = !!(a.compareDocumentPosition(b) & 16);
	        } else {
	            while (b = b.parentNode) {
	                if (b === a) {
	                    include = true;
	                }
	            }
	        }
	        return include;
	    };
	
	    function isInDocument(element) {
	        return contains(document.documentElement, element);
	    }
	
	    function ucfirst(str) {
	        return str.charAt(0).toUpperCase() + str.substring(1);
	    }
	
	
	    var EVENT_KEY_SPLITTER = /^(\S+)\s*(.*)$/;
	    var EXPRESSION_FLAG = /{{([^}]+)}}/g;
	    var INVALID_SELECTOR = 'INVALID_SELECTOR';
	
	    function getEvents(widget) {
	        if (isFunction(widget.events)) {
	            widget.events = widget.events();
	        }
	        return widget.events;
	    }
	
	    function parseEventKey(eventKey, widget) {
	        var match = eventKey.match(EVENT_KEY_SPLITTER);
	        var eventType = match[1] + DELEGATE_EVENT_NS + widget.cid;
	
	        // 当没有 selector 时，需要设置为 undefined，以使得 zepto 能正确转换为 bind
	        var selector = match[2] || undefined;
	
	        if (selector && selector.indexOf('{{') > -1) {
	            selector = parseExpressionInEventKey(selector, widget);
	        }
	
	        return {
	            type: eventType,
	            selector: selector
	        };
	    }
	
	    // 解析 eventKey 中的 {{xx}}, {{yy}}
	    function parseExpressionInEventKey(selector, widget) {
	
	        return selector.replace(EXPRESSION_FLAG, function(m, name) {
	            var parts = name.split(".");
	            var point = widget, part;
	
	            while (part = parts.shift()) {
	                if (point === widget.attrs) {
	                    point = widget.get(part);
	                } else {
	                    point = point[part];
	                }
	            }
	
	            // 已经是 className，比如来自 dataset 的
	            if (isString(point)) {
	                return point;
	            }
	
	            // 不能识别的，返回无效标识
	            return INVALID_SELECTOR;
	        });
	    }
	
	
	    // 对于 attrs 的 value 来说，以下值都认为是空值： null, undefined
	    function isEmptyAttrValue(o) {
	        return o === null || o === undefined;
	    }
	
	    function trimRightUndefine(argus) {
	        for (var i = argus.length - 1; i >= 0; i--) {
	            if (argus[i] === undefined) {
	                argus.pop();
	            } else {
	                break;
	            }
	        }
	        return argus;
	    }
	
	    return Widget;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 42:
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		if (typeof execScript !== "undefined")
			execScript(src);
		else
			eval.call(null, src);
	}


/***/ },

/***/ 50:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 检测专用类
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	
	    var CDetector = __webpack_require__(40),
	        browser = CDetector.browser;
	
	    // 检查当前URL是否为detach模式
	    function isDetachMode() {
	        return /detach.jsp$/.test(location.pathname);
	    }
	
	    // 参考 http://stackoverflow.com/questions/28766423/detecting-npapi-support-in-chrome-using-javascript
	    // 目前修正的逻辑只检查Chrome浏览器, 其他浏览器都认为支持. 后续其他浏览器如果提供不支持方法需要继续修正这个方法
	    function isSupportNPAPI() {
	        var isJavaAvailable;
	
	        if (browser.name === 'chrome') {
	            isJavaAvailable = (function() {
	                var javaRegex = /(Java)(\(TM\)| Deployment)/,
	                    plugins = navigator.plugins || [], plugin;
	                for (plugin in plugins) {
	                    if (plugins.hasOwnProperty(plugin) && javaRegex.exec(plugins[plugin].name)) {
	                        return true;
	                    }
	                }
	
	                return false;
	            })();
	
	            if (browser.version >= 42 && !isJavaAvailable) {
	                return false;
	            }
	        }
	
	        return true;
	    }
	
	    function isIE(version) {
	        var currentVersion = (function () {
	            var returnVersion = -1;
	            var userAgent = navigator.userAgent;
	            if (navigator.appName === 'Microsoft Internet Explorer') {
	                if (/MSIE ([0-9]{1,}[.0-9]{0,})/.exec(userAgent) !== null) {
	                    returnVersion = parseInt(RegExp.$1, 10);
	                }
	            } else if (navigator.appName === 'Netscape') {
	                if (/Trident\/.*rv:([0-9]{1,}[.0-9]{0,})/.exec(userAgent) !== null) {
	                    returnVersion = parseInt(RegExp.$1, 10);
	                }
	            }
	
	            return returnVersion;
	        })();
	
	        var isIE = currentVersion > 0;
	        /**
	         * 支持 IE6 ~ 11 的版本检测：
	         * '6+'： 表示检测是否为 IE6 以上
	         * '11'：表示检测是否为 IE11
	         * '8-'：表示检测是否为 IE8 以下
	         */
	        var operations = /^(1[0-1]|[6-9])(\+|-)?$/.exec(version);
	
	        if (version === void 0 || operations === null || !isIE) {
	            // 若没有传 version 或 version 不符合规则或本身不是 IE，则只判断是否是 IE 浏览器即可
	            return isIE;
	        }
	
	        var versionNumber = parseInt(operations[1], 10);
	        var versionOperator = operations[2];
	        switch (versionOperator) {
	        case '+':
	            return currentVersion >= versionNumber;
	        case '-':
	            return currentVersion <= versionNumber;
	        case void 0:
	            return currentVersion === versionNumber;
	        default:
	            return currentVersion === versionNumber;
	        }
	    }
	
	    function isLowerIE11() {
	        return isIE() && browser.version < 11;
	    }
	
	    function isClipboardSupport() {
	        if (browser.name === 'ie') {
	            return (browser.version >= 9) ? true : (window.clipboardData ? 'oldie' : false);
	        } else {
	            return (browser.name === 'chrome' && browser.version >= 42)
	                   || (browser.name === 'firefox' && browser.version >= 41)
	                   || (browser.name === 'opera' && browser.version >= 29);
	        }
	    }
	
	    function supportAjaxUpload() {
	        var supportFileAPI = (function() {
	            var node = document.createElement('INPUT');
	            node.type = 'file';
	            return 'files' in node;
	        })();
	
	        var supportFormData = (function() {
	            return !!window.FormData;
	        })();
	
	        return supportFileAPI && supportFormData;
	    }
	
	    function supportBlobURL() {
	        return !!window.URL && window.URL.createObjectURL;
	    }
	
	    return {
	        isDetachMode: isDetachMode,
	        isSupportNPAPI: isSupportNPAPI,
	        isClipboardSupport: isClipboardSupport,
	        isIE: isIE,
	        isLowerIE11: isLowerIE11,
	        supportAjaxUpload: supportAjaxUpload,
	        supportBlobURL: supportBlobURL,
	        device: CDetector.device,
	        os: CDetector.os,
	        engine: CDetector.engine,
	        browser: browser
	    }
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	


/***/ },

/***/ 78:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 允许在指定方法执行的前后插入特定函数
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    // 在指定方法执行前，先执行 callback
	    exports.before = function(methodName, callback, context) {
	        return weave.call(this, 'before', methodName, callback, context);
	    };
	
	
	    // 在指定方法执行后，再执行 callback
	    exports.after = function(methodName, callback, context) {
	        return weave.call(this, 'after', methodName, callback, context);
	    };
	
	
	    // Helpers
	    // -------
	
	    var eventSplitter = /\s+/;
	
	    function weave(when, methodName, callback, context) {
	        var names = methodName.split(eventSplitter);
	        var name, method;
	
	        while (name = names.shift()) {
	            method = getMethod(this, name);
	            if (!method.__isAspected) {
	                wrap.call(this, name);
	            }
	            this.on(when + ':' + name, callback, context);
	        }
	
	        return this;
	    }
	
	
	    function getMethod(host, methodName) {
	        var method = host[methodName];
	        if (!method) {
	            throw new Error('Invalid method name: ' + methodName);
	        }
	        return method;
	    }
	
	
	    function wrap(methodName) {
	        var old = this[methodName];
	
	        this[methodName] = function() {
	            var args = Array.prototype.slice.call(arguments);
	            var beforeArgs = ['before:' + methodName].concat(args);
	
	            // prevent if trigger return false
	            if (this.trigger.apply(this, beforeArgs) === false) return;
	
	            var ret = old.apply(this, arguments);
	            var afterArgs = ['after:' + methodName, ret].concat(args);
	            this.trigger.apply(this, afterArgs);
	
	            return ret;
	        };
	
	        this[methodName].__isAspected = true;
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 79:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 提供基本的属性添加、获取、移除等功能
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	    // 负责 attributes 的初始化
	    // attributes 是与实例相关的状态信息，可读可写，发生变化时，会自动触发相关事件
	    var exports = {
	        initAttrs: function(config) {
	            // initAttrs 是在初始化时调用的，默认情况下实例上肯定没有 attrs，不存在覆盖问题
	            var attrs = this.attrs = {};
	
	            // Get all inherited attributes.
	            // this.propsInAttrs 中指定的属性，如果 prototype 上存在，那么会将其挂载在 this 上.
	            var specialProps = this.propsInAttrs || [];
	            mergeInheritedAttrs(attrs, this, specialProps);
	
	            // Merge user-specific attributes from config.
	            if (config) {
	                mergeUserValue(attrs, config);
	            }
	
	            // 对于有 setter 的属性，要用初始值 set 一下，以保证关联属性也一同初始化
	            setSetterAttrs(this, attrs, config);
	
	            // Convert `on/before/afterXxx` config to event handler.
	            parseEventsFromAttrs(this, attrs);
	
	            // 将 this.attrs 上的 special properties 放回 this 上
	            copySpecialProps(specialProps, this, attrs, true);
	        },
	
	        // Get the value of an attribute.
	        get: function(key) {
	            var attr = this.attrs[key] || {};
	            var val = attr.value;
	            return attr.getter ? attr.getter.call(this, val, key) : val;
	        },
	
	        // Set a hash of model attributes on the object, firing `"change"` unless
	        // you choose to silence it.
	        set: function(key, val, options) {
	            var attrs = {};
	
	            // set("key", val, options)
	            if (isString(key)) {
	                attrs[key] = val;
	            } else {
	                // set({ "key": val, "key2": val2 }, options)
	                attrs = key;
	                options = val;
	            }
	
	            options || (options = {});
	            var silent = options.silent;
	            var override = options.override;
	
	            var now = this.attrs;
	            var changed = this.__changedAttrs || (this.__changedAttrs = {});
	
	            for (key in attrs) {
	                if (!attrs.hasOwnProperty(key)) continue;
	
	                var attr = now[key] || (now[key] = {});
	                val = attrs[key];
	
	                if (attr.readOnly) {
	                    throw new Error('This attribute is readOnly: ' + key);
	                }
	
	                // invoke setter
	                // 这里调用 setter 有个隐含的 bug，那就是在 setter 中不要去设置 this.attrs[key].value = val
	                if (attr.setter) {
	                    val = attr.setter.call(this, val, key);
	                }
	
	                // 获取设置前的 prev 值
	                var prev = this.get(key);
	
	                // 获取需要设置的 val 值
	                // 如果设置了 override 为 true，表示要强制覆盖，就不去 merge 了
	                // 都为对象时，做 merge 操作，以保留 prev 上没有覆盖的值
	                if (!override && isPlainObject(prev) && isPlainObject(val)) {
	                    val = merge(merge({}, prev), val);
	                }
	
	                // set finally
	                now[key].value = val;
	
	                // invoke change event
	                // 初始化时对 set 的调用，不触发任何事件
	                if (!this.__initializingAttrs && !isEqual(prev, val)) {
	                    if (silent) {
	                        changed[key] = [val, prev];
	                    } else {
	                        this.trigger('change:' + key, val, prev, key);
	                    }
	                }
	            }
	
	            return this;
	        },
	
	        // Call this method to manually fire a `"change"` event for triggering
	        // a `"change:attribute"` event for each changed attribute.
	        change: function() {
	            var changed = this.__changedAttrs;
	
	            if (changed) {
	                for (var key in changed) {
	                    if (changed.hasOwnProperty(key)) {
	                        var args = changed[key];
	                        this.trigger('change:' + key, args[0], args[1], key);
	                    }
	                }
	                delete this.__changedAttrs;
	            }
	
	            return this;
	        },
	
	        // for test
	        _isPlainObject: isPlainObject
	    };
	
	    // Helpers
	    // -------
	
	    var toString = Object.prototype.toString;
	    var hasOwn = Object.prototype.hasOwnProperty;
	
	    /**
	     * Detect the JScript [[DontEnum]] bug:
	     * In IE < 9 an objects own properties, shadowing non-enumerable ones, are
	     * made non-enumerable as well.
	     * https://github.com/bestiejs/lodash/blob/7520066fc916e205ef84cb97fbfe630d7c154158/lodash.js#L134-L144
	     */
	    /** Detect if own properties are iterated after inherited properties (IE < 9) */
	    var iteratesOwnLast;
	    (function() {
	        var props = [];
	        function Ctor() { this.x = 1; }
	        Ctor.prototype = { 'valueOf': 1, 'y': 1 };
	        for (var prop in new Ctor()) { props.push(prop); }
	        iteratesOwnLast = props[0] !== 'x';
	    }());
	
	    var isArray = Array.isArray || function(val) {
	        return toString.call(val) === '[object Array]';
	    };
	
	    function isString(val) {
	        return toString.call(val) === '[object String]';
	    }
	
	    function isFunction(val) {
	        return toString.call(val) === '[object Function]';
	    }
	
	    function isWindow(o) {
	        return o != null && o == o.window;
	    }
	
	    function isPlainObject(o) {
	        // Must be an Object.
	        // Because of IE, we also have to check the presence of the constructor
	        // property. Make sure that DOM nodes and window objects don't
	        // pass through, as well
	        if (!o || toString.call(o) !== '[object Object]' ||
	            o.nodeType || isWindow(o)) {
	            return false;
	        }
	
	        try {
	            // Not own constructor property must be Object
	            if (o.constructor &&
	                !hasOwn.call(o, 'constructor') &&
	                !hasOwn.call(o.constructor.prototype, 'isPrototypeOf')) {
	                return false;
	            }
	        } catch (e) {
	            // IE8,9 Will throw exceptions on certain host objects #9897
	            return false;
	        }
	
	        var key;
	
	        // Support: IE<9
	        // Handle iteration over inherited properties before own properties.
	        // http://bugs.jquery.com/ticket/12199
	        if (iteratesOwnLast) {
	            for (key in o) {
	                return hasOwn.call(o, key);
	            }
	        }
	
	        // Own properties are enumerated firstly, so to speed up,
	        // if last one is own, then all properties are own.
	        for (key in o) {}
	
	        return key === undefined || hasOwn.call(o, key);
	    }
	
	    function isEmptyObject(o) {
	        if (!o || toString.call(o) !== '[object Object]' ||
	            o.nodeType || isWindow(o) || !o.hasOwnProperty) {
	            return false;
	        }
	
	        for (var p in o) {
	            if (o.hasOwnProperty(p)) return false;
	        }
	        return true;
	    }
	
	    function merge(receiver, supplier) {
	        var key;
	
	        for (key in supplier) {
	            if (supplier.hasOwnProperty(key)) {
	                receiver[key] = cloneValue(supplier[key], receiver[key]);
	            }
	        }
	
	        return receiver;
	    }
	
	    // 只 clone 数组和 plain object，其他的保持不变
	    function cloneValue(value, prev){
	        if (isArray(value)) {
	            value = value.slice();
	        } else if (isPlainObject(value)) {
	            isPlainObject(prev) || (prev = {});
	
	            value = merge(prev, value);
	        }
	
	        return value;
	    }
	
	    var keys = Object.keys;
	
	    if (!keys) {
	        keys = function(o) {
	            var result = [];
	
	            for (var name in o) {
	                if (o.hasOwnProperty(name)) {
	                    result.push(name);
	                }
	            }
	            return result;
	        };
	    }
	
	    function mergeInheritedAttrs(attrs, instance, specialProps) {
	        var inherited = [];
	        var proto = instance.constructor.prototype;
	
	        while (proto) {
	            // 不要取父类 prototype 的
	            if (!proto.hasOwnProperty('attrs')) {
	                proto.attrs = {};
	            }
	
	            // 将 proto 上的特殊 properties 放到 proto.attrs 上，以便合并
	            copySpecialProps(specialProps, proto.attrs, proto);
	
	            // 为空时不添加
	            if (!isEmptyObject(proto.attrs)) {
	                inherited.unshift(proto.attrs);
	            }
	
	            // 向上回溯一级
	            proto = proto.constructor.superclass;
	        }
	
	        // Merge and clone default values to instance.
	        for (var i = 0, len = inherited.length; i < len; i++) {
	            mergeAttrs(attrs, normalize(inherited[i]));
	        }
	    }
	
	    function mergeUserValue(attrs, config) {
	        mergeAttrs(attrs, normalize(config, true), true);
	    }
	
	    function copySpecialProps(specialProps, receiver, supplier, isAttr2Prop) {
	        for (var i = 0, len = specialProps.length; i < len; i++) {
	            var key = specialProps[i];
	
	            if (supplier.hasOwnProperty(key)) {
	                receiver[key] = isAttr2Prop ? receiver.get(key) : supplier[key];
	            }
	        }
	    }
	
	
	    var EVENT_PATTERN = /^(on|before|after)([A-Z].*)$/;
	    var EVENT_NAME_PATTERN = /^(Change)?([A-Z])(.*)/;
	
	    function parseEventsFromAttrs(host, attrs) {
	        for (var key in attrs) {
	            if (attrs.hasOwnProperty(key)) {
	                var value = attrs[key].value, m;
	
	                if (isFunction(value) && (m = key.match(EVENT_PATTERN))) {
	                    host[m[1]](getEventName(m[2]), value);
	                    delete attrs[key];
	                }
	            }
	        }
	    }
	
	    // Converts `Show` to `show` and `ChangeTitle` to `change:title`
	    function getEventName(name) {
	        var m = name.match(EVENT_NAME_PATTERN);
	        var ret = m[1] ? 'change:' : '';
	        ret += m[2].toLowerCase() + m[3];
	        return ret;
	    }
	
	
	    function setSetterAttrs(host, attrs, config) {
	        var options = { silent: true };
	        host.__initializingAttrs = true;
	
	        for (var key in config) {
	            if (config.hasOwnProperty(key)) {
	                if (attrs[key].setter) {
	                    host.set(key, config[key], options);
	                }
	            }
	        }
	
	        delete host.__initializingAttrs;
	    }
	
	
	    var ATTR_SPECIAL_KEYS = ['value', 'getter', 'setter', 'readOnly'];
	
	    // normalize `attrs` to
	    //
	    //   {
	    //      value: 'xx',
	    //      getter: fn,
	    //      setter: fn,
	    //      readOnly: boolean
	    //   }
	    //
	    // 如果不提供 value/getter/setter/readOnly，默认的结构为
	    //  {
	    //      value: 'xx'
	    //  }
	    function normalize(attrs, isUserValue) {
	        var newAttrs = {};
	
	        for (var key in attrs) {
	            var attr = attrs[key];
	
	            if (!isUserValue &&
	                isPlainObject(attr) &&
	                hasOwnProperties(attr, ATTR_SPECIAL_KEYS)) {
	                newAttrs[key] = attr;
	                continue;
	            }
	
	            newAttrs[key] = {
	                value: attr
	            };
	        }
	
	        return newAttrs;
	    }
	
	    var ATTR_OPTIONS = ['setter', 'getter', 'readOnly'];
	    // 专用于 attrs 的 merge 方法
	    function mergeAttrs(attrs, inheritedAttrs, isUserValue){
	        var key, value;
	        var attr;
	
	        for (key in inheritedAttrs) {
	            if (inheritedAttrs.hasOwnProperty(key)) {
	                value = inheritedAttrs[key];
	                attr = attrs[key];
	
	                if (!attr) {
	                    attr = attrs[key] = {};
	                }
	
	                // 从严谨上来说，遍历 ATTR_SPECIAL_KEYS 更好
	                // 从性能来说，直接 人肉赋值 更快
	                // 这里还是选择 性能优先
	
	                // 只有 value 要复制原值，其他的直接覆盖即可
	                (value['value'] !== undefined) && (attr['value'] = cloneValue(value['value'], attr['value']));
	
	                // 如果是用户赋值，只要考虑value
	                if (isUserValue) continue;
	
	                for (var i in ATTR_OPTIONS) {
	                    var option = ATTR_OPTIONS[i];
	                    if (value[option] !== undefined) {
	                        attr[option] = value[option];
	                    }
	                }
	            }
	        }
	
	        return attrs;
	    }
	
	    function hasOwnProperties(object, properties) {
	        for (var i = 0, len = properties.length; i < len; i++) {
	            if (object.hasOwnProperty(properties[i])) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	
	    // 对于 attrs 的 value 来说，以下值都认为是空值： null, undefined, '', [], {}
	    function isEmptyAttrValue(o) {
	        return o == null || // null, undefined
	            (isString(o) || isArray(o)) && o.length === 0 || // '', []
	            isEmptyObject(o); // {}
	    }
	
	    // 判断属性值 a 和 b 是否相等，注意仅适用于属性值的判断，非普适的 === 或 == 判断。
	    function isEqual(a, b) {
	        if (a === b) return true;
	
	        if (isEmptyAttrValue(a) && isEmptyAttrValue(b)) return true;
	
	        // Compare `[[Class]]` names.
	        var className = toString.call(a);
	        if (className != toString.call(b)) return false;
	
	        switch (className) {
	
	            // Strings, numbers, dates, and booleans are compared by value.
	            case '[object String]':
	                // Primitives and their corresponding object wrappers are
	                // equivalent; thus, `"5"` is equivalent to `new String("5")`.
	                return a == String(b);
	
	            case '[object Number]':
	                // `NaN`s are equivalent, but non-reflexive. An `equal`
	                // comparison is performed for other numeric values.
	                return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	
	            case '[object Date]':
	            case '[object Boolean]':
	                // Coerce dates and booleans to numeric primitive values.
	                // Dates are compared by their millisecond representations.
	                // Note that invalid dates with millisecond representations
	                // of `NaN` are not equivalent.
	                return +a == +b;
	
	            // RegExps are compared by their source patterns and flags.
	            case '[object RegExp]':
	                return a.source == b.source &&
	                    a.global == b.global &&
	                    a.multiline == b.multiline &&
	                    a.ignoreCase == b.ignoreCase;
	
	            // 简单判断数组包含的 primitive 值是否相等
	            case '[object Array]':
	                var aString = a.toString();
	                var bString = b.toString();
	
	                // 只要包含非 primitive 值，为了稳妥起见，都返回 false
	                return aString.indexOf('[object') === -1 &&
	                    bString.indexOf('[object') === -1 &&
	                    aString === bString;
	        }
	
	        if (typeof a != 'object' || typeof b != 'object') return false;
	
	        // 简单判断两个对象是否相等，只判断第一层
	        if (isPlainObject(a) && isPlainObject(b)) {
	
	            // 键值不相等，立刻返回 false
	            if (!isEqual(keys(a), keys(b))) {
	                return false;
	            }
	
	            // 键相同，但有值不等，立刻返回 false
	            for (var p in a) {
	                if (a[p] !== b[p]) return false;
	            }
	
	            return true;
	        }
	
	        // 其他情况返回 false, 以避免误判导致 change 事件没发生
	        return false;
	    }
	
	    return exports;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 80:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 通用对话框组件，提供显隐关闭、遮罩层、内嵌iframe、内容区域自定义功能，是所有对话框类型组件的基类。
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var $ = __webpack_require__(1);
	    var Events = __webpack_require__(29);
	    var Overlay = __webpack_require__(20);
	    var mask = __webpack_require__(81);
	    var Templatable = __webpack_require__(4);
	
	    var template = '<div class="{{classPrefix}} {{subClass}}">' +
	                        '<a class="{{classPrefix}}-close" title="Close" href="javascript:;" data-role="close"></a>' +
	                        '<div class="{{classPrefix}}-wrap" data-role="wrap"></div>' +
	                    '</div>';
	
	    var Dialog = Overlay.extend({
	        Implements: Templatable,
	
	        attrs: {
	            template: template,
	
	            // 对话框触发点
	            trigger: {
	                value: null,
	                getter: function(val) {
	                    return $(val);
	                }
	            },
	
	            classPrefix: 'u-dialog',
	
	            subClass: '',
	
	            // 指定内容元素，可以是url地址
	            content: {
	                value: null,
	                setter: function(val) {
	                    // 判断是否是url地址
	                    if (/^(https?:\/\/|\/|\.\/|\.\.\/)/.test(val)) {
	                        this._type = 'iframe';
	                        // 用 ajax 的方式而不是 iframe 进行载入
	                        if (val.indexOf('?ajax') > 0 || val.indexOf('&ajax') > 0) {
	                            this._ajax = true;
	                        }
	                    }
	                    return val;
	                }
	            },
	
	            // 是否有背景遮罩层
	            hasMask: true,
	
	            // 是否按ESC关闭弹窗
	            hasEscClose: true,
	
	            // 关闭按钮可以自定义
	            closeTpl: '&times;',
	
	            // 默认宽度
	            width: 450,
	
	            // 默认高度
	            height: null,
	
	            // iframe 类型时，dialog的最初高度
	            initialHeight: 300,
	
	            // 简单的动画效果 none|fade
	            effect: 'none',
	
	            zIndex: 999,
	
	            // 是否自适应高度
	            autoFit: true,
	
	            // 默认定位左右居中，略微靠上
	            align: {
	                value: {
	                    selfXY: ['50%', '50%'],
	                    baseXY: ['50%', '42%']
	                },
	                getter: function (val) {
	                    // 高度超过窗口的 42/50 浮层头部顶住窗口
	                    // https://github.com/aralejs/dialog/issues/41
	                    if (this.element.height() > $(window).height() * 0.84) {
	                        return {
	                            selfXY: ['50%', '0'],
	                            baseXY: ['50%', '0']
	                        };
	                    }
	                    return val;
	                }
	            }
	        },
	
	        parseElement: function() {
	            this.set('model', {
	                classPrefix: this.get('classPrefix')
	            });
	            Dialog.superclass.parseElement.call(this);
	            this.contentElement = this.$('[data-role=wrap]');
	
	            // 必要的样式
	            this.contentElement.css({
	                height: '100%',
	                zoom: 1
	            });
	
	            // 关闭按钮先隐藏
	            // 后面当 onRenderCloseTpl 时，如果 closeTpl 不为空，会显示出来
	            // 这样写是为了回避 arale.base 的一个问题：
	            // 当属性初始值为''时，不会进入 onRender 方法
	            // https://github.com/aralejs/base/issues/7
	            this.$('[data-role=close]').hide();
	        },
	
	        events: {
	            'click [data-role=close]': function (e) {
	                e.preventDefault();
	                this.hide();
	            }
	        },
	
	        show: function () {
	            // iframe 要在载入完成才显示
	            if (this._type === 'iframe') {
	                // ajax 读入内容并 append 到容器中
	                if (this._ajax) {
	                    this._ajaxHtml();
	                } else {
	                    // iframe 还未请求完，先设置一个固定高度
	                    !this.get('height') && this.contentElement.css('height', this.get('initialHeight'));
	                    this._showIframe();
	                }
	            }
	
	            Dialog.superclass.show.call(this);
	            return this;
	        },
	
	        hide: function () {
	            // 把 iframe 状态复原
	            if (this._type === 'iframe' && this.iframe) {
	                this.iframe.attr({
	                    src: 'javascript:\'\';'
	                });
	                // 原来只是将 iframe 的状态复原
	                // 但是发现在 IE6 下，将 src 置为 javascript:''; 会出现 404 页面
	                this.iframe.remove();
	                this.iframe = null;
	            }
	
	            Dialog.superclass.hide.call(this);
	            clearInterval(this._interval);
	            delete this._interval;
	            return this;
	        },
	
	        destroy: function () {
	            this.element.remove();
	            this._hideMask();
	            clearInterval(this._interval);
	            return Dialog.superclass.destroy.call(this);
	        },
	
	        setup: function () {
	            Dialog.superclass.setup.call(this);
	
	            this._setupTrigger();
	            this._setupMask();
	            this._setupKeyEvents();
	            this._setupFocus();
	            toTabed(this.element);
	            toTabed(this.get('trigger'));
	
	            // 默认当前触发器
	            this.activeTrigger = this.get('trigger').eq(0);
	        },
	
	        // onRender
	        // ---
	        _onRenderSubClass: function(val, prev) {
	            prev && this.element.removeClass(prev);
	            val && this.element.addClass(val);
	        },
	
	        _onRenderContent: function (val) {
	            if (this._type !== 'iframe') {
	                var value;
	                // 有些情况会报错
	                try {
	                    value = $(val);
	                } catch (e) {
	                    value = [];
	                }
	                if (value[0]) {
	                    this.contentElement.empty().append(value);
	                } else {
	                    this.contentElement.empty().html(val);
	                }
	                // #38 #44
	                this._setPosition();
	            }
	        },
	
	        _onRenderCloseTpl: function (val) {
	            if (val === '') {
	                this.$('[data-role=close]').html(val).hide();
	            } else {
	                this.$('[data-role=close]').html(val).show();
	            }
	        },
	
	        // 覆盖 overlay，提供动画
	        _onRenderVisible: function (val) {
	            if (val) {
	                if (this.get('effect') === 'fade') {
	                    // 固定 300 的动画时长，暂不可定制
	                    this.element.fadeIn(300);
	                } else {
	                    this.element.show();
	                }
	            } else {
	                this.element.hide();
	            }
	        },
	
	        // 私有方法
	        // ---
	        // 绑定触发对话框出现的事件
	        _setupTrigger: function () {
	            this.delegateEvents(this.get('trigger'), 'click', function (e) {
	                e.preventDefault();
	                // 标识当前点击的元素
	                this.activeTrigger = $(e.currentTarget);
	                this.show();
	            });
	        },
	
	        // 绑定遮罩层事件
	        _setupMask: function () {
	            var that = this;
	
	            // 存放 mask 对应的对话框
	            mask._dialogs = mask._dialogs || [];
	
	            this.after('show', function () {
	                if (!this.get('hasMask')) {
	                    return;
	                }
	                // not using the z-index
	                // because multiable dialogs may share same mask
	                mask.set('zIndex', that.get('zIndex')).show();
	                mask.element.insertBefore(that.element);
	
	                // 避免重复存放
	                var existed = false;
	                for (var i = 0; i < mask._dialogs.length; i++) {
	                    if (mask._dialogs[i] === that) {
	                        existed = true;
	                    }
	                }
	                // 依次存放对应的对话框
	                if (!existed) {
	                    mask._dialogs.push(that);
	                }
	            });
	
	            this.after('hide', this._hideMask);
	        },
	
	        // 隐藏 mask
	        _hideMask: function () {
	            if (!this.get('hasMask')) {
	                return;
	            }
	
	            // 当且仅当最后一个 dialog 是当前 dialog 时，才移除
	            // 因为 hide 与 destroy 都会调用 _hideMask，此举用于避免错误移除
	            if (mask._dialogs &&
	                    mask._dialogs[mask._dialogs.length - 1] === this) {
	                mask._dialogs.pop();
	            }
	
	            if (mask._dialogs && mask._dialogs.length > 0) {
	                var last = mask._dialogs[mask._dialogs.length - 1];
	                mask.set('zIndex', last.get('zIndex'));
	                mask.element.insertBefore(last.element);
	            } else {
	                mask.hide();
	            }
	        },
	
	        // 绑定元素聚焦状态
	        _setupFocus: function () {
	            this.after('show', function () {
	                this.element.focus();
	            });
	            this.after('hide', function () {
	                // 关于网页中浮层消失后的焦点处理
	                // http://www.qt06.com/post/280/
	                this.activeTrigger && this.activeTrigger.focus();
	            });
	        },
	
	        // 绑定键盘事件，ESC关闭窗口
	        _setupKeyEvents: function () {
	            if (this.get('hasEscClose')) {
	                this.delegateEvents($(document), 'keyup.esc', function (e) {
	                    if (e.keyCode === 27) {
	                        this.get('visible') && this.hide();
	                    }
	                });
	            }
	        },
	
	        _showIframe: function () {
	            var that = this;
	            // 若未创建则新建一个
	            if (!this.iframe) {
	                this._createIframe();
	            }
	            // 开始请求 iframe
	            this.iframe.attr({
	                src: this._fixUrl(),
	                name: 'dialog-iframe' + new Date().getTime()
	            });
	            // 因为在 IE 下 onload 无法触发
	            // http://my.oschina.net/liangrockman/blog/24015
	            // 所以使用 jquery 的 one 函数来代替 onload
	            // one 比 on 好，因为它只执行一次，并在执行后自动销毁
	            this.iframe.one('load', function () {
	                // 如果 dialog 已经隐藏了，就不需要触发 onload
	                if (!that.get('visible')) {
	                    return;
	                }
	                // 绑定自动处理高度的事件
	                if (that.get('autoFit')) {
	                    clearInterval(that._interval);
	                    that._interval = setInterval(function () {
	                        that._syncHeight();
	                    }, 300);
	                }
	                that._syncHeight();
	                that._setPosition();
	                that.trigger('complete:show');
	            });
	        },
	
	        _fixUrl: function () {
	            var s = this.get('content').match(/([^?#]*)(\?[^#]*)?(#.*)?/);
	            s.shift();
	            s[1] = ((s[1] && s[1] !== '?') ? (s[1] + '&') : '?') + 't=' + new Date().getTime();
	            return s.join('');
	        },
	
	        _createIframe: function () {
	            var that = this;
	
	            this.iframe = $('<iframe>', {
	                src: 'javascript:\'\';',
	                scrolling: 'no',
	                frameborder: 'no',
	                allowTransparency: 'true',
	                css: {
	                    border: 'none',
	                    width: '100%',
	                    display: 'block',
	                    height: '100%',
	                    overflow: 'hidden'
	                }
	            }).appendTo(this.contentElement);
	
	            // 给 iframe 绑一个 close 事件
	            // iframe 内部可通过 window.frameElement.trigger('close') 关闭
	            Events.mixTo(this.iframe[0]);
	            this.iframe[0].on('close', function () {
	                that.hide();
	            });
	        },
	
	        _syncHeight: function () {
	            var h;
	            // 如果未传 height，才会自动获取
	            if (!this.get('height')) {
	                try {
	                    this._errCount = 0;
	                    h = getIframeHeight(this.iframe) + 'px';
	                } catch (err) {
	                    // 页面跳转也会抛错，最多失败6次
	                    this._errCount = (this._errCount || 0) + 1;
	                    if (this._errCount >= 6) {
	                        // 获取失败则给默认高度 300px
	                        // 跨域会抛错进入这个流程
	                        h = this.get('initialHeight');
	                        clearInterval(this._interval);
	                        delete this._interval;
	                    }
	                }
	                this.contentElement.css('height', h);
	                // force to reflow in ie6
	                // http://44ux.com/blog/2011/08/24/ie67-reflow-bug/
	                this.element[0].className = this.element[0].className;
	            } else {
	                clearInterval(this._interval);
	                delete this._interval;
	            }
	        },
	
	        _ajaxHtml: function () {
	            var that = this;
	            this.contentElement.css('height', this.get('initialHeight'));
	            this.contentElement.load(this.get('content'), function () {
	                that._setPosition();
	                that.contentElement.css('height', '');
	                that.trigger('complete:show');
	            });
	        }
	    });
	
	    module.exports = Dialog;
	
	    // Helpers
	    // ----
	    // 让目标节点可以被 Tab
	    function toTabed(element) {
	        if (element.attr('tabindex') == null) {
	            element.attr('tabindex', '-1');
	        }
	    }
	
	    // 获取 iframe 内部的高度
	    function getIframeHeight(iframe) {
	        var D = iframe[0].contentWindow.document;
	        if (D.body.scrollHeight && D.documentElement.scrollHeight) {
	            return Math.min(
	                    D.body.scrollHeight, D.documentElement.scrollHeight);
	        } else if (D.documentElement.scrollHeight) {
	            return D.documentElement.scrollHeight;
	        } else if (D.body.scrollHeight) {
	            return D.body.scrollHeight;
	        }
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 81:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	    var $ = __webpack_require__(1);
	    var Overlay = __webpack_require__(20);
	
	    var ua = (window.navigator.userAgent || "").toLowerCase(),
	        isIE6 = ua.indexOf("msie 6") !== -1,
	        body = $(document.body),
	        doc = $(document);
	
	
	    // Mask
	    // ----------
	    // 全屏遮罩层组件
	    var Mask = Overlay.extend({
	
	        attrs: {
	            width: isIE6 ? doc.outerWidth(true) : '100%',
	            height: isIE6 ? doc.outerHeight(true) : '100%',
	
	            className: 'u-mask',
	            opacity: 0.3,
	            backgroundColor: '#000',
	            style: {
	                position: isIE6 ? 'absolute' : 'fixed',
	                top: 0,
	                left: 0
	            },
	
	            align: {
	                // undefined 表示相对于当前可视范围定位
	                baseElement: isIE6 ? body : undefined
	            }
	        },
	
	        show: function () {
	            if (isIE6) {
	                this.set('width', doc.outerWidth(true));
	                this.set('height', doc.outerHeight(true));
	            }
	            return Mask.superclass.show.call(this);
	        },
	
	        _onRenderBackgroundColor: function (val) {
	            this.element.css('backgroundColor', val);
	        },
	
	        _onRenderOpacity: function (val) {
	            this.element.css('opacity', val);
	        }
	    });
	
	    // 单例
	    return new Mask();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 83:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	    var $ = __webpack_require__(1);
	    var Base = __webpack_require__(27);
	
	    var Dnd = Base.extend({
	        propsInAttrs: ['element', 'handle'],
	
	        // 拖放的元素，即源节点
	        element: null,
	
	        // 触发拖放的元素，该元素必须在element内部
	        // 默认为element
	        handle: null,
	
	        attrs: {
	            // 拖放边界，默认为document
	            // element必须要位于containment内部
	            containment: {
	                value: $(document),
	                setter: function(val) {
	                    return $(val).eq(0);
	                }
	            },
	
	            // 代理元素。实际上跟随鼠标移动的元素，默认null为源节点element的clone
	            proxy: {
	                value: null,
	                setter: function(val) {
	                    return $(val).eq(0);
	                }
	            },
	
	            // 可放置容器，默认null为无
	            drops: {
	                value: null,
	                setter: function(val) {
	                    return $(val);
	                }
	            },
	
	            // 是否禁止该元素拖放，默认false为不禁止
	            disabled: false,
	
	            // 被拖放的元素在源位置上是否可见，默认为false不可见
	            visible: false,
	
	            // 拖放指定的方向，默认false为任意方向
	            axis: false,
	
	            // 是否返回源节点初始位置，默认false不返回
	            revert: false,
	
	            // 返回速度，默认为500ms
	            // 源节点显示（visible=true）时，拖放结束时移动到拖放位置的速度也取此值
	            revertDuration: 500,
	
	            // 拖放过程中没进入放置容器drop时光标的形状，默认为'move'
	            dragCursor: 'move',
	
	            // 拖放过程中进入放置容器drop时光标的形状，默认为'copy'
	            dropCursor: 'copy',
	
	            // 代理元素proxy拖放过程中的z-index，默认为9999
	            zIndex: 9999
	        },
	
	        initialize: function(config) {
	            Dnd.superclass.initialize.call(this, config);
	            // 用来记录一些运行时的信息
	            this.options = {
	                id: 'dnd-' + new Date().getTime(),
	                dragPre: false,
	                draging: false,
	                drop: null,                     // 当前可放置容器，drops则为设置的可放置容器
	                diffX: 0,                       // 记录鼠标点击离源节点的距离
	                diffY: 0,
	                dataTransfer: {},               // 存储拖放信息，在dragstart可设置，在drop中可读取
	                next: true                     // 标识是否可以执行下一次拖放。当使用动画时，动画结束后会释放proxy，而此时proxy元素可能已经改变
	            };
	
	            this.element = $(this.element);
	            if (this.element.length === 0) {
	                $.error('Dnd element error');
	            }
	            this.handle = $(this.handle);
	            if (this.handle.length === 0 || !$.contains(this.element[0], this.handle[0])) {
	                this.handle = this.element;
	            }
	            this.handle.css('cursor', 'move');
	
	            this.setup();
	        },
	
	        setup: function() {
	            this.handle.on('mousedown', $.proxy(this._handleMouseDown, this));
	            $(document).on('mousemove.' + this.options.id, $.proxy(this._handleMouseMove, this));
	            $(document).on('mouseup.' + this.options.id, $.proxy(this._handleMouseUp, this));
	        },
	
	        destroy: function() {
	            $(document).off('mousemove.' + this.options.id);
	            $(document).off('mouseup.' + this.options.id);
	            Dnd.superclass.destroy.call(this);
	        },
	
	        _handleMouseDown: function(evt) {
	            var proxy, diffX, diffY;
	
	            if (this.options.next) {
	                // 不允许拖放则返回
	                if (this.get('disabled')) return;
	
	                // 初始化proxy
	                if (!this.get('proxy')) {
	                    proxy = this.element.clone();
	                } else {
	                    proxy = this.get('proxy');
	                }
	
	                // 设置代理元素proxy，并将其插入element的父元素中
	                // 这样保证proxy的样式与源节点element一致
	                proxy.css({
	                    position: 'absolute',
	                    left: 0,
	                    top: 0,
	                    visibility: 'hidden'
	                });
	                proxy.appendTo(this.element.parent());
	
	                // 使代理元素定位到element处
	                proxy.data('originx', proxy.offset().left);
	                proxy.data('originy', proxy.offset().top);
	                proxy.css({
	                    left: this.element.offset().left - proxy.data('originx'),
	                    top: this.element.offset().top - proxy.data('originy'),
	                    width: this.element.width(),
	                    height: this.element.height()
	                });
	
	                // 记录鼠标点击位置与源节点element的距离
	                diffX = evt.pageX - this.element.offset().left;
	                diffY = evt.pageY - this.element.offset().top;
	
	                $.extend(this.options, {
	                    dragPre: true,
	                    proxy: proxy,
	                    diffX: diffX,
	                    diffY: diffY
	                });
	            }
	
	            if (this.options.dragPre) {
	                evt.preventDefault();
	            }
	        },
	
	        _handleMouseMove: function(evt) {
	            if (this.options.dragPre) {
	                // 开始拖放
	                this._executeDragStart();
	            } else if (this.options.draging) {
	                // 根据边界和方向一起判断是否drag并执行
	                this._executeDrag({
	                    pageX: evt.pageX,
	                    pageY: evt.pageY
	                });
	
	                // 根据proxy和可放置容器的相互位置来判断
	                // 是否要dragenter, dragleave和dragover并执行
	                this._executeDragEnterLeaveOver();
	
	                // 阻止默认选中文本
	                evt.preventDefault();
	            }
	        },
	
	        _handleMouseUp: function(evt) {
	            var options = this.options;
	            if (options.dragPre) {
	                // 点击而非拖放
	                options.proxy.remove();
	                options.proxy = null;
	                options.dragPre = false;
	            } else if (options.draging) {
	                options.draging = false;
	                options.next = false;
	                options.proxy.css('cursor', 'default');
	                options.proxy.focus();
	
	                // 根据当前的可放置容器判断是否drop并执行
	                this._executeDrop();
	
	                // 根据revert属性判断是否要返回并执行
	                this._executeRevert();
	            }
	        },
	
	        // 鼠标拖动触发拖放
	        _executeDragStart: function() {
	            var visible = this.get('visible');
	            var dragCursor = this.get('dragCursor');
	            var zIndex = this.get('zIndex');
	            var options = this.options;
	
	            // 按照设置显示或隐藏element
	            if (!visible) {
	                this.element.css('visibility', 'hidden');
	            }
	
	            // 显示proxy
	            options.proxy.css({
	                'z-index': zIndex,
	                visibility: 'visible',
	                cursor: dragCursor
	            });
	            options.proxy.focus();
	
	            options.dataTransfer = {};
	            options.dragPre = false;
	            options.draging = true;
	            this.trigger('dragstart', options.dataTransfer, options.proxy);
	        },
	
	        // 根据边界和方向一起判断是否drag并执行
	        _executeDrag: function(evt) {
	            var options = this.options;
	            var containment = this.get('containment');
	            var axis = this.get('axis');
	            var xleft = evt.pageX - options.diffX;
	            var xtop = evt.pageY - options.diffY;
	            var originx = options.proxy.data('originx');
	            var originy = options.proxy.data('originy');
	            var offset = containment.offset();
	
	            // containment is document
	            // 不用 === 是因为 jquery 版本不同，返回值也不同
	            if (!offset) {
	                offset = {left:0, top:0};
	            }
	
	            // 是否在x方向上移动并执行
	            if (axis !== 'y') {
	                if (xleft >= offset.left &&
	                    (xleft + options.proxy.outerWidth()) <= (offset.left + containment.outerWidth())) {
	                    options.proxy.css('left', xleft - originx);
	                } else {
	                    if (xleft <= offset.left) {
	                        options.proxy.css('left', offset.left - originx);
	                    } else {
	                        options.proxy.css('left',
	                            offset.left + containment.outerWidth() -
	                            options.proxy.outerWidth() - originx);
	                    }
	                }
	            }
	
	            // 是否在y方向上移动并执行
	            if (axis !== 'x') {
	                if (xtop >= offset.top &&
	                    (xtop + options.proxy.outerHeight()) <= (offset.top + containment.outerHeight())) {
	                    options.proxy.css('top', xtop - originy);
	                } else {
	                    if (xtop <= offset.top) {
	                        options.proxy.css('top', offset.top - originy);
	                    } else {
	                        options.proxy.css('top',
	                            offset.top + containment.outerHeight() -
	                            options.proxy.outerHeight() - originy);
	                    }
	                }
	            }
	
	            this.trigger('drag', options.proxy, options.drop);
	        },
	
	        // 根据proxy和可放置容器的相互位置来判断是否dragenter, dragleave和dragover并执行
	        _executeDragEnterLeaveOver: function() {
	            var self = this;
	            var options = this.options;
	            var drops = this.get('drops');
	            var dragCursor = this.get('dragCursor');
	            var dropCursor = this.get('dropCursor');
	            var xleft = options.proxy.offset().left + options.diffX;
	            var xtop = options.proxy.offset().top + options.diffY;
	
	            if (drops === null) {
	                return;
	            }
	
	            if (options.drop === null) {
	                $.each(drops, function (index, elem) {
	                    if (isContain(elem, xleft, xtop) === true) {
	                        options.proxy.css('cursor', dropCursor);
	                        options.proxy.focus();
	
	                        options.drop = $(elem);
	                        self.trigger('dragenter', options.proxy, options.drop);
	                        return false; // 跳出each
	                    }
	                });
	            } else {
	                if (isContain(options.drop, xleft, xtop) === false) {
	                    options.proxy.css('cursor', dragCursor);
	                    options.proxy.focus();
	
	                    self.trigger('dragleave', options.proxy, options.drop);
	                    options.drop = null;
	                } else {
	                    self.trigger('dragover', options.proxy, options.drop);
	                }
	            }
	        },
	
	        // 根据proxy和当前的可放置容器地相互位置判断是否drop并执行
	        // 当proxy不完全在drop内且不需要revert时，将proxy置于drop中央
	        _executeDrop: function() {
	            var options = this.options;
	            var revert = this.get('revert');
	            var originx = options.proxy.data('originx');
	            var originy = options.proxy.data('originy');
	
	            if (options.drop === null) {
	                return;
	            }
	
	            // 放置时不完全在drop中并且不需要返回的则放置中央
	            if (isContain(options.drop, options.proxy) === false && revert === false) {
	                options.proxy.css('left', options.drop.offset().left +
	                        (options.drop.outerWidth() - options.proxy.outerWidth()) / 2 - originx);
	                options.proxy.css('top', options.drop.offset().top +
	                        (options.drop.outerHeight() - options.proxy.outerHeight()) / 2 - originy);
	            }
	
	            this.trigger('drop', options.dataTransfer, options.proxy, options.drop);
	        },
	
	        // 根据revert判断是否要返回
	        // 若可放置容器drops不为null且当前可放置容器drop为null，则自动回到原处
	        // 处理完移除代理元素
	        _executeRevert: function() {
	            var self = this;
	            var options = this.options;
	            var drops = this.get('drops');
	            var revert = this.get('revert');
	            var revertDuration = this.get('revertDuration');
	            var visible = this.get('visible');
	            var zIndex = this.get('zIndex');
	            var xleft = options.proxy.offset().left - this.element.offset().left;
	            var xtop = options.proxy.offset().top -  this.element.offset().top;
	            var originx = options.proxy.data('originx');
	            var originy = options.proxy.data('originy');
	
	            if (revert || (options.drop === null && drops !== null)) {
	
	                //代理元素返回源节点初始位置
	                options.proxy.animate({
	                    left: this.element.offset().left - originx,
	                    top: this.element.offset().top - originy
	                }, revertDuration, function () {
	                    self.element.css('visibility', '');
	                    options.proxy.remove();
	                    options.proxy = null;
	
	                    // 触发dragend
	                    self.trigger('dragend', self.element, options.drop);
	                    options.drop = null;
	                    options.next = true;
	                });
	
	            } else {
	                // 源节点移动到代理元素处
	                if (this.element.css('position') === 'relative') {
	                    xleft = (isNaN(parseInt(this.element.css('left'), 10)) ? 0 :
	                        parseInt(this.element.css('left'), 10)) + xleft;
	                    xtop = (isNaN(parseInt(this.element.css('top'), 10)) ? 0 :
	                        parseInt(this.element.css('top'), 10)) + xtop;
	                } else if (this.element.css('position') === 'absolute') {
	                    xleft = options.proxy.offset().left - originx;
	                    xtop = options.proxy.offset().top - originy;
	                } else {
	                    this.element.css('position', 'relative');
	                }
	
	                if (visible === false) {
	                    this.element.css({
	                        left: xleft,
	                        top: xtop,
	                        visibility: '',
	                        'z-index': zIndex
	                    });
	                    options.proxy.remove();
	                    options.proxy = null;
	
	                    // 触发dragend
	                    this.trigger('dragend', this.element, options.drop);
	                    options.drop = null;
	                    options.next = true;
	
	                } else {
	                    // 源节点显示时，动画移动到代理元素处
	                    this.element.animate({
	                        left: xleft,
	                        top: xtop
	                    }, revertDuration, function () {
	                        options.proxy.remove();
	                        options.proxy = null;
	
	                        // 触发dragend
	                        self.trigger('dragend', self.element, self.drop);
	                        options.drop = null;
	                        options.next = true;
	                    });
	                }
	            }
	        }
	    });
	
	    /**
	     * 暴露该方法来批量初始化拖放元素
	     */
	    Dnd.initialize = function(elems, config) {
	        $(elems).each(function(i, elem) {
	            new Dnd($.extend({
	                element: elem
	            }, config));
	        });
	    };
	
	    // Helpers
	    // -------
	
	    /**
	     * 判断元素B是否位于元素A内部
	     * or 点(B, C)是否位于A内
	     */
	    function isContain(A, B, C) {
	        var offset = $(A).offset();
	
	        // A is document
	        if (!offset) {
	            offset = {left:0, top:0};
	        }
	
	        if (arguments.length === 2) {
	            return offset.left <= $(B).offset().left &&
	                offset.left + $(A).outerWidth() >=
	                $(B).offset().left + $(B).outerWidth() &&
	                offset.top <= $(B).offset().top &&
	                offset.top + $(A).outerHeight() >=
	                $(B).offset().top + $(B).outerHeight();
	        }
	        if (arguments.length === 3) {
	            return offset.left <= B &&
	                offset.left + $(A).outerWidth() >= B &&
	                offset.top <= C &&
	                offset.top + $(A).outerHeight() >= C;
	        }
	    }
	
	
	    return Dnd;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 84:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * 定位工具，将一个 DOM 节点相对另一个 DOM 节点进行定位操作.
	 *
	 * 原理：有需要定位的元素和基准元素两个对象，每个元素对象分别指定定位点，然后将定位点重合。
	 *
	 * 注意：IE8下，当文档流中定位元素在基准元素的相邻前方，并且不是body的第一个元素时，基准元素有可能会因为未reflow而导致margin-top失败，
	 * 所以要尽量避免定位元素与基准元素相邻并在其之前。
	 *
	 * @example
	 *
	 *      // 定位元素到可视区域左上角
	 *      // 后一个参数可以理解为偏移量
	 *      Position.pin(a, {x: 0, y: 0});
	 *
	 *      // 定位元素到基准元素位置向右偏移20px
	 *      Position.pin(a, {element: b, x: '20px', y: 0});
	 *
	 *      // 定位元素到基准元素下方20px的位置
	 *      Position.pin(a, {element: b, x: 0, y: '100%+20px'});
	 *
	 *      // 定位元素到基准元素正中央
	 *      Position.center(a, b);
	 *
	 *      // 定位元素到基准元素右方中间位置
	 *      Position.pin(a, {element: b, x: 'right', y: 'center'});
	 *      Position.pin(a, {element: b, x: '100%', y: '50%'});
	 *
	 *      // 定位元素到可视区域中央
	 *      Position.center(a);
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	    var $ = __webpack_require__(1);
	
	    var Position = {},
	        VIEWPORT = { _id: 'VIEWPORT', nodeType: 1 },
	        isPinFixed = false,
	        ua = (window.navigator.userAgent || "").toLowerCase(),
	        isIE6 = ua.indexOf("msie 6") !== -1;
	
	
	    // 将目标元素相对于基准元素进行定位
	    // 这是 Position 的基础方法，接收两个参数，分别描述了目标元素和基准元素的定位点
	    Position.pin = function(pinObject, baseObject) {
	
	        // 将两个参数转换成标准定位对象 { element: a, x: 0, y: 0 }
	        pinObject = normalize(pinObject);
	        baseObject = normalize(baseObject);
	
	        // if pinObject.element is not present
	        // https://github.com/aralejs/position/pull/11
	        if (pinObject.element === VIEWPORT ||
	                pinObject.element._id === 'VIEWPORT') {
	            return;
	        }
	
	        // 设定目标元素的 position 为绝对定位
	        // 若元素的初始 position 不为 absolute，会影响元素的 display、宽高等属性
	        var pinElement = $(pinObject.element);
	
	        if (pinElement.css('position') !== 'fixed' || isIE6) {
	            pinElement.css('position', 'absolute');
	            isPinFixed = false;
	        } else {
	            // 定位 fixed 元素的标志位，下面有特殊处理
	            isPinFixed = true;
	        }
	
	        // 将位置属性归一化为数值
	        // 注：必须放在上面这句 `css('position', 'absolute')` 之后，
	        //    否则获取的宽高有可能不对
	        posConverter(pinObject);
	        posConverter(baseObject);
	
	        var parentOffset = getParentOffset(pinElement);
	        var baseOffset = baseObject.offset();
	
	        // 计算目标元素的位置
	        var top = baseOffset.top + baseObject.y -
	                pinObject.y - parentOffset.top;
	
	        var left = baseOffset.left + baseObject.x -
	                pinObject.x - parentOffset.left;
	
	        // 定位目标元素
	        pinElement.css({ left: Math.max(left, 0), top: Math.max(top, 0) });
	    };
	
	
	    // 将目标元素相对于基准元素进行居中定位
	    // 接受两个参数，分别为目标元素和定位的基准元素，都是 DOM 节点类型
	    Position.center = function(pinElement, baseElement) {
	        Position.pin({
	            element: pinElement,
	            x: '50%',
	            y: '50%'
	        }, {
	            element: baseElement,
	            x: '50%',
	            y: '50%'
	        });
	    };
	
	
	    // 这是当前可视区域的伪 DOM 节点
	    // 需要相对于当前可视区域定位时，可传入此对象作为 element 参数
	    Position.VIEWPORT = VIEWPORT;
	
	
	    // Helpers
	    // -------
	
	    // 将参数包装成标准的定位对象，形似 { element: a, x: 0, y: 0 }
	    function normalize(posObject) {
	        posObject = toElement(posObject) || {};
	
	        if (posObject.nodeType) {
	            posObject = { element: posObject };
	        }
	
	        var element = toElement(posObject.element) || VIEWPORT;
	        if (element.nodeType !== 1) {
	            throw new Error('posObject.element is invalid.');
	        }
	
	        var result = {
	            element: element,
	            x: posObject.x || 0,
	            y: posObject.y || 0
	        };
	
	        // config 的深度克隆会替换掉 Position.VIEWPORT, 导致直接比较为 false
	        var isVIEWPORT = (element === VIEWPORT || element._id === 'VIEWPORT');
	
	        // 归一化 offset
	        result.offset = function() {
	            // 若定位 fixed 元素，则父元素的 offset 没有意义
	            if (isPinFixed) {
	                return {
	                    left: 0,
	                    top: 0
	                };
	            } else if (isVIEWPORT) {
	                return {
	                    left: $(document).scrollLeft(),
	                    top: $(document).scrollTop()
	                };
	            } else {
	                return getOffset($(element)[0]);
	            }
	        };
	
	        // 归一化 size, 含 padding 和 border
	        result.size = function() {
	            var el = isVIEWPORT ? $(window) : $(element);
	            return {
	                width: el.outerWidth(),
	                height: el.outerHeight()
	            };
	        };
	
	        return result;
	    }
	
	    // 对 x, y 两个参数为 left|center|right|%|px 时的处理，全部处理为纯数字
	    function posConverter(pinObject) {
	        pinObject.x = xyConverter(pinObject.x, pinObject, 'width');
	        pinObject.y = xyConverter(pinObject.y, pinObject, 'height');
	    }
	
	    // 处理 x, y 值，都转化为数字
	    function xyConverter(x, pinObject, type) {
	        // 先转成字符串再说！好处理
	        x = x + '';
	
	        // 处理 px
	        x = x.replace(/px/gi, '');
	
	        // 处理 alias
	        if (/\D/.test(x)) {
	            x = x.replace(/(?:top|left)/gi, '0%')
	                    .replace(/center/gi, '50%')
	                    .replace(/(?:bottom|right)/gi, '100%');
	        }
	
	        // 将百分比转为像素值
	        if (x.indexOf('%') !== -1) {
	            //支持小数
	            x = x.replace(/(\d+(?:\.\d+)?)%/gi, function(m, d) {
	                return pinObject.size()[type] * (d / 100.0);
	            });
	        }
	
	        // 处理类似 100%+20px 的情况
	        if (/[+\-*\/]/.test(x)) {
	            try {
	                // eval 会影响压缩
	                // new Function 方法效率高于 for 循环拆字符串的方法
	                // 参照：http://jsperf.com/eval-newfunction-for
	                x = (new Function('return ' + x))();
	            } catch (e) {
	                throw new Error('Invalid position value: ' + x);
	            }
	        }
	
	        // 转回为数字
	        return numberize(x);
	    }
	
	    // 获取 offsetParent 的位置
	    function getParentOffset(element) {
	        var parent = element.offsetParent();
	
	        // IE7 下，body 子节点的 offsetParent 为 html 元素，其 offset 为
	        // { top: 2, left: 2 }，会导致定位差 2 像素，所以这里将 parent
	        // 转为 document.body
	        if (parent[0] === document.documentElement) {
	            parent = $(document.body);
	        }
	
	        // 修正 ie6 下 absolute 定位不准的 bug
	        if (isIE6) {
	            parent.css('zoom', 1);
	        }
	
	        // 获取 offsetParent 的 offset
	        var offset;
	
	        // 当 offsetParent 为 body，
	        // 而且 body 的 position 是 static 时
	        // 元素并不按照 body 来定位，而是按 document 定位
	        // http://jsfiddle.net/afc163/hN9Tc/2/
	        // 因此这里的偏移值直接设为 0 0
	        if (parent[0] === document.body &&
	                parent.css('position') === 'static') {
	            offset = { top:0, left: 0 };
	        } else {
	            offset = getOffset(parent[0]);
	        }
	
	        // 根据基准元素 offsetParent 的 border 宽度，来修正 offsetParent 的基准位置
	        offset.top += numberize(parent.css('border-top-width'));
	        offset.left += numberize(parent.css('border-left-width'));
	
	        return offset;
	    }
	
	    function numberize(s) {
	        return parseFloat(s, 10) || 0;
	    }
	
	    function toElement(element) {
	        return $(element)[0];
	    }
	
	    // fix jQuery 1.7.2 offset
	    // document.body 的 position 是 absolute 或 relative 时
	    // jQuery.offset 方法无法正确获取 body 的偏移值
	    //   -> http://jsfiddle.net/afc163/gMAcp/
	    // jQuery 1.9.1 已经修正了这个问题
	    //   -> http://jsfiddle.net/afc163/gMAcp/1/
	    // 这里先实现一份
	    // 参照 kissy 和 jquery 1.9.1
	    //   -> https://github.com/kissyteam/kissy/blob/master/src/dom/sub-modules/base/src/base/offset.js#L366
	    //   -> https://github.com/jquery/jquery/blob/1.9.1/src/offset.js#L28
	    function getOffset(element) {
	        var box = element.getBoundingClientRect(),
	            docElem = document.documentElement;
	
	        // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
	        return {
	            left: box.left + (window.pageXOffset || docElem.scrollLeft) -
	            (docElem.clientLeft || document.body.clientLeft  || 0),
	            top: box.top  + (window.pageYOffset || docElem.scrollTop) -
	            (docElem.clientTop || document.body.clientTop  || 0)
	        };
	    }
	
	    return Position;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 87:
/***/ function(module, exports) {

	/**
	 * @fileoverview
	 * - Using the 'QRCode for Javascript library'
	 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
	 * - this library has no dependencies.
	 * 
	 * @author davidshimjs
	 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
	 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
	 */
	var QRCode;
	
	(function () {
		//---------------------------------------------------------------------
		// QRCode for JavaScript
		//
		// Copyright (c) 2009 Kazuhiko Arase
		//
		// URL: http://www.d-project.com/
		//
		// Licensed under the MIT license:
		//   http://www.opensource.org/licenses/mit-license.php
		//
		// The word "QR Code" is registered trademark of 
		// DENSO WAVE INCORPORATED
		//   http://www.denso-wave.com/qrcode/faqpatent-e.html
		//
		//---------------------------------------------------------------------
		function QR8bitByte(data) {
			this.mode = QRMode.MODE_8BIT_BYTE;
			this.data = data;
			this.parsedData = [];
	
			// Added to support UTF-8 Characters
			for (var i = 0, l = this.data.length; i < l; i++) {
				var byteArray = [];
				var code = this.data.charCodeAt(i);
	
				if (code > 0x10000) {
					byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
					byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
					byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
					byteArray[3] = 0x80 | (code & 0x3F);
				} else if (code > 0x800) {
					byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
					byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
					byteArray[2] = 0x80 | (code & 0x3F);
				} else if (code > 0x80) {
					byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
					byteArray[1] = 0x80 | (code & 0x3F);
				} else {
					byteArray[0] = code;
				}
	
				this.parsedData.push(byteArray);
			}
	
			this.parsedData = Array.prototype.concat.apply([], this.parsedData);
	
			if (this.parsedData.length != this.data.length) {
				this.parsedData.unshift(191);
				this.parsedData.unshift(187);
				this.parsedData.unshift(239);
			}
		}
	
		QR8bitByte.prototype = {
			getLength: function (buffer) {
				return this.parsedData.length;
			},
			write: function (buffer) {
				for (var i = 0, l = this.parsedData.length; i < l; i++) {
					buffer.put(this.parsedData[i], 8);
				}
			}
		};
	
		function QRCodeModel(typeNumber, errorCorrectLevel) {
			this.typeNumber = typeNumber;
			this.errorCorrectLevel = errorCorrectLevel;
			this.modules = null;
			this.moduleCount = 0;
			this.dataCache = null;
			this.dataList = [];
		}
	
		QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
		return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
		this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
		if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
		this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
		return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
		return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
		this.modules[r][6]=(r%2==0);}
		for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
		this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
		for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
		for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
		for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
		this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
		var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
		this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
		row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
		var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
		if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
		+buffer.getLengthInBits()
		+">"
		+totalDataCount*8
		+")");}
		if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
		while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
		while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
		buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
		buffer.put(QRCodeModel.PAD1,8);}
		return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
		offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
		var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
		var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
		for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
		return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
		return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
		return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
		return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
		return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
		for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
		if(r==0&&c==0){continue;}
		if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
		if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
		for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
		for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
		for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
		var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
		var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
		return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
		while(n>=256){n-=255;}
		return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
		for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
		for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
		function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
		var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
		this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
		QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
		return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
		var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
		for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
		return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
		QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
		var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
		return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
		QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
		if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
		this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];
		
		function _isSupportCanvas() {
			return typeof CanvasRenderingContext2D != "undefined";
		}
		
		// android 2.x doesn't support Data-URI spec
		function _getAndroid() {
			var android = false;
			var sAgent = navigator.userAgent;
			
			if (/android/i.test(sAgent)) { // android
				android = true;
				var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
				
				if (aMat && aMat[1]) {
					android = parseFloat(aMat[1]);
				}
			}
			
			return android;
		}
		
		var svgDrawer = (function() {
	
			var Drawing = function (el, htOption) {
				this._el = el;
				this._htOption = htOption;
			};
	
			Drawing.prototype.draw = function (oQRCode) {
				var _htOption = this._htOption;
				var _el = this._el;
				var nCount = oQRCode.getModuleCount();
				var nWidth = Math.floor(_htOption.width / nCount);
				var nHeight = Math.floor(_htOption.height / nCount);
	
				this.clear();
	
				function makeSVG(tag, attrs) {
					var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
					for (var k in attrs)
						if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
					return el;
				}
	
				var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
				svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
				_el.appendChild(svg);
	
				svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
				svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));
	
				for (var row = 0; row < nCount; row++) {
					for (var col = 0; col < nCount; col++) {
						if (oQRCode.isDark(row, col)) {
							var child = makeSVG("use", {"x": String(col), "y": String(row)});
							child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
							svg.appendChild(child);
						}
					}
				}
			};
			Drawing.prototype.clear = function () {
				while (this._el.hasChildNodes())
					this._el.removeChild(this._el.lastChild);
			};
			return Drawing;
		})();
	
		var useSVG = document.documentElement.tagName.toLowerCase() === "svg";
	
		// Drawing in DOM by using Table tag
		var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
			var Drawing = function (el, htOption) {
				this._el = el;
				this._htOption = htOption;
			};
				
			/**
			 * Draw the QRCode
			 * 
			 * @param {QRCode} oQRCode
			 */
			Drawing.prototype.draw = function (oQRCode) {
	            var _htOption = this._htOption;
	            var _el = this._el;
				var nCount = oQRCode.getModuleCount();
				var nWidth = Math.floor(_htOption.width / nCount);
				var nHeight = Math.floor(_htOption.height / nCount);
				var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
				
				for (var row = 0; row < nCount; row++) {
					aHTML.push('<tr>');
					
					for (var col = 0; col < nCount; col++) {
						aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
					}
					
					aHTML.push('</tr>');
				}
				
				aHTML.push('</table>');
				_el.innerHTML = aHTML.join('');
				
				// Fix the margin values as real size.
				var elTable = _el.childNodes[0];
				var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
				var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
				
				if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
					elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";	
				}
			};
			
			/**
			 * Clear the QRCode
			 */
			Drawing.prototype.clear = function () {
				this._el.innerHTML = '';
			};
			
			return Drawing;
		})() : (function () { // Drawing in Canvas
			function _onMakeImage() {
				this._elImage.src = this._elCanvas.toDataURL("image/png");
				this._elImage.style.display = "block";
				this._elCanvas.style.display = "none";			
			}
			
			// Android 2.1 bug workaround
			// http://code.google.com/p/android/issues/detail?id=5141
			if (this._android && this._android <= 2.1) {
		    	var factor = 1 / window.devicePixelRatio;
		        var drawImage = CanvasRenderingContext2D.prototype.drawImage; 
		    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
		    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
			        	for (var i = arguments.length - 1; i >= 1; i--) {
			            	arguments[i] = arguments[i] * factor;
			        	}
		    		} else if (typeof dw == "undefined") {
		    			arguments[1] *= factor;
		    			arguments[2] *= factor;
		    			arguments[3] *= factor;
		    			arguments[4] *= factor;
		    		}
		    		
		        	drawImage.apply(this, arguments); 
		    	};
			}
			
			/**
			 * Check whether the user's browser supports Data URI or not
			 * 
			 * @private
			 * @param {Function} fSuccess Occurs if it supports Data URI
			 * @param {Function} fFail Occurs if it doesn't support Data URI
			 */
			function _safeSetDataURI(fSuccess, fFail) {
	            var self = this;
	            self._fFail = fFail;
	            self._fSuccess = fSuccess;
	
	            // Check it just once
	            if (self._bSupportDataURI === null) {
	                var el = document.createElement("img");
	                var fOnError = function() {
	                    self._bSupportDataURI = false;
	
	                    if (self._fFail) {
	                        self._fFail.call(self);
	                    }
	                };
	                var fOnSuccess = function() {
	                    self._bSupportDataURI = true;
	
	                    if (self._fSuccess) {
	                        self._fSuccess.call(self);
	                    }
	                };
	
	                el.onabort = fOnError;
	                el.onerror = fOnError;
	                el.onload = fOnSuccess;
	                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
	                return;
	            } else if (self._bSupportDataURI === true && self._fSuccess) {
	                self._fSuccess.call(self);
	            } else if (self._bSupportDataURI === false && self._fFail) {
	                self._fFail.call(self);
	            }
			};
			
			/**
			 * Drawing QRCode by using canvas
			 * 
			 * @constructor
			 * @param {HTMLElement} el
			 * @param {Object} htOption QRCode Options 
			 */
			var Drawing = function (el, htOption) {
	    		this._bIsPainted = false;
	    		this._android = _getAndroid();
			
				this._htOption = htOption;
				this._elCanvas = document.createElement("canvas");
				this._elCanvas.width = htOption.width;
				this._elCanvas.height = htOption.height;
				el.appendChild(this._elCanvas);
				this._el = el;
				this._oContext = this._elCanvas.getContext("2d");
				this._bIsPainted = false;
				this._elImage = document.createElement("img");
				this._elImage.alt = "Scan me!";
				this._elImage.style.display = "none";
				this._el.appendChild(this._elImage);
				this._bSupportDataURI = null;
			};
				
			/**
			 * Draw the QRCode
			 * 
			 * @param {QRCode} oQRCode 
			 */
			Drawing.prototype.draw = function (oQRCode) {
	            var _elImage = this._elImage;
	            var _oContext = this._oContext;
	            var _htOption = this._htOption;
	            
				var nCount = oQRCode.getModuleCount();
				var nWidth = _htOption.width / nCount;
				var nHeight = _htOption.height / nCount;
				var nRoundedWidth = Math.round(nWidth);
				var nRoundedHeight = Math.round(nHeight);
	
				_elImage.style.display = "none";
				this.clear();
				
				for (var row = 0; row < nCount; row++) {
					for (var col = 0; col < nCount; col++) {
						var bIsDark = oQRCode.isDark(row, col);
						var nLeft = col * nWidth;
						var nTop = row * nHeight;
						_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
						_oContext.lineWidth = 1;
						_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;					
						_oContext.fillRect(nLeft, nTop, nWidth, nHeight);
						
						// 안티 앨리어싱 방지 처리
						_oContext.strokeRect(
							Math.floor(nLeft) + 0.5,
							Math.floor(nTop) + 0.5,
							nRoundedWidth,
							nRoundedHeight
						);
						
						_oContext.strokeRect(
							Math.ceil(nLeft) - 0.5,
							Math.ceil(nTop) - 0.5,
							nRoundedWidth,
							nRoundedHeight
						);
					}
				}
				
				this._bIsPainted = true;
			};
				
			/**
			 * Make the image from Canvas if the browser supports Data URI.
			 */
			Drawing.prototype.makeImage = function () {
				if (this._bIsPainted) {
					_safeSetDataURI.call(this, _onMakeImage);
				}
			};
				
			/**
			 * Return whether the QRCode is painted or not
			 * 
			 * @return {Boolean}
			 */
			Drawing.prototype.isPainted = function () {
				return this._bIsPainted;
			};
			
			/**
			 * Clear the QRCode
			 */
			Drawing.prototype.clear = function () {
				this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
				this._bIsPainted = false;
			};
			
			/**
			 * @private
			 * @param {Number} nNumber
			 */
			Drawing.prototype.round = function (nNumber) {
				if (!nNumber) {
					return nNumber;
				}
				
				return Math.floor(nNumber * 1000) / 1000;
			};
			
			return Drawing;
		})();
		
		/**
		 * Get the type by string length
		 * 
		 * @private
		 * @param {String} sText
		 * @param {Number} nCorrectLevel
		 * @return {Number} type
		 */
		function _getTypeNumber(sText, nCorrectLevel) {			
			var nType = 1;
			var length = _getUTF8Length(sText);
			
			for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
				var nLimit = 0;
				
				switch (nCorrectLevel) {
					case QRErrorCorrectLevel.L :
						nLimit = QRCodeLimitLength[i][0];
						break;
					case QRErrorCorrectLevel.M :
						nLimit = QRCodeLimitLength[i][1];
						break;
					case QRErrorCorrectLevel.Q :
						nLimit = QRCodeLimitLength[i][2];
						break;
					case QRErrorCorrectLevel.H :
						nLimit = QRCodeLimitLength[i][3];
						break;
				}
				
				if (length <= nLimit) {
					break;
				} else {
					nType++;
				}
			}
			
			if (nType > QRCodeLimitLength.length) {
				throw new Error("Too long data");
			}
			
			return nType;
		}
	
		function _getUTF8Length(sText) {
			var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
			return replacedText.length + (replacedText.length != sText ? 3 : 0);
		}
		
		/**
		 * @class QRCode
		 * @constructor
		 * @example 
		 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
		 *
		 * @example
		 * var oQRCode = new QRCode("test", {
		 *    text : "http://naver.com",
		 *    width : 128,
		 *    height : 128
		 * });
		 * 
		 * oQRCode.clear(); // Clear the QRCode.
		 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
		 *
		 * @param {HTMLElement|String} el target element or 'id' attribute of element.
		 * @param {Object|String} vOption
		 * @param {String} vOption.text QRCode link data
		 * @param {Number} [vOption.width=256]
		 * @param {Number} [vOption.height=256]
		 * @param {String} [vOption.colorDark="#000000"]
		 * @param {String} [vOption.colorLight="#ffffff"]
		 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
		 */
		QRCode = function (el, vOption) {
			this._htOption = {
				width : 256, 
				height : 256,
				typeNumber : 4,
				colorDark : "#000000",
				colorLight : "#ffffff",
				correctLevel : QRErrorCorrectLevel.H
			};
			
			if (typeof vOption === 'string') {
				vOption	= {
					text : vOption
				};
			}
			
			// Overwrites options
			if (vOption) {
				for (var i in vOption) {
					this._htOption[i] = vOption[i];
				}
			}
			
			if (typeof el == "string") {
				el = document.getElementById(el);
			}
	
			if (this._htOption.useSVG) {
				Drawing = svgDrawer;
			}
			
			this._android = _getAndroid();
			this._el = el;
			this._oQRCode = null;
			this._oDrawing = new Drawing(this._el, this._htOption);
			
			if (this._htOption.text) {
				this.makeCode(this._htOption.text);	
			}
		};
		
		/**
		 * Make the QRCode
		 * 
		 * @param {String} sText link data
		 */
		QRCode.prototype.makeCode = function (sText) {
			this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
			this._oQRCode.addData(sText);
			this._oQRCode.make();
			this._el.title = sText;
			this._oDrawing.draw(this._oQRCode);			
			this.makeImage();
		};
		
		/**
		 * Make the Image from Canvas element
		 * - It occurs automatically
		 * - Android below 3 doesn't support Data-URI spec.
		 * 
		 * @private
		 */
		QRCode.prototype.makeImage = function () {
			if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
				this._oDrawing.makeImage();
			}
		};
		
		/**
		 * Clear the QRCode
		 */
		QRCode.prototype.clear = function () {
			this._oDrawing.clear();
		};
		
		/**
		 * @name QRCode.CorrectLevel
		 */
		QRCode.CorrectLevel = QRErrorCorrectLevel;
	})();
	
	module.exports = QRCode;
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = QRCode;

/***/ },

/***/ 467:
/***/ function(module, exports) {

	module.exports = "// Copyright (c) 2005  Tom Wu\n// All Rights Reserved.\n// See \"LICENSE\" for details.\n\n// Basic JavaScript BN library - subset useful for RSA encryption.\n\n// Bits per digit\nvar dbits;\n\n// JavaScript engine analysis\nvar canary = 0xdeadbeefcafe;\nvar j_lm = ((canary&0xffffff)==0xefcafe);\n\n// (public) Constructor\nfunction BigInteger(a,b,c) {\n  if(a != null)\n    if(\"number\" == typeof a) this.fromNumber(a,b,c);\n    else if(b == null && \"string\" != typeof a) this.fromString(a,256);\n    else this.fromString(a,b);\n}\n\n// return new, unset BigInteger\nfunction nbi() { return new BigInteger(null); }\n\n// am: Compute w_j += (x*this_i), propagate carries,\n// c is initial carry, returns final carry.\n// c < 3*dvalue, x < 2*dvalue, this_i < dvalue\n// We need to select the fastest one that works in this environment.\n\n// am1: use a single mult and divide to get the high bits,\n// max digit bits should be 26 because\n// max internal value = 2*dvalue^2-2*dvalue (< 2^53)\nfunction am1(i,x,w,j,c,n) {\n  while(--n >= 0) {\n    var v = x*this[i++]+w[j]+c;\n    c = Math.floor(v/0x4000000);\n    w[j++] = v&0x3ffffff;\n  }\n  return c;\n}\n// am2 avoids a big mult-and-extract completely.\n// Max digit bits should be <= 30 because we do bitwise ops\n// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)\nfunction am2(i,x,w,j,c,n) {\n  var xl = x&0x7fff, xh = x>>15;\n  while(--n >= 0) {\n    var l = this[i]&0x7fff;\n    var h = this[i++]>>15;\n    var m = xh*l+h*xl;\n    l = xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);\n    c = (l>>>30)+(m>>>15)+xh*h+(c>>>30);\n    w[j++] = l&0x3fffffff;\n  }\n  return c;\n}\n// Alternately, set max digit bits to 28 since some\n// browsers slow down when dealing with 32-bit numbers.\nfunction am3(i,x,w,j,c,n) {\n  var xl = x&0x3fff, xh = x>>14;\n  while(--n >= 0) {\n    var l = this[i]&0x3fff;\n    var h = this[i++]>>14;\n    var m = xh*l+h*xl;\n    l = xl*l+((m&0x3fff)<<14)+w[j]+c;\n    c = (l>>28)+(m>>14)+xh*h;\n    w[j++] = l&0xfffffff;\n  }\n  return c;\n}\nif(j_lm && (navigator.appName == \"Microsoft Internet Explorer\")) {\n  BigInteger.prototype.am = am2;\n  dbits = 30;\n}\nelse if(j_lm && (navigator.appName != \"Netscape\")) {\n  BigInteger.prototype.am = am1;\n  dbits = 26;\n}\nelse { // Mozilla/Netscape seems to prefer am3\n  BigInteger.prototype.am = am3;\n  dbits = 28;\n}\n\nBigInteger.prototype.DB = dbits;\nBigInteger.prototype.DM = ((1<<dbits)-1);\nBigInteger.prototype.DV = (1<<dbits);\n\nvar BI_FP = 52;\nBigInteger.prototype.FV = Math.pow(2,BI_FP);\nBigInteger.prototype.F1 = BI_FP-dbits;\nBigInteger.prototype.F2 = 2*dbits-BI_FP;\n\n// Digit conversions\nvar BI_RM = \"0123456789abcdefghijklmnopqrstuvwxyz\";\nvar BI_RC = new Array();\nvar rr,vv;\nrr = \"0\".charCodeAt(0);\nfor(vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;\nrr = \"a\".charCodeAt(0);\nfor(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;\nrr = \"A\".charCodeAt(0);\nfor(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;\n\nfunction int2char(n) { return BI_RM.charAt(n); }\nfunction intAt(s,i) {\n  var c = BI_RC[s.charCodeAt(i)];\n  return (c==null)?-1:c;\n}\n\n// (protected) copy this to r\nfunction bnpCopyTo(r) {\n  for(var i = this.t-1; i >= 0; --i) r[i] = this[i];\n  r.t = this.t;\n  r.s = this.s;\n}\n\n// (protected) set from integer value x, -DV <= x < DV\nfunction bnpFromInt(x) {\n  this.t = 1;\n  this.s = (x<0)?-1:0;\n  if(x > 0) this[0] = x;\n  else if(x < -1) this[0] = x+DV;\n  else this.t = 0;\n}\n\n// return bigint initialized to value\nfunction nbv(i) { var r = nbi(); r.fromInt(i); return r; }\n\n// (protected) set from string and radix\nfunction bnpFromString(s,b) {\n  var k;\n  if(b == 16) k = 4;\n  else if(b == 8) k = 3;\n  else if(b == 256) k = 8; // byte array\n  else if(b == 2) k = 1;\n  else if(b == 32) k = 5;\n  else if(b == 4) k = 2;\n  else { this.fromRadix(s,b); return; }\n  this.t = 0;\n  this.s = 0;\n  var i = s.length, mi = false, sh = 0;\n  while(--i >= 0) {\n    var x = (k==8)?s[i]&0xff:intAt(s,i);\n    if(x < 0) {\n      if(s.charAt(i) == \"-\") mi = true;\n      continue;\n    }\n    mi = false;\n    if(sh == 0)\n      this[this.t++] = x;\n    else if(sh+k > this.DB) {\n      this[this.t-1] |= (x&((1<<(this.DB-sh))-1))<<sh;\n      this[this.t++] = (x>>(this.DB-sh));\n    }\n    else\n      this[this.t-1] |= x<<sh;\n    sh += k;\n    if(sh >= this.DB) sh -= this.DB;\n  }\n  if(k == 8 && (s[0]&0x80) != 0) {\n    this.s = -1;\n    if(sh > 0) this[this.t-1] |= ((1<<(this.DB-sh))-1)<<sh;\n  }\n  this.clamp();\n  if(mi) BigInteger.ZERO.subTo(this,this);\n}\n\n// (protected) clamp off excess high words\nfunction bnpClamp() {\n  var c = this.s&this.DM;\n  while(this.t > 0 && this[this.t-1] == c) --this.t;\n}\n\n// (public) return string representation in given radix\nfunction bnToString(b) {\n  if(this.s < 0) return \"-\"+this.negate().toString(b);\n  var k;\n  if(b == 16) k = 4;\n  else if(b == 8) k = 3;\n  else if(b == 2) k = 1;\n  else if(b == 32) k = 5;\n  else if(b == 4) k = 2;\n  else return this.toRadix(b);\n  var km = (1<<k)-1, d, m = false, r = \"\", i = this.t;\n  var p = this.DB-(i*this.DB)%k;\n  if(i-- > 0) {\n    if(p < this.DB && (d = this[i]>>p) > 0) { m = true; r = int2char(d); }\n    while(i >= 0) {\n      if(p < k) {\n        d = (this[i]&((1<<p)-1))<<(k-p);\n        d |= this[--i]>>(p+=this.DB-k);\n      }\n      else {\n        d = (this[i]>>(p-=k))&km;\n        if(p <= 0) { p += this.DB; --i; }\n      }\n      if(d > 0) m = true;\n      if(m) r += int2char(d);\n    }\n  }\n  return m?r:\"0\";\n}\n\n// (public) -this\nfunction bnNegate() { var r = nbi(); BigInteger.ZERO.subTo(this,r); return r; }\n\n// (public) |this|\nfunction bnAbs() { return (this.s<0)?this.negate():this; }\n\n// (public) return + if this > a, - if this < a, 0 if equal\nfunction bnCompareTo(a) {\n  var r = this.s-a.s;\n  if(r != 0) return r;\n  var i = this.t;\n  r = i-a.t;\n  if(r != 0) return (this.s<0)?-r:r;\n  while(--i >= 0) if((r=this[i]-a[i]) != 0) return r;\n  return 0;\n}\n\n// returns bit length of the integer x\nfunction nbits(x) {\n  var r = 1, t;\n  if((t=x>>>16) != 0) { x = t; r += 16; }\n  if((t=x>>8) != 0) { x = t; r += 8; }\n  if((t=x>>4) != 0) { x = t; r += 4; }\n  if((t=x>>2) != 0) { x = t; r += 2; }\n  if((t=x>>1) != 0) { x = t; r += 1; }\n  return r;\n}\n\n// (public) return the number of bits in \"this\"\nfunction bnBitLength() {\n  if(this.t <= 0) return 0;\n  return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));\n}\n\n// (protected) r = this << n*DB\nfunction bnpDLShiftTo(n,r) {\n  var i;\n  for(i = this.t-1; i >= 0; --i) r[i+n] = this[i];\n  for(i = n-1; i >= 0; --i) r[i] = 0;\n  r.t = this.t+n;\n  r.s = this.s;\n}\n\n// (protected) r = this >> n*DB\nfunction bnpDRShiftTo(n,r) {\n  for(var i = n; i < this.t; ++i) r[i-n] = this[i];\n  r.t = Math.max(this.t-n,0);\n  r.s = this.s;\n}\n\n// (protected) r = this << n\nfunction bnpLShiftTo(n,r) {\n  var bs = n%this.DB;\n  var cbs = this.DB-bs;\n  var bm = (1<<cbs)-1;\n  var ds = Math.floor(n/this.DB), c = (this.s<<bs)&this.DM, i;\n  for(i = this.t-1; i >= 0; --i) {\n    r[i+ds+1] = (this[i]>>cbs)|c;\n    c = (this[i]&bm)<<bs;\n  }\n  for(i = ds-1; i >= 0; --i) r[i] = 0;\n  r[ds] = c;\n  r.t = this.t+ds+1;\n  r.s = this.s;\n  r.clamp();\n}\n\n// (protected) r = this >> n\nfunction bnpRShiftTo(n,r) {\n  r.s = this.s;\n  var ds = Math.floor(n/this.DB);\n  if(ds >= this.t) { r.t = 0; return; }\n  var bs = n%this.DB;\n  var cbs = this.DB-bs;\n  var bm = (1<<bs)-1;\n  r[0] = this[ds]>>bs;\n  for(var i = ds+1; i < this.t; ++i) {\n    r[i-ds-1] |= (this[i]&bm)<<cbs;\n    r[i-ds] = this[i]>>bs;\n  }\n  if(bs > 0) r[this.t-ds-1] |= (this.s&bm)<<cbs;\n  r.t = this.t-ds;\n  r.clamp();\n}\n\n// (protected) r = this - a\nfunction bnpSubTo(a,r) {\n  var i = 0, c = 0, m = Math.min(a.t,this.t);\n  while(i < m) {\n    c += this[i]-a[i];\n    r[i++] = c&this.DM;\n    c >>= this.DB;\n  }\n  if(a.t < this.t) {\n    c -= a.s;\n    while(i < this.t) {\n      c += this[i];\n      r[i++] = c&this.DM;\n      c >>= this.DB;\n    }\n    c += this.s;\n  }\n  else {\n    c += this.s;\n    while(i < a.t) {\n      c -= a[i];\n      r[i++] = c&this.DM;\n      c >>= this.DB;\n    }\n    c -= a.s;\n  }\n  r.s = (c<0)?-1:0;\n  if(c < -1) r[i++] = this.DV+c;\n  else if(c > 0) r[i++] = c;\n  r.t = i;\n  r.clamp();\n}\n\n// (protected) r = this * a, r != this,a (HAC 14.12)\n// \"this\" should be the larger one if appropriate.\nfunction bnpMultiplyTo(a,r) {\n  var x = this.abs(), y = a.abs();\n  var i = x.t;\n  r.t = i+y.t;\n  while(--i >= 0) r[i] = 0;\n  for(i = 0; i < y.t; ++i) r[i+x.t] = x.am(0,y[i],r,i,0,x.t);\n  r.s = 0;\n  r.clamp();\n  if(this.s != a.s) BigInteger.ZERO.subTo(r,r);\n}\n\n// (protected) r = this^2, r != this (HAC 14.16)\nfunction bnpSquareTo(r) {\n  var x = this.abs();\n  var i = r.t = 2*x.t;\n  while(--i >= 0) r[i] = 0;\n  for(i = 0; i < x.t-1; ++i) {\n    var c = x.am(i,x[i],r,2*i,0,1);\n    if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1)) >= x.DV) {\n      r[i+x.t] -= x.DV;\n      r[i+x.t+1] = 1;\n    }\n  }\n  if(r.t > 0) r[r.t-1] += x.am(i,x[i],r,2*i,0,1);\n  r.s = 0;\n  r.clamp();\n}\n\n// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)\n// r != q, this != m.  q or r may be null.\nfunction bnpDivRemTo(m,q,r) {\n  var pm = m.abs();\n  if(pm.t <= 0) return;\n  var pt = this.abs();\n  if(pt.t < pm.t) {\n    if(q != null) q.fromInt(0);\n    if(r != null) this.copyTo(r);\n    return;\n  }\n  if(r == null) r = nbi();\n  var y = nbi(), ts = this.s, ms = m.s;\n  var nsh = this.DB-nbits(pm[pm.t-1]);\t// normalize modulus\n  if(nsh > 0) { pm.lShiftTo(nsh,y); pt.lShiftTo(nsh,r); }\n  else { pm.copyTo(y); pt.copyTo(r); }\n  var ys = y.t;\n  var y0 = y[ys-1];\n  if(y0 == 0) return;\n  var yt = y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);\n  var d1 = this.FV/yt, d2 = (1<<this.F1)/yt, e = 1<<this.F2;\n  var i = r.t, j = i-ys, t = (q==null)?nbi():q;\n  y.dlShiftTo(j,t);\n  if(r.compareTo(t) >= 0) {\n    r[r.t++] = 1;\n    r.subTo(t,r);\n  }\n  BigInteger.ONE.dlShiftTo(ys,t);\n  t.subTo(y,y);\t// \"negative\" y so we can replace sub with am later\n  while(y.t < ys) y[y.t++] = 0;\n  while(--j >= 0) {\n    // Estimate quotient digit\n    var qd = (r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);\n    if((r[i]+=y.am(0,qd,r,j,0,ys)) < qd) {\t// Try it out\n      y.dlShiftTo(j,t);\n      r.subTo(t,r);\n      while(r[i] < --qd) r.subTo(t,r);\n    }\n  }\n  if(q != null) {\n    r.drShiftTo(ys,q);\n    if(ts != ms) BigInteger.ZERO.subTo(q,q);\n  }\n  r.t = ys;\n  r.clamp();\n  if(nsh > 0) r.rShiftTo(nsh,r);\t// Denormalize remainder\n  if(ts < 0) BigInteger.ZERO.subTo(r,r);\n}\n\n// (public) this mod a\nfunction bnMod(a) {\n  var r = nbi();\n  this.abs().divRemTo(a,null,r);\n  if(this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r,r);\n  return r;\n}\n\n// Modular reduction using \"classic\" algorithm\nfunction Classic(m) { this.m = m; }\nfunction cConvert(x) {\n  if(x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);\n  else return x;\n}\nfunction cRevert(x) { return x; }\nfunction cReduce(x) { x.divRemTo(this.m,null,x); }\nfunction cMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }\nfunction cSqrTo(x,r) { x.squareTo(r); this.reduce(r); }\n\nClassic.prototype.convert = cConvert;\nClassic.prototype.revert = cRevert;\nClassic.prototype.reduce = cReduce;\nClassic.prototype.mulTo = cMulTo;\nClassic.prototype.sqrTo = cSqrTo;\n\n// (protected) return \"-1/this % 2^DB\"; useful for Mont. reduction\n// justification:\n//         xy == 1 (mod m)\n//         xy =  1+km\n//   xy(2-xy) = (1+km)(1-km)\n// x[y(2-xy)] = 1-k^2m^2\n// x[y(2-xy)] == 1 (mod m^2)\n// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2\n// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.\n// JS multiply \"overflows\" differently from C/C++, so care is needed here.\nfunction bnpInvDigit() {\n  if(this.t < 1) return 0;\n  var x = this[0];\n  if((x&1) == 0) return 0;\n  var y = x&3;\t\t// y == 1/x mod 2^2\n  y = (y*(2-(x&0xf)*y))&0xf;\t// y == 1/x mod 2^4\n  y = (y*(2-(x&0xff)*y))&0xff;\t// y == 1/x mod 2^8\n  y = (y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;\t// y == 1/x mod 2^16\n  // last step - calculate inverse mod DV directly;\n  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints\n  y = (y*(2-x*y%this.DV))%this.DV;\t\t// y == 1/x mod 2^dbits\n  // we really want the negative inverse, and -DV < y < DV\n  return (y>0)?this.DV-y:-y;\n}\n\n// Montgomery reduction\nfunction Montgomery(m) {\n  this.m = m;\n  this.mp = m.invDigit();\n  this.mpl = this.mp&0x7fff;\n  this.mph = this.mp>>15;\n  this.um = (1<<(m.DB-15))-1;\n  this.mt2 = 2*m.t;\n}\n\n// xR mod m\nfunction montConvert(x) {\n  var r = nbi();\n  x.abs().dlShiftTo(this.m.t,r);\n  r.divRemTo(this.m,null,r);\n  if(x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r,r);\n  return r;\n}\n\n// x/R mod m\nfunction montRevert(x) {\n  var r = nbi();\n  x.copyTo(r);\n  this.reduce(r);\n  return r;\n}\n\n// x = x/R mod m (HAC 14.32)\nfunction montReduce(x) {\n  while(x.t <= this.mt2)\t// pad x so am has enough room later\n    x[x.t++] = 0;\n  for(var i = 0; i < this.m.t; ++i) {\n    // faster way of calculating u0 = x[i]*mp mod DV\n    var j = x[i]&0x7fff;\n    var u0 = (j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;\n    // use am to combine the multiply-shift-add into one call\n    j = i+this.m.t;\n    x[j] += this.m.am(0,u0,x,i,0,this.m.t);\n    // propagate carry\n    while(x[j] >= x.DV) { x[j] -= x.DV; x[++j]++; }\n  }\n  x.clamp();\n  x.drShiftTo(this.m.t,x);\n  if(x.compareTo(this.m) >= 0) x.subTo(this.m,x);\n}\n\n// r = \"x^2/R mod m\"; x != r\nfunction montSqrTo(x,r) { x.squareTo(r); this.reduce(r); }\n\n// r = \"xy/R mod m\"; x,y != r\nfunction montMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }\n\nMontgomery.prototype.convert = montConvert;\nMontgomery.prototype.revert = montRevert;\nMontgomery.prototype.reduce = montReduce;\nMontgomery.prototype.mulTo = montMulTo;\nMontgomery.prototype.sqrTo = montSqrTo;\n\n// (protected) true iff this is even\nfunction bnpIsEven() { return ((this.t>0)?(this[0]&1):this.s) == 0; }\n\n// (protected) this^e, e < 2^32, doing sqr and mul with \"r\" (HAC 14.79)\nfunction bnpExp(e,z) {\n  if(e > 0xffffffff || e < 1) return BigInteger.ONE;\n  var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e)-1;\n  g.copyTo(r);\n  while(--i >= 0) {\n    z.sqrTo(r,r2);\n    if((e&(1<<i)) > 0) z.mulTo(r2,g,r);\n    else { var t = r; r = r2; r2 = t; }\n  }\n  return z.revert(r);\n}\n\n// (public) this^e % m, 0 <= e < 2^32\nfunction bnModPowInt(e,m) {\n  var z;\n  if(e < 256 || m.isEven()) z = new Classic(m); else z = new Montgomery(m);\n  return this.exp(e,z);\n}\n\n// protected\nBigInteger.prototype.copyTo = bnpCopyTo;\nBigInteger.prototype.fromInt = bnpFromInt;\nBigInteger.prototype.fromString = bnpFromString;\nBigInteger.prototype.clamp = bnpClamp;\nBigInteger.prototype.dlShiftTo = bnpDLShiftTo;\nBigInteger.prototype.drShiftTo = bnpDRShiftTo;\nBigInteger.prototype.lShiftTo = bnpLShiftTo;\nBigInteger.prototype.rShiftTo = bnpRShiftTo;\nBigInteger.prototype.subTo = bnpSubTo;\nBigInteger.prototype.multiplyTo = bnpMultiplyTo;\nBigInteger.prototype.squareTo = bnpSquareTo;\nBigInteger.prototype.divRemTo = bnpDivRemTo;\nBigInteger.prototype.invDigit = bnpInvDigit;\nBigInteger.prototype.isEven = bnpIsEven;\nBigInteger.prototype.exp = bnpExp;\n\n// public\nBigInteger.prototype.toString = bnToString;\nBigInteger.prototype.negate = bnNegate;\nBigInteger.prototype.abs = bnAbs;\nBigInteger.prototype.compareTo = bnCompareTo;\nBigInteger.prototype.bitLength = bnBitLength;\nBigInteger.prototype.mod = bnMod;\nBigInteger.prototype.modPowInt = bnModPowInt;\n\n// \"constants\"\nBigInteger.ZERO = nbv(0);\nBigInteger.ONE = nbv(1);\n"

/***/ },

/***/ 468:
/***/ function(module, exports) {

	module.exports = "// Copyright (c) 2005-2009  Tom Wu\n// All Rights Reserved.\n// See \"LICENSE\" for details.\n\n// Extended JavaScript BN functions, required for RSA private ops.\n\n// Version 1.1: new BigInteger(\"0\", 10) returns \"proper\" zero\n// Version 1.2: square() API, isProbablePrime fix\n\n// (public)\nfunction bnClone() { var r = nbi(); this.copyTo(r); return r; }\n\n// (public) return value as integer\nfunction bnIntValue() {\n  if(this.s < 0) {\n    if(this.t == 1) return this[0]-this.DV;\n    else if(this.t == 0) return -1;\n  }\n  else if(this.t == 1) return this[0];\n  else if(this.t == 0) return 0;\n  // assumes 16 < DB < 32\n  return ((this[1]&((1<<(32-this.DB))-1))<<this.DB)|this[0];\n}\n\n// (public) return value as byte\nfunction bnByteValue() { return (this.t==0)?this.s:(this[0]<<24)>>24; }\n\n// (public) return value as short (assumes DB>=16)\nfunction bnShortValue() { return (this.t==0)?this.s:(this[0]<<16)>>16; }\n\n// (protected) return x s.t. r^x < DV\nfunction bnpChunkSize(r) { return Math.floor(Math.LN2*this.DB/Math.log(r)); }\n\n// (public) 0 if this == 0, 1 if this > 0\nfunction bnSigNum() {\n  if(this.s < 0) return -1;\n  else if(this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0;\n  else return 1;\n}\n\n// (protected) convert to radix string\nfunction bnpToRadix(b) {\n  if(b == null) b = 10;\n  if(this.signum() == 0 || b < 2 || b > 36) return \"0\";\n  var cs = this.chunkSize(b);\n  var a = Math.pow(b,cs);\n  var d = nbv(a), y = nbi(), z = nbi(), r = \"\";\n  this.divRemTo(d,y,z);\n  while(y.signum() > 0) {\n    r = (a+z.intValue()).toString(b).substr(1) + r;\n    y.divRemTo(d,y,z);\n  }\n  return z.intValue().toString(b) + r;\n}\n\n// (protected) convert from radix string\nfunction bnpFromRadix(s,b) {\n  this.fromInt(0);\n  if(b == null) b = 10;\n  var cs = this.chunkSize(b);\n  var d = Math.pow(b,cs), mi = false, j = 0, w = 0;\n  for(var i = 0; i < s.length; ++i) {\n    var x = intAt(s,i);\n    if(x < 0) {\n      if(s.charAt(i) == \"-\" && this.signum() == 0) mi = true;\n      continue;\n    }\n    w = b*w+x;\n    if(++j >= cs) {\n      this.dMultiply(d);\n      this.dAddOffset(w,0);\n      j = 0;\n      w = 0;\n    }\n  }\n  if(j > 0) {\n    this.dMultiply(Math.pow(b,j));\n    this.dAddOffset(w,0);\n  }\n  if(mi) BigInteger.ZERO.subTo(this,this);\n}\n\n// (protected) alternate constructor\nfunction bnpFromNumber(a,b,c) {\n  if(\"number\" == typeof b) {\n    // new BigInteger(int,int,RNG)\n    if(a < 2) this.fromInt(1);\n    else {\n      this.fromNumber(a,c);\n      if(!this.testBit(a-1))\t// force MSB set\n        this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this);\n      if(this.isEven()) this.dAddOffset(1,0); // force odd\n      while(!this.isProbablePrime(b)) {\n        this.dAddOffset(2,0);\n        if(this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a-1),this);\n      }\n    }\n  }\n  else {\n    // new BigInteger(int,RNG)\n    var x = new Array(), t = a&7;\n    x.length = (a>>3)+1;\n    b.nextBytes(x);\n    if(t > 0) x[0] &= ((1<<t)-1); else x[0] = 0;\n    this.fromString(x,256);\n  }\n}\n\n// (public) convert to bigendian byte array\nfunction bnToByteArray() {\n  var i = this.t, r = new Array();\n  r[0] = this.s;\n  var p = this.DB-(i*this.DB)%8, d, k = 0;\n  if(i-- > 0) {\n    if(p < this.DB && (d = this[i]>>p) != (this.s&this.DM)>>p)\n      r[k++] = d|(this.s<<(this.DB-p));\n    while(i >= 0) {\n      if(p < 8) {\n        d = (this[i]&((1<<p)-1))<<(8-p);\n        d |= this[--i]>>(p+=this.DB-8);\n      }\n      else {\n        d = (this[i]>>(p-=8))&0xff;\n        if(p <= 0) { p += this.DB; --i; }\n      }\n      if((d&0x80) != 0) d |= -256;\n      if(k == 0 && (this.s&0x80) != (d&0x80)) ++k;\n      if(k > 0 || d != this.s) r[k++] = d;\n    }\n  }\n  return r;\n}\n\nfunction bnEquals(a) { return(this.compareTo(a)==0); }\nfunction bnMin(a) { return(this.compareTo(a)<0)?this:a; }\nfunction bnMax(a) { return(this.compareTo(a)>0)?this:a; }\n\n// (protected) r = this op a (bitwise)\nfunction bnpBitwiseTo(a,op,r) {\n  var i, f, m = Math.min(a.t,this.t);\n  for(i = 0; i < m; ++i) r[i] = op(this[i],a[i]);\n  if(a.t < this.t) {\n    f = a.s&this.DM;\n    for(i = m; i < this.t; ++i) r[i] = op(this[i],f);\n    r.t = this.t;\n  }\n  else {\n    f = this.s&this.DM;\n    for(i = m; i < a.t; ++i) r[i] = op(f,a[i]);\n    r.t = a.t;\n  }\n  r.s = op(this.s,a.s);\n  r.clamp();\n}\n\n// (public) this & a\nfunction op_and(x,y) { return x&y; }\nfunction bnAnd(a) { var r = nbi(); this.bitwiseTo(a,op_and,r); return r; }\n\n// (public) this | a\nfunction op_or(x,y) { return x|y; }\nfunction bnOr(a) { var r = nbi(); this.bitwiseTo(a,op_or,r); return r; }\n\n// (public) this ^ a\nfunction op_xor(x,y) { return x^y; }\nfunction bnXor(a) { var r = nbi(); this.bitwiseTo(a,op_xor,r); return r; }\n\n// (public) this & ~a\nfunction op_andnot(x,y) { return x&~y; }\nfunction bnAndNot(a) { var r = nbi(); this.bitwiseTo(a,op_andnot,r); return r; }\n\n// (public) ~this\nfunction bnNot() {\n  var r = nbi();\n  for(var i = 0; i < this.t; ++i) r[i] = this.DM&~this[i];\n  r.t = this.t;\n  r.s = ~this.s;\n  return r;\n}\n\n// (public) this << n\nfunction bnShiftLeft(n) {\n  var r = nbi();\n  if(n < 0) this.rShiftTo(-n,r); else this.lShiftTo(n,r);\n  return r;\n}\n\n// (public) this >> n\nfunction bnShiftRight(n) {\n  var r = nbi();\n  if(n < 0) this.lShiftTo(-n,r); else this.rShiftTo(n,r);\n  return r;\n}\n\n// return index of lowest 1-bit in x, x < 2^31\nfunction lbit(x) {\n  if(x == 0) return -1;\n  var r = 0;\n  if((x&0xffff) == 0) { x >>= 16; r += 16; }\n  if((x&0xff) == 0) { x >>= 8; r += 8; }\n  if((x&0xf) == 0) { x >>= 4; r += 4; }\n  if((x&3) == 0) { x >>= 2; r += 2; }\n  if((x&1) == 0) ++r;\n  return r;\n}\n\n// (public) returns index of lowest 1-bit (or -1 if none)\nfunction bnGetLowestSetBit() {\n  for(var i = 0; i < this.t; ++i)\n    if(this[i] != 0) return i*this.DB+lbit(this[i]);\n  if(this.s < 0) return this.t*this.DB;\n  return -1;\n}\n\n// return number of 1 bits in x\nfunction cbit(x) {\n  var r = 0;\n  while(x != 0) { x &= x-1; ++r; }\n  return r;\n}\n\n// (public) return number of set bits\nfunction bnBitCount() {\n  var r = 0, x = this.s&this.DM;\n  for(var i = 0; i < this.t; ++i) r += cbit(this[i]^x);\n  return r;\n}\n\n// (public) true iff nth bit is set\nfunction bnTestBit(n) {\n  var j = Math.floor(n/this.DB);\n  if(j >= this.t) return(this.s!=0);\n  return((this[j]&(1<<(n%this.DB)))!=0);\n}\n\n// (protected) this op (1<<n)\nfunction bnpChangeBit(n,op) {\n  var r = BigInteger.ONE.shiftLeft(n);\n  this.bitwiseTo(r,op,r);\n  return r;\n}\n\n// (public) this | (1<<n)\nfunction bnSetBit(n) { return this.changeBit(n,op_or); }\n\n// (public) this & ~(1<<n)\nfunction bnClearBit(n) { return this.changeBit(n,op_andnot); }\n\n// (public) this ^ (1<<n)\nfunction bnFlipBit(n) { return this.changeBit(n,op_xor); }\n\n// (protected) r = this + a\nfunction bnpAddTo(a,r) {\n  var i = 0, c = 0, m = Math.min(a.t,this.t);\n  while(i < m) {\n    c += this[i]+a[i];\n    r[i++] = c&this.DM;\n    c >>= this.DB;\n  }\n  if(a.t < this.t) {\n    c += a.s;\n    while(i < this.t) {\n      c += this[i];\n      r[i++] = c&this.DM;\n      c >>= this.DB;\n    }\n    c += this.s;\n  }\n  else {\n    c += this.s;\n    while(i < a.t) {\n      c += a[i];\n      r[i++] = c&this.DM;\n      c >>= this.DB;\n    }\n    c += a.s;\n  }\n  r.s = (c<0)?-1:0;\n  if(c > 0) r[i++] = c;\n  else if(c < -1) r[i++] = this.DV+c;\n  r.t = i;\n  r.clamp();\n}\n\n// (public) this + a\nfunction bnAdd(a) { var r = nbi(); this.addTo(a,r); return r; }\n\n// (public) this - a\nfunction bnSubtract(a) { var r = nbi(); this.subTo(a,r); return r; }\n\n// (public) this * a\nfunction bnMultiply(a) { var r = nbi(); this.multiplyTo(a,r); return r; }\n\n// (public) this^2\nfunction bnSquare() { var r = nbi(); this.squareTo(r); return r; }\n\n// (public) this / a\nfunction bnDivide(a) { var r = nbi(); this.divRemTo(a,r,null); return r; }\n\n// (public) this % a\nfunction bnRemainder(a) { var r = nbi(); this.divRemTo(a,null,r); return r; }\n\n// (public) [this/a,this%a]\nfunction bnDivideAndRemainder(a) {\n  var q = nbi(), r = nbi();\n  this.divRemTo(a,q,r);\n  return new Array(q,r);\n}\n\n// (protected) this *= n, this >= 0, 1 < n < DV\nfunction bnpDMultiply(n) {\n  this[this.t] = this.am(0,n-1,this,0,0,this.t);\n  ++this.t;\n  this.clamp();\n}\n\n// (protected) this += n << w words, this >= 0\nfunction bnpDAddOffset(n,w) {\n  if(n == 0) return;\n  while(this.t <= w) this[this.t++] = 0;\n  this[w] += n;\n  while(this[w] >= this.DV) {\n    this[w] -= this.DV;\n    if(++w >= this.t) this[this.t++] = 0;\n    ++this[w];\n  }\n}\n\n// A \"null\" reducer\nfunction NullExp() {}\nfunction nNop(x) { return x; }\nfunction nMulTo(x,y,r) { x.multiplyTo(y,r); }\nfunction nSqrTo(x,r) { x.squareTo(r); }\n\nNullExp.prototype.convert = nNop;\nNullExp.prototype.revert = nNop;\nNullExp.prototype.mulTo = nMulTo;\nNullExp.prototype.sqrTo = nSqrTo;\n\n// (public) this^e\nfunction bnPow(e) { return this.exp(e,new NullExp()); }\n\n// (protected) r = lower n words of \"this * a\", a.t <= n\n// \"this\" should be the larger one if appropriate.\nfunction bnpMultiplyLowerTo(a,n,r) {\n  var i = Math.min(this.t+a.t,n);\n  r.s = 0; // assumes a,this >= 0\n  r.t = i;\n  while(i > 0) r[--i] = 0;\n  var j;\n  for(j = r.t-this.t; i < j; ++i) r[i+this.t] = this.am(0,a[i],r,i,0,this.t);\n  for(j = Math.min(a.t,n); i < j; ++i) this.am(0,a[i],r,i,0,n-i);\n  r.clamp();\n}\n\n// (protected) r = \"this * a\" without lower n words, n > 0\n// \"this\" should be the larger one if appropriate.\nfunction bnpMultiplyUpperTo(a,n,r) {\n  --n;\n  var i = r.t = this.t+a.t-n;\n  r.s = 0; // assumes a,this >= 0\n  while(--i >= 0) r[i] = 0;\n  for(i = Math.max(n-this.t,0); i < a.t; ++i)\n    r[this.t+i-n] = this.am(n-i,a[i],r,0,0,this.t+i-n);\n  r.clamp();\n  r.drShiftTo(1,r);\n}\n\n// Barrett modular reduction\nfunction Barrett(m) {\n  // setup Barrett\n  this.r2 = nbi();\n  this.q3 = nbi();\n  BigInteger.ONE.dlShiftTo(2*m.t,this.r2);\n  this.mu = this.r2.divide(m);\n  this.m = m;\n}\n\nfunction barrettConvert(x) {\n  if(x.s < 0 || x.t > 2*this.m.t) return x.mod(this.m);\n  else if(x.compareTo(this.m) < 0) return x;\n  else { var r = nbi(); x.copyTo(r); this.reduce(r); return r; }\n}\n\nfunction barrettRevert(x) { return x; }\n\n// x = x mod m (HAC 14.42)\nfunction barrettReduce(x) {\n  x.drShiftTo(this.m.t-1,this.r2);\n  if(x.t > this.m.t+1) { x.t = this.m.t+1; x.clamp(); }\n  this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);\n  this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);\n  while(x.compareTo(this.r2) < 0) x.dAddOffset(1,this.m.t+1);\n  x.subTo(this.r2,x);\n  while(x.compareTo(this.m) >= 0) x.subTo(this.m,x);\n}\n\n// r = x^2 mod m; x != r\nfunction barrettSqrTo(x,r) { x.squareTo(r); this.reduce(r); }\n\n// r = x*y mod m; x,y != r\nfunction barrettMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }\n\nBarrett.prototype.convert = barrettConvert;\nBarrett.prototype.revert = barrettRevert;\nBarrett.prototype.reduce = barrettReduce;\nBarrett.prototype.mulTo = barrettMulTo;\nBarrett.prototype.sqrTo = barrettSqrTo;\n\n// (public) this^e % m (HAC 14.85)\nfunction bnModPow(e,m) {\n  var i = e.bitLength(), k, r = nbv(1), z;\n  if(i <= 0) return r;\n  else if(i < 18) k = 1;\n  else if(i < 48) k = 3;\n  else if(i < 144) k = 4;\n  else if(i < 768) k = 5;\n  else k = 6;\n  if(i < 8)\n    z = new Classic(m);\n  else if(m.isEven())\n    z = new Barrett(m);\n  else\n    z = new Montgomery(m);\n\n  // precomputation\n  var g = new Array(), n = 3, k1 = k-1, km = (1<<k)-1;\n  g[1] = z.convert(this);\n  if(k > 1) {\n    var g2 = nbi();\n    z.sqrTo(g[1],g2);\n    while(n <= km) {\n      g[n] = nbi();\n      z.mulTo(g2,g[n-2],g[n]);\n      n += 2;\n    }\n  }\n\n  var j = e.t-1, w, is1 = true, r2 = nbi(), t;\n  i = nbits(e[j])-1;\n  while(j >= 0) {\n    if(i >= k1) w = (e[j]>>(i-k1))&km;\n    else {\n      w = (e[j]&((1<<(i+1))-1))<<(k1-i);\n      if(j > 0) w |= e[j-1]>>(this.DB+i-k1);\n    }\n\n    n = k;\n    while((w&1) == 0) { w >>= 1; --n; }\n    if((i -= n) < 0) { i += this.DB; --j; }\n    if(is1) {\t// ret == 1, don't bother squaring or multiplying it\n      g[w].copyTo(r);\n      is1 = false;\n    }\n    else {\n      while(n > 1) { z.sqrTo(r,r2); z.sqrTo(r2,r); n -= 2; }\n      if(n > 0) z.sqrTo(r,r2); else { t = r; r = r2; r2 = t; }\n      z.mulTo(r2,g[w],r);\n    }\n\n    while(j >= 0 && (e[j]&(1<<i)) == 0) {\n      z.sqrTo(r,r2); t = r; r = r2; r2 = t;\n      if(--i < 0) { i = this.DB-1; --j; }\n    }\n  }\n  return z.revert(r);\n}\n\n// (public) gcd(this,a) (HAC 14.54)\nfunction bnGCD(a) {\n  var x = (this.s<0)?this.negate():this.clone();\n  var y = (a.s<0)?a.negate():a.clone();\n  if(x.compareTo(y) < 0) { var t = x; x = y; y = t; }\n  var i = x.getLowestSetBit(), g = y.getLowestSetBit();\n  if(g < 0) return x;\n  if(i < g) g = i;\n  if(g > 0) {\n    x.rShiftTo(g,x);\n    y.rShiftTo(g,y);\n  }\n  while(x.signum() > 0) {\n    if((i = x.getLowestSetBit()) > 0) x.rShiftTo(i,x);\n    if((i = y.getLowestSetBit()) > 0) y.rShiftTo(i,y);\n    if(x.compareTo(y) >= 0) {\n      x.subTo(y,x);\n      x.rShiftTo(1,x);\n    }\n    else {\n      y.subTo(x,y);\n      y.rShiftTo(1,y);\n    }\n  }\n  if(g > 0) y.lShiftTo(g,y);\n  return y;\n}\n\n// (protected) this % n, n < 2^26\nfunction bnpModInt(n) {\n  if(n <= 0) return 0;\n  var d = this.DV%n, r = (this.s<0)?n-1:0;\n  if(this.t > 0)\n    if(d == 0) r = this[0]%n;\n    else for(var i = this.t-1; i >= 0; --i) r = (d*r+this[i])%n;\n  return r;\n}\n\n// (public) 1/this % m (HAC 14.61)\nfunction bnModInverse(m) {\n  var ac = m.isEven();\n  if((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO;\n  var u = m.clone(), v = this.clone();\n  var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);\n  while(u.signum() != 0) {\n    while(u.isEven()) {\n      u.rShiftTo(1,u);\n      if(ac) {\n        if(!a.isEven() || !b.isEven()) { a.addTo(this,a); b.subTo(m,b); }\n        a.rShiftTo(1,a);\n      }\n      else if(!b.isEven()) b.subTo(m,b);\n      b.rShiftTo(1,b);\n    }\n    while(v.isEven()) {\n      v.rShiftTo(1,v);\n      if(ac) {\n        if(!c.isEven() || !d.isEven()) { c.addTo(this,c); d.subTo(m,d); }\n        c.rShiftTo(1,c);\n      }\n      else if(!d.isEven()) d.subTo(m,d);\n      d.rShiftTo(1,d);\n    }\n    if(u.compareTo(v) >= 0) {\n      u.subTo(v,u);\n      if(ac) a.subTo(c,a);\n      b.subTo(d,b);\n    }\n    else {\n      v.subTo(u,v);\n      if(ac) c.subTo(a,c);\n      d.subTo(b,d);\n    }\n  }\n  if(v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;\n  if(d.compareTo(m) >= 0) return d.subtract(m);\n  if(d.signum() < 0) d.addTo(m,d); else return d;\n  if(d.signum() < 0) return d.add(m); else return d;\n}\n\nvar lowprimes = [2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997];\nvar lplim = (1<<26)/lowprimes[lowprimes.length-1];\n\n// (public) test primality with certainty >= 1-.5^t\nfunction bnIsProbablePrime(t) {\n  var i, x = this.abs();\n  if(x.t == 1 && x[0] <= lowprimes[lowprimes.length-1]) {\n    for(i = 0; i < lowprimes.length; ++i)\n      if(x[0] == lowprimes[i]) return true;\n    return false;\n  }\n  if(x.isEven()) return false;\n  i = 1;\n  while(i < lowprimes.length) {\n    var m = lowprimes[i], j = i+1;\n    while(j < lowprimes.length && m < lplim) m *= lowprimes[j++];\n    m = x.modInt(m);\n    while(i < j) if(m%lowprimes[i++] == 0) return false;\n  }\n  return x.millerRabin(t);\n}\n\n// (protected) true if probably prime (HAC 4.24, Miller-Rabin)\nfunction bnpMillerRabin(t) {\n  var n1 = this.subtract(BigInteger.ONE);\n  var k = n1.getLowestSetBit();\n  if(k <= 0) return false;\n  var r = n1.shiftRight(k);\n  t = (t+1)>>1;\n  if(t > lowprimes.length) t = lowprimes.length;\n  var a = nbi();\n  for(var i = 0; i < t; ++i) {\n    //Pick bases at random, instead of starting at 2\n    a.fromInt(lowprimes[Math.floor(Math.random()*lowprimes.length)]);\n    var y = a.modPow(r,this);\n    if(y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {\n      var j = 1;\n      while(j++ < k && y.compareTo(n1) != 0) {\n        y = y.modPowInt(2,this);\n        if(y.compareTo(BigInteger.ONE) == 0) return false;\n      }\n      if(y.compareTo(n1) != 0) return false;\n    }\n  }\n  return true;\n}\n\n// protected\nBigInteger.prototype.chunkSize = bnpChunkSize;\nBigInteger.prototype.toRadix = bnpToRadix;\nBigInteger.prototype.fromRadix = bnpFromRadix;\nBigInteger.prototype.fromNumber = bnpFromNumber;\nBigInteger.prototype.bitwiseTo = bnpBitwiseTo;\nBigInteger.prototype.changeBit = bnpChangeBit;\nBigInteger.prototype.addTo = bnpAddTo;\nBigInteger.prototype.dMultiply = bnpDMultiply;\nBigInteger.prototype.dAddOffset = bnpDAddOffset;\nBigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;\nBigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;\nBigInteger.prototype.modInt = bnpModInt;\nBigInteger.prototype.millerRabin = bnpMillerRabin;\n\n// public\nBigInteger.prototype.clone = bnClone;\nBigInteger.prototype.intValue = bnIntValue;\nBigInteger.prototype.byteValue = bnByteValue;\nBigInteger.prototype.shortValue = bnShortValue;\nBigInteger.prototype.signum = bnSigNum;\nBigInteger.prototype.toByteArray = bnToByteArray;\nBigInteger.prototype.equals = bnEquals;\nBigInteger.prototype.min = bnMin;\nBigInteger.prototype.max = bnMax;\nBigInteger.prototype.and = bnAnd;\nBigInteger.prototype.or = bnOr;\nBigInteger.prototype.xor = bnXor;\nBigInteger.prototype.andNot = bnAndNot;\nBigInteger.prototype.not = bnNot;\nBigInteger.prototype.shiftLeft = bnShiftLeft;\nBigInteger.prototype.shiftRight = bnShiftRight;\nBigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;\nBigInteger.prototype.bitCount = bnBitCount;\nBigInteger.prototype.testBit = bnTestBit;\nBigInteger.prototype.setBit = bnSetBit;\nBigInteger.prototype.clearBit = bnClearBit;\nBigInteger.prototype.flipBit = bnFlipBit;\nBigInteger.prototype.add = bnAdd;\nBigInteger.prototype.subtract = bnSubtract;\nBigInteger.prototype.multiply = bnMultiply;\nBigInteger.prototype.divide = bnDivide;\nBigInteger.prototype.remainder = bnRemainder;\nBigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;\nBigInteger.prototype.modPow = bnModPow;\nBigInteger.prototype.modInverse = bnModInverse;\nBigInteger.prototype.pow = bnPow;\nBigInteger.prototype.gcd = bnGCD;\nBigInteger.prototype.isProbablePrime = bnIsProbablePrime;\n\n// JSBN-specific extension\nBigInteger.prototype.square = bnSquare;\n\n// BigInteger interfaces not implemented in jsbn:\n\n// BigInteger(int signum, byte[] magnitude)\n// double doubleValue()\n// float floatValue()\n// int hashCode()\n// long longValue()\n// static BigInteger valueOf(long val)\n"

/***/ },

/***/ 469:
/***/ function(module, exports) {

	module.exports = "// prng4.js - uses Arcfour as a PRNG\n\nfunction Arcfour() {\n  this.i = 0;\n  this.j = 0;\n  this.S = new Array();\n}\n\n// Initialize arcfour context from key, an array of ints, each from [0..255]\nfunction ARC4init(key) {\n  var i, j, t;\n  for(i = 0; i < 256; ++i)\n    this.S[i] = i;\n  j = 0;\n  for(i = 0; i < 256; ++i) {\n    j = (j + this.S[i] + key[i % key.length]) & 255;\n    t = this.S[i];\n    this.S[i] = this.S[j];\n    this.S[j] = t;\n  }\n  this.i = 0;\n  this.j = 0;\n}\n\nfunction ARC4next() {\n  var t;\n  this.i = (this.i + 1) & 255;\n  this.j = (this.j + this.S[this.i]) & 255;\n  t = this.S[this.i];\n  this.S[this.i] = this.S[this.j];\n  this.S[this.j] = t;\n  return this.S[(t + this.S[this.i]) & 255];\n}\n\nArcfour.prototype.init = ARC4init;\nArcfour.prototype.next = ARC4next;\n\n// Plug in your RNG constructor here\nfunction prng_newstate() {\n  return new Arcfour();\n}\n\n// Pool size must be a multiple of 4 and greater than 32.\n// An array of bytes the size of the pool will be passed to init()\nvar rng_psize = 256;\n"

/***/ },

/***/ 470:
/***/ function(module, exports) {

	module.exports = "// Random number generator - requires a PRNG backend, e.g. prng4.js\n\n// For best results, put code like\n// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>\n// in your main HTML document.\n\nvar rng_state;\nvar rng_pool;\nvar rng_pptr;\n\n// Mix in a 32-bit integer into the pool\nfunction rng_seed_int(x) {\n  rng_pool[rng_pptr++] ^= x & 255;\n  rng_pool[rng_pptr++] ^= (x >> 8) & 255;\n  rng_pool[rng_pptr++] ^= (x >> 16) & 255;\n  rng_pool[rng_pptr++] ^= (x >> 24) & 255;\n  if(rng_pptr >= rng_psize) rng_pptr -= rng_psize;\n}\n\n// Mix in the current time (w/milliseconds) into the pool\nfunction rng_seed_time() {\n  rng_seed_int(new Date().getTime());\n}\n\n// Initialize the pool with junk if needed.\nif(rng_pool == null) {\n  rng_pool = new Array();\n  rng_pptr = 0;\n  var t;\n  if(navigator.appName == \"Netscape\" && navigator.appVersion < \"5\" && window.crypto) {\n    // Extract entropy (256 bits) from NS4 RNG if available\n    var z = window.crypto.random(32);\n    for(t = 0; t < z.length; ++t)\n      rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;\n  }  \n  while(rng_pptr < rng_psize) {  // extract some randomness from Math.random()\n    t = Math.floor(65536 * Math.random());\n    rng_pool[rng_pptr++] = t >>> 8;\n    rng_pool[rng_pptr++] = t & 255;\n  }\n  rng_pptr = 0;\n  rng_seed_time();\n  //rng_seed_int(window.screenX);\n  //rng_seed_int(window.screenY);\n}\n\nfunction rng_get_byte() {\n  if(rng_state == null) {\n    rng_seed_time();\n    rng_state = prng_newstate();\n    rng_state.init(rng_pool);\n    for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)\n      rng_pool[rng_pptr] = 0;\n    rng_pptr = 0;\n    //rng_pool = null;\n  }\n  // TODO: allow reseeding after first request\n  return rng_state.next();\n}\n\nfunction rng_get_bytes(ba) {\n  var i;\n  for(i = 0; i < ba.length; ++i) ba[i] = rng_get_byte();\n}\n\nfunction SecureRandom() {}\n\nSecureRandom.prototype.nextBytes = rng_get_bytes;\n"

/***/ },

/***/ 471:
/***/ function(module, exports) {

	module.exports = "// Depends on jsbn.js and rng.js\n\n// Version 1.1: support utf-8 encoding in pkcs1pad2\n\n// convert a (hex) string to a bignum object\nfunction parseBigInt(str,r) {\n  return new BigInteger(str,r);\n}\n\nfunction linebrk(s,n) {\n  var ret = \"\";\n  var i = 0;\n  while(i + n < s.length) {\n    ret += s.substring(i,i+n) + \"\\n\";\n    i += n;\n  }\n  return ret + s.substring(i,s.length);\n}\n\nfunction byte2Hex(b) {\n  if(b < 0x10)\n    return \"0\" + b.toString(16);\n  else\n    return b.toString(16);\n}\n\n// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint\nfunction pkcs1pad2(s,n) {\n  if(n < s.length + 11) { // TODO: fix for utf-8\n    alert(\"Message too long for RSA\");\n    return null;\n  }\n  var ba = new Array();\n  var i = s.length - 1;\n  while(i >= 0 && n > 0) {\n    var c = s.charCodeAt(i--);\n    if(c < 128) { // encode using utf-8\n      ba[--n] = c;\n    }\n    else if((c > 127) && (c < 2048)) {\n      ba[--n] = (c & 63) | 128;\n      ba[--n] = (c >> 6) | 192;\n    }\n    else {\n      ba[--n] = (c & 63) | 128;\n      ba[--n] = ((c >> 6) & 63) | 128;\n      ba[--n] = (c >> 12) | 224;\n    }\n  }\n  ba[--n] = 0;\n  var rng = new SecureRandom();\n  var x = new Array();\n  while(n > 2) { // random non-zero pad\n    x[0] = 0;\n    while(x[0] == 0) rng.nextBytes(x);\n    ba[--n] = x[0];\n  }\n  ba[--n] = 2;\n  ba[--n] = 0;\n  return new BigInteger(ba);\n}\n\n// \"empty\" RSA key constructor\nfunction RSAKey() {\n  this.n = null;\n  this.e = 0;\n  this.d = null;\n  this.p = null;\n  this.q = null;\n  this.dmp1 = null;\n  this.dmq1 = null;\n  this.coeff = null;\n}\n\n// Set the public key fields N and e from hex strings\nfunction RSASetPublic(N,E) {\n  if(N != null && E != null && N.length > 0 && E.length > 0) {\n    this.n = parseBigInt(N,16);\n    this.e = parseInt(E,16);\n  }\n  else\n    alert(\"Invalid RSA public key\");\n}\n\n// Perform raw public operation on \"x\": return x^e (mod n)\nfunction RSADoPublic(x) {\n  return x.modPowInt(this.e, this.n);\n}\n\n// Return the PKCS#1 RSA encryption of \"text\" as an even-length hex string\nfunction RSAEncrypt(text) {\n  var m = pkcs1pad2(text,(this.n.bitLength()+7)>>3);\n  if(m == null) return null;\n  var c = this.doPublic(m);\n  if(c == null) return null;\n  var h = c.toString(16);\n  if((h.length & 1) == 0) return h; else return \"0\" + h;\n}\n\n// Return the PKCS#1 RSA encryption of \"text\" as a Base64-encoded string\n//function RSAEncryptB64(text) {\n//  var h = this.encrypt(text);\n//  if(h) return hex2b64(h); else return null;\n//}\n\n// protected\nRSAKey.prototype.doPublic = RSADoPublic;\n\n// public\nRSAKey.prototype.setPublic = RSASetPublic;\nRSAKey.prototype.encrypt = RSAEncrypt;\n//RSAKey.prototype.encrypt_b64 = RSAEncryptB64;\n"

/***/ },

/***/ 472:
/***/ function(module, exports) {

	module.exports = "// Depends on rsa.js and jsbn2.js\n\n// Version 1.1: support utf-8 decoding in pkcs1unpad2\n\n// Undo PKCS#1 (type 2, random) padding and, if valid, return the plaintext\nfunction pkcs1unpad2(d,n) {\n  var b = d.toByteArray();\n  var i = 0;\n  while(i < b.length && b[i] == 0) ++i;\n  if(b.length-i != n-1 || b[i] != 2)\n    return null;\n  ++i;\n  while(b[i] != 0)\n    if(++i >= b.length) return null;\n  var ret = \"\";\n  while(++i < b.length) {\n    var c = b[i] & 255;\n    if(c < 128) { // utf-8 decode\n      ret += String.fromCharCode(c);\n    }\n    else if((c > 191) && (c < 224)) {\n      ret += String.fromCharCode(((c & 31) << 6) | (b[i+1] & 63));\n      ++i;\n    }\n    else {\n      ret += String.fromCharCode(((c & 15) << 12) | ((b[i+1] & 63) << 6) | (b[i+2] & 63));\n      i += 2;\n    }\n  }\n  return ret;\n}\n\n// Set the private key fields N, e, and d from hex strings\nfunction RSASetPrivate(N,E,D) {\n  if(N != null && E != null && N.length > 0 && E.length > 0) {\n    this.n = parseBigInt(N,16);\n    this.e = parseInt(E,16);\n    this.d = parseBigInt(D,16);\n  }\n  else\n    alert(\"Invalid RSA private key\");\n}\n\n// Set the private key fields N, e, d and CRT params from hex strings\nfunction RSASetPrivateEx(N,E,D,P,Q,DP,DQ,C) {\n  if(N != null && E != null && N.length > 0 && E.length > 0) {\n    this.n = parseBigInt(N,16);\n    this.e = parseInt(E,16);\n    this.d = parseBigInt(D,16);\n    this.p = parseBigInt(P,16);\n    this.q = parseBigInt(Q,16);\n    this.dmp1 = parseBigInt(DP,16);\n    this.dmq1 = parseBigInt(DQ,16);\n    this.coeff = parseBigInt(C,16);\n  }\n  else\n    alert(\"Invalid RSA private key\");\n}\n\n// Generate a new random private key B bits long, using public expt E\nfunction RSAGenerate(B,E) {\n  var rng = new SecureRandom();\n  var qs = B>>1;\n  this.e = parseInt(E,16);\n  var ee = new BigInteger(E,16);\n  for(;;) {\n    for(;;) {\n      this.p = new BigInteger(B-qs,1,rng);\n      if(this.p.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.p.isProbablePrime(10)) break;\n    }\n    for(;;) {\n      this.q = new BigInteger(qs,1,rng);\n      if(this.q.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.q.isProbablePrime(10)) break;\n    }\n    if(this.p.compareTo(this.q) <= 0) {\n      var t = this.p;\n      this.p = this.q;\n      this.q = t;\n    }\n    var p1 = this.p.subtract(BigInteger.ONE);\n    var q1 = this.q.subtract(BigInteger.ONE);\n    var phi = p1.multiply(q1);\n    if(phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {\n      this.n = this.p.multiply(this.q);\n      this.d = ee.modInverse(phi);\n      this.dmp1 = this.d.mod(p1);\n      this.dmq1 = this.d.mod(q1);\n      this.coeff = this.q.modInverse(this.p);\n      break;\n    }\n  }\n}\n\n// Perform raw private operation on \"x\": return x^d (mod n)\nfunction RSADoPrivate(x) {\n  if(this.p == null || this.q == null)\n    return x.modPow(this.d, this.n);\n\n  // TODO: re-calculate any missing CRT params\n  var xp = x.mod(this.p).modPow(this.dmp1, this.p);\n  var xq = x.mod(this.q).modPow(this.dmq1, this.q);\n\n  while(xp.compareTo(xq) < 0)\n    xp = xp.add(this.p);\n  return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);\n}\n\n// Return the PKCS#1 RSA decryption of \"ctext\".\n// \"ctext\" is an even-length hex string and the output is a plain string.\nfunction RSADecrypt(ctext) {\n  var c = parseBigInt(ctext, 16);\n  var m = this.doPrivate(c);\n  if(m == null) return null;\n  return pkcs1unpad2(m, (this.n.bitLength()+7)>>3);\n}\n\n// Return the PKCS#1 RSA decryption of \"ctext\".\n// \"ctext\" is a Base64-encoded string and the output is a plain string.\n//function RSAB64Decrypt(ctext) {\n//  var h = b64tohex(ctext);\n//  if(h) return this.decrypt(h); else return null;\n//}\n\n// protected\nRSAKey.prototype.doPrivate = RSADoPrivate;\n\n// public\nRSAKey.prototype.setPrivate = RSASetPrivate;\nRSAKey.prototype.setPrivateEx = RSASetPrivateEx;\nRSAKey.prototype.generate = RSAGenerate;\nRSAKey.prototype.decrypt = RSADecrypt;\n//RSAKey.prototype.b64_decrypt = RSAB64Decrypt;\n"

/***/ },

/***/ 474:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)(__webpack_require__(467))

/***/ },

/***/ 475:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)(__webpack_require__(468))

/***/ },

/***/ 476:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)(__webpack_require__(469))

/***/ },

/***/ 477:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)(__webpack_require__(470))

/***/ },

/***/ 478:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)(__webpack_require__(471))

/***/ },

/***/ 479:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(42)(__webpack_require__(472))

/***/ },

/***/ 492:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {/* globals SYS_CONST, alert, RSAKey, WsStore, I18N_CONST */
	/* eslint-disable camelcase */
	
	__webpack_require__(1);
	
	var Components = __webpack_require__(155);
	var Handlebars = __webpack_require__(99);
	var TwoFactoryVerify = __webpack_require__(157);
	var QRCode = __webpack_require__(87);
	var io = __webpack_require__(95);
	var PollStore = __webpack_require__(158);
	var loginDeviceStore = __webpack_require__(156);
	var Cookie = __webpack_require__(32);
	var ConfirmBox = __webpack_require__(12);
	var Detector = __webpack_require__(50);
	
	__webpack_require__(159);
	
	__webpack_require__(474);
	__webpack_require__(475);
	__webpack_require__(476);
	__webpack_require__(477);
	__webpack_require__(478);
	__webpack_require__(479);
	
	// hardcode rsa加密解密必要条件
	var rsa_n = 'C4E3F7212602E1E396C0B6623CF11D26204ACE3E7D26685E037AD2507DCE82FC\n28F2D5F8A67FC3AFAB89A6D818D1F4C28CFA548418BD9F8E7426789A67E73E41';
	var rsa_e = '10001';
	var rsa_d = '7cd1745aec69096129b1f42da52ac9eae0afebbe0bc2ec89253598dcf454960e\n3e5e4ec9f8c87202b986601dd167253ee3fb3fa047e14f1dfd5ccd37e931b29d';
	var rsa_p ='f0e4dd1eac5622bd3932860fc749bbc48662edabdf3d2826059acc0251ac0d3b';
	var rsa_q = 'd13cb38fbcd06ee9bca330b4000b3dae5dae12b27e5173e4d888c325cda61ab3';
	var rsa_dmp1 = 'b3d5571197fc31b0eb6b4153b425e24c033b054d22b9c8282254fe69d8c8c593';
	var rsa_dmq1 = '968ffe89e50d7b72585a79b65cfdb9c1da0963cceb56c3759e57334de5a0ac3f';
	var rsa_coeff = 'd9bc4f420e93adad9f007d0e5744c2fe051c9ed9d3c9b65f439a18e13d6e3908';
	var rsa_password_prefix = 'password: ';
	
	var $loginForm;     // 登录表单元素
	var _$;             // $loginForm 下查询节点，具有缓存
	var __$;            // $loginForm 下查询节点，无缓存
	
	// 二次验证相关变量
	var secondAuthMeta = SYS_CONST.secondAuthMeta;
	var isUseSecondAuth = secondAuthMeta.sms || secondAuthMeta.dynamic1 || secondAuthMeta.dynamic2;
	var isNeedToBindSecondAuth = !(secondAuthMeta.config === 'none' || secondAuthMeta.config === 'custom');
	
	// 是否是 IE7 及 IE7 以下的低版本
	var isLowerVersion = Detector.isIE('7-');
	
	// 统一管理各cookie 名
	var cookieNames = {
	    uid:                'uid',                  // uid
	    saveUsername:       'saveUsername',         // 保存用户名
	    domain:             'domain',               // 邮箱域名
	    face:               'face',                 // 风格
	    locale:             'locale',               // 语言
	    netSpeedServerHost: 'netSpeedServerHost',   // 服务器加速
	    portinfo:           'portinfo'              // 端口
	};
	var cookieOptions = {expires : 30, path : '/'};
	
	window.SYS_CONST = window.SYS_CONST || {};
	
	initCDNCSSload();
	
	Components.blurBgImg();
	
	renderContent();
	
	initFormQueryHelpers();
	
	// 事件绑定
	//window.setTimeout(function(){
	//    initEventDelegate();
	//}, 50);
	initEventDelegate();
	
	initErrorMsg();
	// 获取天气情况
	initWeather();
	// Cookie 值自动填充
	autoFillCookieValue();
	
	// 低版本提示
	if (isLowerVersion) {
	    notifyLowVersionWarning(isUseSecondAuth ? I18N_CONST.msg_low_version_second_auth : I18N_CONST.msg_low_version);
	}
	
	$(document).customRadioCheckbox();
	
	function initCDNCSSload() {
	    if (SYS_CONST.imgCDN || false) {
	        $('body').addClass('cdn');
	    }
	}
	
	function notifyLowVersionWarning(message, callback) {
	    callback = callback || $.noop;
	
	    var title = I18N_CONST.msg_sys_info;
	    var handler = function () {
	        this.hide();
	        this.destroy();
	        callback();
	    };
	
	    new ConfirmBox({
	        parentNode: $('.main'),
	        title: title,
	        message: message,
	        confirmTpl: I18N_CONST.msg_low_version_confirm,
	        cancelTpl: false,
	        onConfirm: handler,
	        onCancel: handler
	    }).show();
	}
	
	function renderContent() {
	    var data = window.DATA || {};
	
	    // handlebar编译
	    // content部分
	    var template = Handlebars.compile($('#contentTpl').html());
	    var result = template(data);
	    $('.main .content').html(result);
	    // aside部分
	    var template2 = Handlebars.compile($('#asideTpl').html());
	    var result2 = template2(data);
	    $('.main .aside').html(result2);
	
	    if (isUseSecondAuth) {
	        TwoFactoryVerify.initVerify({
	            backObserver: function() {
	                submitWithoutLogin();
	                return false;
	            },
	            authData: SYS_CONST.secondAuthMeta,
	            $authWrap: $('.j-second-auth-wrap'),
	            $loginForm: $('.j-login-form')
	        });
	    }
	}
	
	/**
	 * 创建具有返回结果缓存效果的函数
	 *
	 * @param {function} fn 原始函数
	 * */
	function cached(fn) {
	    var cache = {};
	    return function cacheFn(str) {
	        var hit = cache[str];
	        return hit == null ? (cache[str] = fn(str)) : hit;
	    }
	}
	
	// 初始化表单元素以及相关的DOM 查询函数
	function initFormQueryHelpers() {
	    $loginForm = $('.j-login-form');
	
	    __$ = function queryUnderLoginForm(selector) {
	        return $loginForm.find(selector);
	    };
	
	    _$ = cached(__$);
	}
	
	// 触发登录表单提交
	function triggerLoginFormSubmit() {
	    $loginForm.submit();
	}
	
	function initEventDelegate () {
	    $('.loginArea').on('click', '[role="dropdown"]', function(evt) {
	        var menu = $(this).find('.u-menu');
	        if (!menu.hasClass('u-menu-show')) {
	            $('.u-menu').removeClass('u-menu-show').addClass('u-menu-hidden');
	        }
	        menu.toggleClass('u-menu-hidden u-menu-show');
	        evt.stopPropagation();
	    }).on('click', 'a[logintype]', function() {
	        var loginType = $(this).attr('logintype');
	        var container = $(this).closest('.loginArea');
	        var curLoginType = container.attr('curtype');
	        if (loginType !== curLoginType) {
	            container.toggleClass(curLoginType + ' ' +loginType)
	                    .attr('curtype', loginType)
	        }
	
	        if (loginType === 'QRCode' && SYS_CONST.appScanLogin.enable) {
	            createQRCode();
	            subscribeQRLoginMsg();
	        }
	    }).on('click', '.backToScan', function() {
	        updateQRLoginContainer('waitScan');
	    }).on('click', '.headImage i', function() {
	        // 重载页面
	        location.reload();
	    });
	
	    $('.u-menu').on('click', 'li', function(evt) {
	        var parentNode = $(this).closest('[role="dropdown"]');
	        parentNode.find('li .iconfont').remove();
	        $(this).addClass('u-menu-choose').append('<i class="iconfont iconchoose left"></i>');
	        if (parentNode.hasClass('locale')) { // 语言菜单
	            $('#locale').val($(this).data('locale'));
	            Cookie.set(cookieNames.locale, $(this).data('locale'), cookieOptions);
	            submitWithoutLogin();
	        } else if (parentNode.hasClass('faceMenu')) { // 风格菜单
	            _$('.faceTxt').html($(this).data('facetxt'));
	            _$('#faceName').val($(this).data('facetxt'));
	            _$('#face').val($(this).data('face'));
	        } else if (parentNode.hasClass('domainMenu')) { // 域名菜单
	            _$('.domainTxt').html($(this).data('domain'));
	            _$('#domain').val($(this).data('domain'));
	        }
	        $(this).closest('.u-menu').removeClass('u-menu-show').addClass('u-menu-hidden');
	        evt.stopPropagation();
	    });
	
	    $('[data-operation]').on('click', function () {
	        var operation = $(this).data('operation');
	        switch (operation) {
	        case 'addFavourite' :
	            try {
	                window.external.AddFavorite(location.href, document.title);
	                $(this).addClass('favourite');
	            } catch (e) {
	                try {
	                    window.sidebar.addPanel(location.href, document.title, '');
	                    $(this).addClass('favourite');
	                } catch (e) {
	                    alert($(this).data('msg'));
	                }
	            }
	            break;
	        case 'refresh' :
	            var imgObj = $('.securityCode img');
	            var url = imgObj.attr('src');
	            var rand = parseInt(Math.random()*100000000);
	            url = url.replace(/rand=-?\d*/, 'rand=' + rand);
	            imgObj.attr('src', url);
	            break;
	        case 'recoverPwdUrl' :
	            var pwdUrl = $(this).attr('href');
	            var uid = _$('#uid').val();
	            if (uid) {
	                var index = pwdUrl.indexOf('?');
	                if (index !== -1) {
	                    var hostPart = pwdUrl.substr(0, index);
	                    var paramPart = pwdUrl.substr(index + 1);
	                    var paramPartArr = paramPart.split('&');
	                    var newParamPart = ''; // 拼凑新的请求字符串
	                    var i ,str;
	                    for (i = 0; i < paramPartArr.length; i++) {
	                        str = paramPartArr[i];
	                        if (str.indexOf('uid') !== -1) {
	                            var arr = str.split('=');
	                            arr[1] = uid;
	                            newParamPart += arr[0] + '=' + arr[1] + '&';
	                        } else {
	                            newParamPart += str + '&';
	                        }
	                    }
	                    // 去掉最后的&
	                    newParamPart = newParamPart.substr(0, newParamPart.length - 1);
	                    $(this).attr('href', hostPart + '?' + newParamPart);
	                } else {
	                    pwdUrl += '?uid=' + uid;
	                    $(this).attr('href', pwdUrl);
	                }
	            }
	            break;
	        }
	    });
	
	    _$('.inputArea').on('focus', 'input', function () {
	        $(this).closest('.input-wrapper').prev().addClass('actived');
	    }).on('err.focus', 'input', function () {
	        $(this).trigger('focus');
	        $(this).closest('.input-wrapper').prev().addClass('error');
	        if ($(this).attr('id') === 'uid') {
	            $('.forPassword label').addClass('error');
	        }
	    }).on('blur', 'input', function () {
	        $(this).closest('.input-wrapper').prev().removeClass('error actived');
	    });
	
	    $(document).on('click', '[role!="dropdown"]', function() {
	        $('.u-menu').removeClass('u-menu-show').addClass('u-menu-hidden');
	    });
	
	    $('.j-ssl-login-button').on('click', function() {
	        var action = $loginForm.attr('action');
	        location.href = 'https://' + location.hostname + (location.port !== 80 ? ':' + location.port : '') + action.replace(/index.jsp.*/, 'index_ca.jsp');
	    });
	
	    // “登录”按钮点击
	    _$('.j-submit').on('click', function () {
	        preLogin(doLogin);
	    });
	
	    _$('#useSSL').on('change.crc', function() {
	        if ($(this).prop('disabled')) return;
	
	        setTimeout(function() {
	            preLogin(submitWithoutLogin);
	        }, 10);
	    });
	
	    // ie8/ie9 在登录页按回车会默认触发form的submit()，这里直接捕获回车
	    $loginForm.on('keypress', function (e) {
	        var keyCode = e.keyCode ? e.keyCode : e.which ? e.which : e.charCode;
	        if (keyCode === 13) {
	            _$('.j-submit').trigger('click');
	            return false;
	        } else { return true; }
	    });
	}
	
	function initWeather() {
	    $.ajax({
	        type: 'GET',
	        url: '/@context.name@/XT5/jsp/mail.jsp',
	        data: {func: 'getWeather'},
	        dataType: 'json',
	        success: function(data) {
	            if (data.code !== 'S_OK') {
	                return;
	            }
	            var status = data['var']['weather']['status'];
	            if (status === 'success') {
	                var weatherResults = data['var']['weather']['results'][0];
	                var currentCity = weatherResults['currentCity'];
	                var currentWeather = weatherResults['weather_data'][0];
	                var temperature = currentWeather['temperature'];
	                var dayPic = currentWeather['dayPictureUrl'];
	                var nightPic = currentWeather['nightPictureUrl'];
	
	                $('#weatherInfo').html(temperature + ' | ' + currentCity);
	                var weatherPic;
	                if (new Date().getHours() >= 18) {
	                    weatherPic = nightPic.substring(nightPic.lastIndexOf('/') + 1, nightPic.lastIndexOf('.'));
	                } else {
	                    weatherPic = dayPic.substring(dayPic.lastIndexOf('/') + 1, dayPic.lastIndexOf('.'));
	                }
	                $('#weatherPic').addClass('icon' + weatherPic);
	                $('#weather').show();
	            } else {
	                $('#weather').hide();
	            }
	        },
	        error: function() {
	            //$("#mainRight #weather").hide();
	        }
	    });
	}
	
	function autoFillCookieValue () {
	    var domain = Cookie.get(cookieNames.domain) || '';
	    var uid = Cookie.get(cookieNames.uid) || '';
	    if (domain.length > 0) {
	        // 选中cookie对应domain
	        _$('[data-domain="'+ domain +'"]').trigger('click');
	        uid = uid.split('@')[0];
	    }
	
	    if (uid.length > 0) {
	        _$('#uid').val(uid);
	    }
	
	    var saveUserName = Cookie.get(cookieNames.saveUsername) || '';
	    if (_$('#saveUsername').length) {
	        _$('#saveUsername').prop('checked', saveUserName === 'true');
	    }
	
	    var face = Cookie.get(cookieNames.face) || '';
	    if (face.length > 0) {
	        // 选中cookie对应的face
	        _$('[data-face="'+ face +'"]').trigger('click');
	    }
	
	    if (SYS_CONST.enablePasswordKey && SYS_CONST.encryptHash) {
	        var rsa = new RSAKey();
	        rsa.setPrivateEx(rsa_n, rsa_e, rsa_d, rsa_p, rsa_q, rsa_dmp1, rsa_dmq1, rsa_coeff);
	        var decodeHash = rsa.decrypt(SYS_CONST.encryptHash);
	        _$('#fakePassword').val(decodeHash.substr(rsa_password_prefix.length));
	    }
	}
	
	function initErrorMsg () {
	    var focusEleName = SYS_CONST.focusEleName,
	        empty_error = SYS_CONST.empty_error,
	        error_other = SYS_CONST.error_other;
	
	    var focusInp, $panel;
	
	    if (focusEleName === 'password' && SYS_CONST.enablePasswordKey) {
	        focusInp = _$('#fakePassword');
	    } else {
	        focusInp = _$('[name="'+ focusEleName +'"]');
	    }
	    if (focusInp.length !== 0) { // 输入框抖动
	        if (empty_error || error_other) {
	            // IE678用js实现抖动效果
	            focusInp.trigger('err.focus');
	            $panel = focusInp.parents('.u-form-item');
	            shakeInput($panel);
	        } else {
	            focusInp.trigger('focus');
	        }
	    }
	}
	
	/**
	 * CM-24043: 登录页路由功能
	 * 根据uid 以及lookup 配置，查询登录路由
	 *
	 * @param {function} err 查询失败回调
	 * @param {function} next 查询成功回调
	 * */
	function doDomainLookup(err, next) {
	    var lookupAction = SYS_CONST.lookupPath;
	    var lookupDomain = SYS_CONST.lookupDefaultDomain;
	
	    var $uid = _$('#uid');
	    var uid = $uid.val();
	    var fullUid = genUidWithDomain(uid);
	    var useSSL = _$('#useSSL').prop('checked') || false;
	
	    if (!$.isFunction(err)) err = $.noop;
	    if (!$.isFunction(next)) err = $.noop;
	
	    // path 配置不正确，跳过路由查询
	    if (typeof lookupAction !== 'string') return next();
	
	    // uid 为空，跳过路由查询
	    if (!fullUid.length) {
	        return next();
	    }
	
	    // 如果此时，uid 无域名后缀，则尝试从LookupDefaultDomain 中查找，如果都找不到，则报错
	    if (!checkUidWithDomain(fullUid)) {
	        if (lookupDomain.length) {
	            fullUid = uid + '@' + lookupDomain;
	        } else {
	            showInputError($uid);
	            shakeInput($uid);
	            showErrMsgInfo(SYS_CONST.loginErrIncompleteEmail);
	            return err(SYS_CONST.loginErrIncompleteEmail);
	        }
	    }
	
	    var resultMsg = null;
	    var rqData = {
	        'uid': fullUid,
	        'useSSL': useSSL,
	        'forAdmin': false,
	        'type': 'jsonp'
	    };
	
	    $.ajax({
	        url: lookupAction,
	        type: 'GET',
	        dataType: 'jsonp',
	        jsonp:'callback',
	        data: rqData,
	        timeout: 5000,
	        success:function(json) {
	            var url = json;
	            if (!url) {
	                showInputError($uid);
	                shakeInput($uid);
	                resultMsg = SYS_CONST.loginErrUnknownEmail;
	            } else if (url === 'LOAD_FAILED') {
	                resultMsg = SYS_CONST.loginErrLookupLoadFailed;
	            } else if (url.match(/^ERROR:/)) {
	                resultMsg = url.substring('ERROR:'.length);
	            }
	
	            if (resultMsg) {
	                showErrMsgInfo(resultMsg);
	                err(resultMsg);
	            } else {
	                // 这里遵从原来的实现，利用lookupCallback 来实现单层的路由查找
	                if (url.indexOf('?') !== -1) {
	                    url = url + '&lookupCallback=1';
	                } else {
	                    url = url + '?lookupCallback=1';
	                }
	                next(url);
	            }
	        },
	        error: function() {
	            resultMsg = 'Unknown error';
	            showErrMsgInfo(resultMsg);
	            err(resultMsg);
	        }
	    });
	}
	
	/**
	 * 预登录
	 *
	 * 这里主要是处理登录表单的输入参数
	 * */
	function preLogin(next) {
	    if ((isUseSecondAuth || isNeedToBindSecondAuth) && isLowerVersion) {
	        // 若用户启用了二次验证或系统需要强制绑定二次验证，低版本浏览器进行提示并取消登录过程
	        notifyLowVersionWarning(I18N_CONST.msg_low_version_second_auth);
	        return;
	    }
	
	    cleanErrMsgInfo();
	
	    next = next || $.noop;
	
	    var self = $loginForm;
	    var isWarning = false;
	    var useSSL = _$('#useSSL').prop('checked') || false;
	    var $face = _$('#face');
	    var face = $face.val();
	
	    /**
	     * RSA 密码处理
	     *
	     * @param {string} action 登录表单的action
	     * */
	    var formatPasswordKey = function(action) {
	        if (SYS_CONST.enablePasswordKey) {
	            var password = _$('#fakePassword').val();
	            var publicKey_e = SYS_CONST.publicKey_e;
	            var publicKey_n = SYS_CONST.publicKey_n;
	            var rsa;
	            if (password) {
	                rsa = new RSAKey();
	                rsa.setPublic(rsa_n, rsa_e);
	                var encryptHash = rsa.encrypt(rsa_password_prefix + password);
	                if (action.indexOf('?') === -1) {
	                    action += '?hash=' + encryptHash;
	                } else {
	                    action += '&hash=' + encryptHash;
	                }
	            }
	            // 使用wmsvr传递的公钥加密密码
	            if (publicKey_e && publicKey_n && password) {
	                rsa = new RSAKey();
	                rsa.setPublic(publicKey_n, publicKey_e);
	                // 加密后的密码填充至需要提交的密码框
	                _$('#password').val(rsa.encrypt(password));
	            }
	        }
	        return action;
	    };
	
	    /**
	     * 格式化表单action
	     * 根据是否勾选ssl 来更改action 的协议值
	     *
	     * @param {string} action 登录表单的action
	     * */
	    var formatFormAction = function(action) {
	        var srcProtocol = useSSL ? 'http://' : 'https://';
	        var dstProtocol = useSSL ? 'https://' : 'http://';
	
	        action = translateProtocol(action, srcProtocol, dstProtocol);
	        self.attr('action', action);
	    };
	
	    var loginAction = function() {
	        var formAction = self.attr('action');
	
	        // 允许更换服务器
	        // todo: 这里选择的服务器会被下面的路由所覆盖，需要确认
	        if (SYS_CONST.enableSpeedTest) {
	            var savedNetHost = Cookie.get(cookieNames.netSpeedServerHost);
	            if (savedNetHost) {
	                var netHostAction = location.protocol + '//' + savedNetHost;
	                if (location.pathname) {
	                    netHostAction += location.pathname;
	                }
	
	                formAction = netHostAction;
	            }
	        }
	
	        if (SYS_CONST.lookupPath) {
	            doDomainLookup(function(/*errMsg*/) {
	                return false;
	            }, function(url) {
	                if (typeof url === 'string' && url.length) {
	                    formAction = url;
	                }
	                formatFormAction(formatPasswordKey(formAction));
	                next();
	            });
	        } else {
	            formatFormAction(formatPasswordKey(formAction));
	            next();
	        }
	    };
	
	    if (face === 'auto') {
	        // IE7 以下强制使用 XT3
	        face = isLowerVersion ? 'XT3' : Cookie.get(cookieNames.face) || 'XT5';
	    }
	
	    if (face === 'XT5' && isLowerVersion) {
	        // 正常登录模式下，若选择了 XT5 则进行提示
	        notifyLowVersionWarning(I18N_CONST.msg_low_version, loginAction);
	        isWarning = true;
	
	        face = 'XT3';
	    }
	    $face.val(face);
	    Cookie.set(cookieNames.face, face, cookieOptions);
	
	    var $locale = _$('#locale');
	    if ($locale.length > 0) {
	        Cookie.set(cookieNames.locale, $locale.val(), cookieOptions);
	    }
	
	    var $uid = _$('#uid');
	    $uid.val(formatUid($uid.val()));
	
	    var saveUserName = _$('#saveUsername').length ? _$('#saveUsername').prop('checked') : false;
	    if (saveUserName) {
	        Cookie.set(cookieNames.saveUsername, true, cookieOptions);
	        Cookie.set(cookieNames.uid, genUidWithDomain($uid.val()), cookieOptions);
	        var $domain = _$('#domain');
	        if ($domain.length > 0) {
	            Cookie.set(cookieNames.domain, $domain.val(), cookieOptions);
	        }
	    } else {
	        Cookie.remove(cookieNames.saveUsername, {path : '/'});
	        Cookie.remove(cookieNames.uid, {path : '/'});
	    }
	
	    !isWarning && loginAction();
	}
	
	/**
	 * 最后触发登录事件前还允许做一些表单数据处理
	 * 这里建议进行非用户输入的数据处理
	 * */
	function doLogin() {
	    var $uid = _$('#uid');
	    var uid = $uid.val();
	    uid = genUidWithDomain(formatUid(uid));
	
	    (function collectLoginDeviceInfo() {
	        if (!SYS_CONST.supportAuthorizedDevice) return false;
	
	        // CM-24998 webmail 信任设备支持，从localStorage、cookie 格式化登录token 等信息
	        var tokenInfo = loginDeviceStore.formatLoginToken(uid);
	        if (tokenInfo != null) {
	            tokenInfo.token && _$('.j-access-token').val(tokenInfo.token);
	            tokenInfo.timestamp && _$('.j-timestamp').val(tokenInfo.timestamp);
	            tokenInfo.signature && _$('.j-signature').val(tokenInfo.signature);
	            tokenInfo.nonce && _$('.j-nonce').val(tokenInfo.nonce);
	        }
	
	        // CM-24998 webmail 信任设备支持，格式化设备信息
	        var deviceInfo = loginDeviceStore.formatLoginDeviceInfo();
	        if (deviceInfo != null) {
	            // 由于二次认证不需要兼容 IE6/IE7，因此此处不需要引入 jquery-json 或任何 JSON shim 来处理
	            _$('.j-device').val(JSON.stringify(deviceInfo));
	        }
	    }());
	
	    // 触发表单submit 事件
	    triggerLoginFormSubmit();
	}
	
	// 仅作提交，但不会触发登录操作，目的是根据当前表单参数刷新页面
	function submitWithoutLogin() {
	    _$('[name="action:login"]').remove();
	    triggerLoginFormSubmit();
	}
	
	/**
	 * 显示表单元素错误状态
	 *
	 * @param {jquery} $input 表单元素
	 * */
	function showInputError($input) {
	    if ($input == null || !$input.length) return false;
	    $input.focus().closest('.input-wrapper').prev().addClass('error');
	}
	
	/**
	 * 显示错误信息
	 *
	 * @param {string} resultMsg 错误信息
	 * */
	function showErrMsgInfo(resultMsg) {
	    _$('#warnOrErrDiv').removeClass('f-dn').addClass('errMsg').html(resultMsg);
	}
	
	/**
	 * 清除错误信息
	 * */
	function cleanErrMsgInfo() {
	    _$('#warnOrErrDiv').addClass('f-dn').removeClass('errMsg').html('');
	}
	
	/**
	 * 格式化uid，暂时做以下两步：
	 * 1. "。" ->"."
	 * 2. 清空 "@" 前后不必要的空格
	 *
	 * @param {string} uid 用户邮箱
	 * @return {string}
	 * */
	function formatUid(uid) {
	    if (typeof uid !== 'string' || !uid.length) {
	        return '';
	    }
	
	    var periodRegExp = new RegExp('\\s*' + String.fromCharCode(0x3002) + '\\s*', 'g');
	    return $.trim(uid.replace(/\s*@\s*/g, '@').replace(periodRegExp, '.'));
	}
	
	/**
	 * 尝试生成域名后缀的uid
	 * 如果uid 带后缀，直接返回
	 * 如果uid 不带后缀，尝试获取domain 列表的值
	 * 如果无domain 列表，则尝试查找默认域名
	 * 如果找不到默认域名，只好原值返回
	 *
	 * @param {string} uid
	 * @return {string}
	 * */
	function genUidWithDomain(uid) {
	    var $domain;
	    var domain;
	    var domainPos;
	
	    if (typeof uid !== 'string') uid = _$('#uid').val();
	    if (!uid.length) return '';
	
	    domainPos = uid.indexOf('@');
	    if (domainPos === -1) {
	        $domain = _$('#domain');
	        if ($domain.length && (domain = $domain.val())) {
	            uid = uid + '@' + domain;
	        } else if (SYS_CONST.primaryDomain != null && SYS_CONST.primaryDomain.length) {
	            uid = uid + '@' + SYS_CONST.primaryDomain;
	        }
	    }
	    return uid;
	}
	
	/**
	 * 检查uid 是否带域名后缀
	 *
	 * @param {string} uid
	 * @return {string}
	 * */
	function checkUidWithDomain(uid) {
	    if (typeof uid !== 'string') return false;
	    return (uid.indexOf('@')) > -1;
	}
	
	/**
	 * 转换url 的协议
	 *
	 * @param {string} url
	 * @param {string} srcProtocol 原协议
	 * @param {string} dstProtocol 目标协议
	 * return {string}
	 * */
	function translateProtocol(url, srcProtocol, dstProtocol) {
	    var port = location.port,
	        portinfo, // protocol,port
	        protocol;
	    // 记住当前非标准端口，切换http和https时可以加上
	    if (port !== '') {
	        Cookie.set(cookieNames.portinfo, location.protocol + ',' + port, {expires : 1, path : '/'});
	    }
	
	    // url = http(s)://host:port/...
	    // url = http(s)://host/...
	    // url = /...
	    if (url.charAt(0) === '/') {
	        // absolute location (but not absolute url)
	        if (location.protocol + '//' !== dstProtocol) {
	            port = '';
	            portinfo = Cookie.get(cookieNames.portinfo) || '';
	            protocol = portinfo.split(',')[0];
	
	            if (protocol + '//' === dstProtocol) {
	                port = portinfo.split(',')[1];
	            }
	            return dstProtocol + location.hostname + (port ? ':' + port : '') + url;
	        }
	        return url;
	    }
	    // TODO???: 不是很明白这里的用法，按照index.jsp的逻辑页面必然会出现转发，form action不会出现绝对地址的情况
	    if (url.substring(0, srcProtocol.length).toLowerCase() === srcProtocol) {
	        var pathStartAt = url.indexOf('/', srcProtocol.length);
	        var portStartAt = url.lastIndexOf(':', pathStartAt);
	        if (pathStartAt > 0 && portStartAt > 0
	            && url.substring(portStartAt + 1, pathStartAt).match(/^\d+$/)) {
	            // etc. translate (http://host:port/...) to (http://host/...)
	            return dstProtocol + url.substring(srcProtocol.length, portStartAt) + url.substring(pathStartAt);
	        } else {
	            // etc. translate (http://host/........) to (http://host/...)
	            return dstProtocol + url.substring(srcProtocol.length);
	        }
	    }
	
	    return url;
	}
	
	/**
	 * 摇晃表单元素
	 *
	 * @param {object} inp 需要摇晃的元素，jquery 类型DOM 集合
	 * */
	function shakeInput (inp) {
	    var $panel = inp.parents('.u-form-item');
	    if (!$.support.leadingWhitespace) {
	        var offset = $panel.offset() - $panel.width();
	        var x = offset.left;
	        var y = offset.top;
	        for (var i = 1; i <= 5; i++) {
	            if (i % 2 === 0) {
	                $panel.animate({left: '+6px'}, 80);
	            } else {
	                $panel.animate({left: '-6px'}, 80);
	            }
	        }
	        $panel.animate({left: 0}, 150);
	        $panel.offset({top: y, left: x});
	    } else {
	        $panel.addClass('animated shake');
	    }
	}
	
	// 生成扫码登录二维码
	function createQRCode() {
	    var container = $('.QRCodeImage .wrapper');
	    if (container.children().length === 0) {
	        new QRCode(container[0], {
	            text: genQRScanUrl(SYS_CONST.appScanLogin.tempSession), // 二维码内容
	            width: 100,
	            height: 100,
	            colorDark : '#000000',
	            colorLight : '#ffffff',
	            correctLevel : QRCode.CorrectLevel.H
	        });
	    }
	}
	
	// 扫码登录消息订阅
	function subscribeQRLoginMsg() {
	    var pollUrl = '../getProcessStatus.jsp?sid=' + SYS_CONST.appScanLogin.tempSession;
	    var socketTopic = 'onstat/mail/$sid$/op_app_qrcode_login'
	            .replace('$sid$', SYS_CONST.appScanLogin.tempSession);
	    var container = $('.QRCodeImage');
	    var poll = container.data('poll');
	    // 低版本浏览器只是用轮询方式
	    // 高版本浏览器推送和轮询并存，当推送有返回结果时，停止轮询
	    if (!poll) {
	        poll = new PollStore({
	            topic: pollUrl,
	            successCallback: _pollSuccessCallback,
	            errorCallback: _pollErrorCallback
	        }).subscribe();
	
	        if ('WebSocket' in window) {
	            WsStore.subscribe(socketTopic, _socketSuccessCallback, {
	                io: io,
	                host: SYS_CONST.appScanLogin.host,
	                authMeta: {
	                    'sid': SYS_CONST.appScanLogin.tempSession,
	                    'TmpSes': 1,
	                    'ClientId': 'webmail:' + SYS_CONST.appScanLogin.tempSession
	                }
	            });
	        }
	        container.data('poll', poll);
	    }
	
	    function _socketSuccessCallback(result) {
	        poll && poll.unSubscribe();
	        _pollSuccessCallback(result);
	    }
	
	    function _pollSuccessCallback(result) {
	        var payload = result.payload || {};
	        updateQRLoginContainer(payload.status);
	
	        if (payload.status === 'appVerify') {
	            _setUserAvatar(payload.avatar, payload.gender);
	            _setLoggedUsername(payload.trueName, payload.email);
	        }
	
	        if (payload.status === 'final') {
	            poll && poll.unSubscribe();
	            WsStore && WsStore.unSubscribe();
	            // 延迟跳转
	            setTimeout(function() {
	                location.href = genLoginRedirectUrl(payload.sid, payload.cookiecheck);
	            }, 500);
	        }
	    }
	
	    function _pollErrorCallback(data) {
	        data = data || {};
	        if (data.code === 'FA_INVALID_SESSION') {
	            updateQRLoginContainer('loginFail');
	        }
	    }
	
	    // 设置用户头像
	    function _setUserAvatar(avatar, gender) {
	        gender = gender || '0';
	        var defaultUrl = 'assets/@project.revision@/images/' + (gender === '0' ? 'man.png' : 'woman.png');
	        $('.headImage img').attr('src', avatar || defaultUrl);
	    }
	
	    // 设置已登录用户的trueName/email
	    function _setLoggedUsername(trueName, email) {
	        $('.headImageArea .loggedUsername').html(trueName || email);
	    }
	}
	
	// 更新二维码登录容器
	function updateQRLoginContainer(className) {
	    if (!className) {
	        return false;
	    }
	    $('.j-qr-code-login').attr('curstatus', function(i, val) {
	        val = val || '';
	        if (val !== className) {
	            $(this).toggleClass(val + ' ' + className);
	            return className;
	        }
	        return val;
	    });
	}
	
	function genUrlPrefix() {
	    return [location.protocol, '//', location.host, '/@context.name@/'].join('');
	}
	
	function genQRScanUrl(sid) {
	    return [genUrlPrefix(), 'qr/', sid].join('');
	}
	
	function genLoginRedirectUrl(sid, cookiecheck) {
	    return [genUrlPrefix(), 'XT5/index.jsp?sid=', sid, '&Cookie.Coremail=', cookiecheck].join('');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }

});


/** WEBPACK FOOTER **
 ** cmxt50.7e1a9.js
 **/